webpackJsonp(["pages.projects.commit.show"],{

/***/ "../../../node_modules/deckar01-task_list/dist/task_list.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["TaskList"] = factory();
	else
		root["TaskList"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var NodeArray, TaskList, closest, createEvent,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

NodeArray = function(nodeList) {
  return Array.prototype.slice.apply(nodeList);
};

closest = function(el, className) {
  while (el && !el.classList.contains(className)) {
    el = el.parentNode;
  }
  return el;
};

createEvent = function(eventName, detail) {
  var event;
  if (typeof Event === 'function') {
    event = new Event(eventName, {
      bubbles: true,
      cancelable: true
    });
    event.detail = detail;
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, true, true, detail);
  }
  return event;
};

TaskList = (function() {
  function TaskList(el1) {
    this.el = el1;
    this.container = closest(this.el, 'js-task-list-container');
    this.field = this.container.querySelector('.js-task-list-field');
    this.container.addEventListener('change', (function(_this) {
      return function(event) {
        if (event.target.classList.contains('task-list-item-checkbox')) {
          return _this.updateTaskList(event.target);
        }
      };
    })(this));
    this.enable();
  }

  TaskList.prototype.enable = function() {
    var event;
    if (this.container.querySelectorAll('.js-task-list-field').length > 0) {
      NodeArray(this.container.querySelectorAll('.task-list-item')).forEach(function(item) {
        return item.classList.add('enabled');
      });
      NodeArray(this.container.querySelectorAll('.task-list-item-checkbox')).forEach(function(checkbox) {
        return checkbox.disabled = false;
      });
      this.container.classList.add('is-task-list-enabled');
      event = createEvent('tasklist:enabled');
      return this.container.dispatchEvent(event);
    }
  };

  TaskList.prototype.disable = function() {
    var event;
    NodeArray(this.container.querySelectorAll('.task-list-item')).forEach(function(item) {
      return item.classList.remove('enabled');
    });
    NodeArray(this.container.querySelectorAll('.task-list-item-checkbox')).forEach(function(checkbox) {
      return checkbox.disabled = true;
    });
    this.container.classList.remove('is-task-list-enabled');
    event = createEvent('tasklist:disabled');
    return this.container.dispatchEvent(event);
  };

  TaskList.prototype.updateTaskList = function(item) {
    var changeEvent, changedEvent, checkboxes, index;
    checkboxes = this.container.querySelectorAll('.task-list-item-checkbox');
    index = 1 + NodeArray(checkboxes).indexOf(item);
    changeEvent = createEvent('tasklist:change', {
      index: index,
      checked: item.checked
    });
    this.field.dispatchEvent(changeEvent);
    if (!changeEvent.defaultPrevented) {
      this.field.value = TaskList.updateSource(this.field.value, index, item.checked);
      changeEvent = createEvent('change');
      this.field.dispatchEvent(changeEvent);
      changedEvent = createEvent('tasklist:changed', {
        index: index,
        checked: item.checked
      });
      return this.field.dispatchEvent(changedEvent);
    }
  };

  TaskList.incomplete = "[ ]";

  TaskList.complete = "[x]";

  TaskList.escapePattern = function(str) {
    return str.replace(/([\[\]])/g, "\\$1").replace(/\s/, "\\s").replace("x", "[xX]");
  };

  TaskList.incompletePattern = RegExp("" + (TaskList.escapePattern(TaskList.incomplete)));

  TaskList.completePattern = RegExp("" + (TaskList.escapePattern(TaskList.complete)));

  TaskList.itemPattern = RegExp("^(?:\\s*(?:>\\s*)*(?:[-+*]|(?:\\d+\\.)))\\s*(" + (TaskList.escapePattern(TaskList.complete)) + "|" + (TaskList.escapePattern(TaskList.incomplete)) + ")\\s+(?!\\(.*?\\))(?=(?:\\[.*?\\]\\s*(?:\\[.*?\\]|\\(.*?\\))\\s*)*(?:[^\\[]|$))");

  TaskList.startFencesPattern = /^`{3}.*$/;

  TaskList.endFencesPattern = /^`{3}$/;

  TaskList.itemsInParasPattern = RegExp("^(" + (TaskList.escapePattern(TaskList.complete)) + "|" + (TaskList.escapePattern(TaskList.incomplete)) + ").+$", "g");

  TaskList.updateSource = function(source, itemIndex, checked) {
    var clean, inCodeBlock, index, line, result;
    clean = source.replace(/\r/g, '').replace(this.itemsInParasPattern, '').split("\n");
    index = 0;
    inCodeBlock = false;
    result = (function() {
      var i, len, ref, results;
      ref = source.split("\n");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        line = ref[i];
        if (inCodeBlock) {
          if (line.match(this.endFencesPattern)) {
            inCodeBlock = false;
          }
        } else if (line.match(this.startFencesPattern)) {
          inCodeBlock = true;
        } else if (indexOf.call(clean, line) >= 0 && line.match(this.itemPattern)) {
          index += 1;
          if (index === itemIndex) {
            line = checked ? line.replace(this.incompletePattern, this.complete) : line.replace(this.completePattern, this.incomplete);
          }
        }
        results.push(line);
      }
      return results;
    }).call(this);
    return result.join("\n");
  };

  return TaskList;

})();

if (typeof jQuery !== 'undefined') {
  jQuery.fn.taskList = function(method) {
    return this.each(function(index, el) {
      var taskList;
      taskList = jQuery(el).data('task-list');
      if (!taskList) {
        taskList = new TaskList(el);
        jQuery(el).data('task-list', taskList);
        if (!method || method === 'enable') {
          return;
        }
      }
      return taskList[method || 'enable']();
    });
  };
}

module.exports = TaskList;


/***/ })
/******/ ]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "../../../node_modules/dropzone/dist/dropzone.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery, module) {
/*
 *
 * More info at [www.dropzonejs.com](http://www.dropzonejs.com)
 *
 * Copyright (c) 2012, Matias Meno
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 */

(function() {
  var Dropzone, Emitter, camelize, contentLoaded, detectVerticalSquash, drawImageIOSFix, noop, without,
    __slice = [].slice,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  noop = function() {};

  Emitter = (function() {
    function Emitter() {}

    Emitter.prototype.addEventListener = Emitter.prototype.on;

    Emitter.prototype.on = function(event, fn) {
      this._callbacks = this._callbacks || {};
      if (!this._callbacks[event]) {
        this._callbacks[event] = [];
      }
      this._callbacks[event].push(fn);
      return this;
    };

    Emitter.prototype.emit = function() {
      var args, callback, callbacks, event, _i, _len;
      event = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      this._callbacks = this._callbacks || {};
      callbacks = this._callbacks[event];
      if (callbacks) {
        for (_i = 0, _len = callbacks.length; _i < _len; _i++) {
          callback = callbacks[_i];
          callback.apply(this, args);
        }
      }
      return this;
    };

    Emitter.prototype.removeListener = Emitter.prototype.off;

    Emitter.prototype.removeAllListeners = Emitter.prototype.off;

    Emitter.prototype.removeEventListener = Emitter.prototype.off;

    Emitter.prototype.off = function(event, fn) {
      var callback, callbacks, i, _i, _len;
      if (!this._callbacks || arguments.length === 0) {
        this._callbacks = {};
        return this;
      }
      callbacks = this._callbacks[event];
      if (!callbacks) {
        return this;
      }
      if (arguments.length === 1) {
        delete this._callbacks[event];
        return this;
      }
      for (i = _i = 0, _len = callbacks.length; _i < _len; i = ++_i) {
        callback = callbacks[i];
        if (callback === fn) {
          callbacks.splice(i, 1);
          break;
        }
      }
      return this;
    };

    return Emitter;

  })();

  Dropzone = (function(_super) {
    var extend, resolveOption;

    __extends(Dropzone, _super);

    Dropzone.prototype.Emitter = Emitter;


    /*
    This is a list of all available events you can register on a dropzone object.
    
    You can register an event handler like this:
    
        dropzone.on("dragEnter", function() { });
     */

    Dropzone.prototype.events = ["drop", "dragstart", "dragend", "dragenter", "dragover", "dragleave", "addedfile", "addedfiles", "removedfile", "thumbnail", "error", "errormultiple", "processing", "processingmultiple", "uploadprogress", "totaluploadprogress", "sending", "sendingmultiple", "success", "successmultiple", "canceled", "canceledmultiple", "complete", "completemultiple", "reset", "maxfilesexceeded", "maxfilesreached", "queuecomplete"];

    Dropzone.prototype.defaultOptions = {
      url: null,
      method: "post",
      withCredentials: false,
      parallelUploads: 2,
      uploadMultiple: false,
      maxFilesize: 256,
      paramName: "file",
      createImageThumbnails: true,
      maxThumbnailFilesize: 10,
      thumbnailWidth: 120,
      thumbnailHeight: 120,
      filesizeBase: 1000,
      maxFiles: null,
      params: {},
      clickable: true,
      ignoreHiddenFiles: true,
      acceptedFiles: null,
      acceptedMimeTypes: null,
      autoProcessQueue: true,
      autoQueue: true,
      addRemoveLinks: false,
      previewsContainer: null,
      hiddenInputContainer: "body",
      capture: null,
      dictDefaultMessage: "Drop files here to upload",
      dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
      dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
      dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
      dictInvalidFileType: "You can't upload files of this type.",
      dictResponseError: "Server responded with {{statusCode}} code.",
      dictCancelUpload: "Cancel upload",
      dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
      dictRemoveFile: "Remove file",
      dictRemoveFileConfirmation: null,
      dictMaxFilesExceeded: "You can not upload any more files.",
      accept: function(file, done) {
        return done();
      },
      init: function() {
        return noop;
      },
      forceFallback: false,
      fallback: function() {
        var child, messageElement, span, _i, _len, _ref;
        this.element.className = "" + this.element.className + " dz-browser-not-supported";
        _ref = this.element.getElementsByTagName("div");
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          child = _ref[_i];
          if (/(^| )dz-message($| )/.test(child.className)) {
            messageElement = child;
            child.className = "dz-message";
            continue;
          }
        }
        if (!messageElement) {
          messageElement = Dropzone.createElement("<div class=\"dz-message\"><span></span></div>");
          this.element.appendChild(messageElement);
        }
        span = messageElement.getElementsByTagName("span")[0];
        if (span) {
          if (span.textContent != null) {
            span.textContent = this.options.dictFallbackMessage;
          } else if (span.innerText != null) {
            span.innerText = this.options.dictFallbackMessage;
          }
        }
        return this.element.appendChild(this.getFallbackForm());
      },
      resize: function(file) {
        var info, srcRatio, trgRatio;
        info = {
          srcX: 0,
          srcY: 0,
          srcWidth: file.width,
          srcHeight: file.height
        };
        srcRatio = file.width / file.height;
        info.optWidth = this.options.thumbnailWidth;
        info.optHeight = this.options.thumbnailHeight;
        if ((info.optWidth == null) && (info.optHeight == null)) {
          info.optWidth = info.srcWidth;
          info.optHeight = info.srcHeight;
        } else if (info.optWidth == null) {
          info.optWidth = srcRatio * info.optHeight;
        } else if (info.optHeight == null) {
          info.optHeight = (1 / srcRatio) * info.optWidth;
        }
        trgRatio = info.optWidth / info.optHeight;
        if (file.height < info.optHeight || file.width < info.optWidth) {
          info.trgHeight = info.srcHeight;
          info.trgWidth = info.srcWidth;
        } else {
          if (srcRatio > trgRatio) {
            info.srcHeight = file.height;
            info.srcWidth = info.srcHeight * trgRatio;
          } else {
            info.srcWidth = file.width;
            info.srcHeight = info.srcWidth / trgRatio;
          }
        }
        info.srcX = (file.width - info.srcWidth) / 2;
        info.srcY = (file.height - info.srcHeight) / 2;
        return info;
      },

      /*
      Those functions register themselves to the events on init and handle all
      the user interface specific stuff. Overwriting them won't break the upload
      but can break the way it's displayed.
      You can overwrite them if you don't like the default behavior. If you just
      want to add an additional event handler, register it on the dropzone object
      and don't overwrite those options.
       */
      drop: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      dragstart: noop,
      dragend: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      dragenter: function(e) {
        return this.element.classList.add("dz-drag-hover");
      },
      dragover: function(e) {
        return this.element.classList.add("dz-drag-hover");
      },
      dragleave: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      paste: noop,
      reset: function() {
        return this.element.classList.remove("dz-started");
      },
      addedfile: function(file) {
        var node, removeFileEvent, removeLink, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2, _results;
        if (this.element === this.previewsContainer) {
          this.element.classList.add("dz-started");
        }
        if (this.previewsContainer) {
          file.previewElement = Dropzone.createElement(this.options.previewTemplate.trim());
          file.previewTemplate = file.previewElement;
          this.previewsContainer.appendChild(file.previewElement);
          _ref = file.previewElement.querySelectorAll("[data-dz-name]");
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            node.textContent = file.name;
          }
          _ref1 = file.previewElement.querySelectorAll("[data-dz-size]");
          for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
            node = _ref1[_j];
            node.innerHTML = this.filesize(file.size);
          }
          if (this.options.addRemoveLinks) {
            file._removeLink = Dropzone.createElement("<a class=\"dz-remove\" href=\"javascript:undefined;\" data-dz-remove>" + this.options.dictRemoveFile + "</a>");
            file.previewElement.appendChild(file._removeLink);
          }
          removeFileEvent = (function(_this) {
            return function(e) {
              e.preventDefault();
              e.stopPropagation();
              if (file.status === Dropzone.UPLOADING) {
                return Dropzone.confirm(_this.options.dictCancelUploadConfirmation, function() {
                  return _this.removeFile(file);
                });
              } else {
                if (_this.options.dictRemoveFileConfirmation) {
                  return Dropzone.confirm(_this.options.dictRemoveFileConfirmation, function() {
                    return _this.removeFile(file);
                  });
                } else {
                  return _this.removeFile(file);
                }
              }
            };
          })(this);
          _ref2 = file.previewElement.querySelectorAll("[data-dz-remove]");
          _results = [];
          for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
            removeLink = _ref2[_k];
            _results.push(removeLink.addEventListener("click", removeFileEvent));
          }
          return _results;
        }
      },
      removedfile: function(file) {
        var _ref;
        if (file.previewElement) {
          if ((_ref = file.previewElement) != null) {
            _ref.parentNode.removeChild(file.previewElement);
          }
        }
        return this._updateMaxFilesReachedClass();
      },
      thumbnail: function(file, dataUrl) {
        var thumbnailElement, _i, _len, _ref;
        if (file.previewElement) {
          file.previewElement.classList.remove("dz-file-preview");
          _ref = file.previewElement.querySelectorAll("[data-dz-thumbnail]");
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            thumbnailElement = _ref[_i];
            thumbnailElement.alt = file.name;
            thumbnailElement.src = dataUrl;
          }
          return setTimeout(((function(_this) {
            return function() {
              return file.previewElement.classList.add("dz-image-preview");
            };
          })(this)), 1);
        }
      },
      error: function(file, message) {
        var node, _i, _len, _ref, _results;
        if (file.previewElement) {
          file.previewElement.classList.add("dz-error");
          if (typeof message !== "String" && message.error) {
            message = message.error;
          }
          _ref = file.previewElement.querySelectorAll("[data-dz-errormessage]");
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            _results.push(node.textContent = message);
          }
          return _results;
        }
      },
      errormultiple: noop,
      processing: function(file) {
        if (file.previewElement) {
          file.previewElement.classList.add("dz-processing");
          if (file._removeLink) {
            return file._removeLink.textContent = this.options.dictCancelUpload;
          }
        }
      },
      processingmultiple: noop,
      uploadprogress: function(file, progress, bytesSent) {
        var node, _i, _len, _ref, _results;
        if (file.previewElement) {
          _ref = file.previewElement.querySelectorAll("[data-dz-uploadprogress]");
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            if (node.nodeName === 'PROGRESS') {
              _results.push(node.value = progress);
            } else {
              _results.push(node.style.width = "" + progress + "%");
            }
          }
          return _results;
        }
      },
      totaluploadprogress: noop,
      sending: noop,
      sendingmultiple: noop,
      success: function(file) {
        if (file.previewElement) {
          return file.previewElement.classList.add("dz-success");
        }
      },
      successmultiple: noop,
      canceled: function(file) {
        return this.emit("error", file, "Upload canceled.");
      },
      canceledmultiple: noop,
      complete: function(file) {
        if (file._removeLink) {
          file._removeLink.textContent = this.options.dictRemoveFile;
        }
        if (file.previewElement) {
          return file.previewElement.classList.add("dz-complete");
        }
      },
      completemultiple: noop,
      maxfilesexceeded: noop,
      maxfilesreached: noop,
      queuecomplete: noop,
      addedfiles: noop,
      previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail /></div>\n  <div class=\"dz-details\">\n    <div class=\"dz-size\"><span data-dz-size></span></div>\n    <div class=\"dz-filename\"><span data-dz-name></span></div>\n  </div>\n  <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Check</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <path d=\"M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" stroke-opacity=\"0.198794158\" stroke=\"#747474\" fill-opacity=\"0.816519475\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"></path>\n      </g>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Error</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"Check-+-Oval-2\" sketch:type=\"MSLayerGroup\" stroke=\"#747474\" stroke-opacity=\"0.198794158\" fill=\"#FFFFFF\" fill-opacity=\"0.816519475\">\n          <path d=\"M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" sketch:type=\"MSShapeGroup\"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>"
    };

    extend = function() {
      var key, object, objects, target, val, _i, _len;
      target = arguments[0], objects = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      for (_i = 0, _len = objects.length; _i < _len; _i++) {
        object = objects[_i];
        for (key in object) {
          val = object[key];
          target[key] = val;
        }
      }
      return target;
    };

    function Dropzone(element, options) {
      var elementOptions, fallback, _ref;
      this.element = element;
      this.version = Dropzone.version;
      this.defaultOptions.previewTemplate = this.defaultOptions.previewTemplate.replace(/\n*/g, "");
      this.clickableElements = [];
      this.listeners = [];
      this.files = [];
      if (typeof this.element === "string") {
        this.element = document.querySelector(this.element);
      }
      if (!(this.element && (this.element.nodeType != null))) {
        throw new Error("Invalid dropzone element.");
      }
      if (this.element.dropzone) {
        throw new Error("Dropzone already attached.");
      }
      Dropzone.instances.push(this);
      this.element.dropzone = this;
      elementOptions = (_ref = Dropzone.optionsForElement(this.element)) != null ? _ref : {};
      this.options = extend({}, this.defaultOptions, elementOptions, options != null ? options : {});
      if (this.options.forceFallback || !Dropzone.isBrowserSupported()) {
        return this.options.fallback.call(this);
      }
      if (this.options.url == null) {
        this.options.url = this.element.getAttribute("action");
      }
      if (!this.options.url) {
        throw new Error("No URL provided.");
      }
      if (this.options.acceptedFiles && this.options.acceptedMimeTypes) {
        throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
      }
      if (this.options.acceptedMimeTypes) {
        this.options.acceptedFiles = this.options.acceptedMimeTypes;
        delete this.options.acceptedMimeTypes;
      }
      this.options.method = this.options.method.toUpperCase();
      if ((fallback = this.getExistingFallback()) && fallback.parentNode) {
        fallback.parentNode.removeChild(fallback);
      }
      if (this.options.previewsContainer !== false) {
        if (this.options.previewsContainer) {
          this.previewsContainer = Dropzone.getElement(this.options.previewsContainer, "previewsContainer");
        } else {
          this.previewsContainer = this.element;
        }
      }
      if (this.options.clickable) {
        if (this.options.clickable === true) {
          this.clickableElements = [this.element];
        } else {
          this.clickableElements = Dropzone.getElements(this.options.clickable, "clickable");
        }
      }
      this.init();
    }

    Dropzone.prototype.getAcceptedFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.accepted) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getRejectedFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (!file.accepted) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getFilesWithStatus = function(status) {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status === status) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getQueuedFiles = function() {
      return this.getFilesWithStatus(Dropzone.QUEUED);
    };

    Dropzone.prototype.getUploadingFiles = function() {
      return this.getFilesWithStatus(Dropzone.UPLOADING);
    };

    Dropzone.prototype.getAddedFiles = function() {
      return this.getFilesWithStatus(Dropzone.ADDED);
    };

    Dropzone.prototype.getActiveFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status === Dropzone.UPLOADING || file.status === Dropzone.QUEUED) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.init = function() {
      var eventName, noPropagation, setupHiddenFileInput, _i, _len, _ref, _ref1;
      if (this.element.tagName === "form") {
        this.element.setAttribute("enctype", "multipart/form-data");
      }
      if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) {
        this.element.appendChild(Dropzone.createElement("<div class=\"dz-default dz-message\"><span>" + this.options.dictDefaultMessage + "</span></div>"));
      }
      if (this.clickableElements.length) {
        setupHiddenFileInput = (function(_this) {
          return function() {
            if (_this.hiddenFileInput) {
              _this.hiddenFileInput.parentNode.removeChild(_this.hiddenFileInput);
            }
            _this.hiddenFileInput = document.createElement("input");
            _this.hiddenFileInput.setAttribute("type", "file");
            if ((_this.options.maxFiles == null) || _this.options.maxFiles > 1) {
              _this.hiddenFileInput.setAttribute("multiple", "multiple");
            }
            _this.hiddenFileInput.className = "dz-hidden-input";
            if (_this.options.acceptedFiles != null) {
              _this.hiddenFileInput.setAttribute("accept", _this.options.acceptedFiles);
            }
            if (_this.options.capture != null) {
              _this.hiddenFileInput.setAttribute("capture", _this.options.capture);
            }
            _this.hiddenFileInput.style.visibility = "hidden";
            _this.hiddenFileInput.style.position = "absolute";
            _this.hiddenFileInput.style.top = "0";
            _this.hiddenFileInput.style.left = "0";
            _this.hiddenFileInput.style.height = "0";
            _this.hiddenFileInput.style.width = "0";
            document.querySelector(_this.options.hiddenInputContainer).appendChild(_this.hiddenFileInput);
            return _this.hiddenFileInput.addEventListener("change", function() {
              var file, files, _i, _len;
              files = _this.hiddenFileInput.files;
              if (files.length) {
                for (_i = 0, _len = files.length; _i < _len; _i++) {
                  file = files[_i];
                  _this.addFile(file);
                }
              }
              _this.emit("addedfiles", files);
              return setupHiddenFileInput();
            });
          };
        })(this);
        setupHiddenFileInput();
      }
      this.URL = (_ref = window.URL) != null ? _ref : window.webkitURL;
      _ref1 = this.events;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        eventName = _ref1[_i];
        this.on(eventName, this.options[eventName]);
      }
      this.on("uploadprogress", (function(_this) {
        return function() {
          return _this.updateTotalUploadProgress();
        };
      })(this));
      this.on("removedfile", (function(_this) {
        return function() {
          return _this.updateTotalUploadProgress();
        };
      })(this));
      this.on("canceled", (function(_this) {
        return function(file) {
          return _this.emit("complete", file);
        };
      })(this));
      this.on("complete", (function(_this) {
        return function(file) {
          if (_this.getAddedFiles().length === 0 && _this.getUploadingFiles().length === 0 && _this.getQueuedFiles().length === 0) {
            return setTimeout((function() {
              return _this.emit("queuecomplete");
            }), 0);
          }
        };
      })(this));
      noPropagation = function(e) {
        e.stopPropagation();
        if (e.preventDefault) {
          return e.preventDefault();
        } else {
          return e.returnValue = false;
        }
      };
      this.listeners = [
        {
          element: this.element,
          events: {
            "dragstart": (function(_this) {
              return function(e) {
                return _this.emit("dragstart", e);
              };
            })(this),
            "dragenter": (function(_this) {
              return function(e) {
                noPropagation(e);
                return _this.emit("dragenter", e);
              };
            })(this),
            "dragover": (function(_this) {
              return function(e) {
                var efct;
                try {
                  efct = e.dataTransfer.effectAllowed;
                } catch (_error) {}
                e.dataTransfer.dropEffect = 'move' === efct || 'linkMove' === efct ? 'move' : 'copy';
                noPropagation(e);
                return _this.emit("dragover", e);
              };
            })(this),
            "dragleave": (function(_this) {
              return function(e) {
                return _this.emit("dragleave", e);
              };
            })(this),
            "drop": (function(_this) {
              return function(e) {
                noPropagation(e);
                return _this.drop(e);
              };
            })(this),
            "dragend": (function(_this) {
              return function(e) {
                return _this.emit("dragend", e);
              };
            })(this)
          }
        }
      ];
      this.clickableElements.forEach((function(_this) {
        return function(clickableElement) {
          return _this.listeners.push({
            element: clickableElement,
            events: {
              "click": function(evt) {
                if ((clickableElement !== _this.element) || (evt.target === _this.element || Dropzone.elementInside(evt.target, _this.element.querySelector(".dz-message")))) {
                  _this.hiddenFileInput.click();
                }
                return true;
              }
            }
          });
        };
      })(this));
      this.enable();
      return this.options.init.call(this);
    };

    Dropzone.prototype.destroy = function() {
      var _ref;
      this.disable();
      this.removeAllFiles(true);
      if ((_ref = this.hiddenFileInput) != null ? _ref.parentNode : void 0) {
        this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
        this.hiddenFileInput = null;
      }
      delete this.element.dropzone;
      return Dropzone.instances.splice(Dropzone.instances.indexOf(this), 1);
    };

    Dropzone.prototype.updateTotalUploadProgress = function() {
      var activeFiles, file, totalBytes, totalBytesSent, totalUploadProgress, _i, _len, _ref;
      totalBytesSent = 0;
      totalBytes = 0;
      activeFiles = this.getActiveFiles();
      if (activeFiles.length) {
        _ref = this.getActiveFiles();
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          file = _ref[_i];
          totalBytesSent += file.upload.bytesSent;
          totalBytes += file.upload.total;
        }
        totalUploadProgress = 100 * totalBytesSent / totalBytes;
      } else {
        totalUploadProgress = 100;
      }
      return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
    };

    Dropzone.prototype._getParamName = function(n) {
      if (typeof this.options.paramName === "function") {
        return this.options.paramName(n);
      } else {
        return "" + this.options.paramName + (this.options.uploadMultiple ? "[" + n + "]" : "");
      }
    };

    Dropzone.prototype.getFallbackForm = function() {
      var existingFallback, fields, fieldsString, form;
      if (existingFallback = this.getExistingFallback()) {
        return existingFallback;
      }
      fieldsString = "<div class=\"dz-fallback\">";
      if (this.options.dictFallbackText) {
        fieldsString += "<p>" + this.options.dictFallbackText + "</p>";
      }
      fieldsString += "<input type=\"file\" name=\"" + (this._getParamName(0)) + "\" " + (this.options.uploadMultiple ? 'multiple="multiple"' : void 0) + " /><input type=\"submit\" value=\"Upload!\"></div>";
      fields = Dropzone.createElement(fieldsString);
      if (this.element.tagName !== "FORM") {
        form = Dropzone.createElement("<form action=\"" + this.options.url + "\" enctype=\"multipart/form-data\" method=\"" + this.options.method + "\"></form>");
        form.appendChild(fields);
      } else {
        this.element.setAttribute("enctype", "multipart/form-data");
        this.element.setAttribute("method", this.options.method);
      }
      return form != null ? form : fields;
    };

    Dropzone.prototype.getExistingFallback = function() {
      var fallback, getFallback, tagName, _i, _len, _ref;
      getFallback = function(elements) {
        var el, _i, _len;
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
          el = elements[_i];
          if (/(^| )fallback($| )/.test(el.className)) {
            return el;
          }
        }
      };
      _ref = ["div", "form"];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        tagName = _ref[_i];
        if (fallback = getFallback(this.element.getElementsByTagName(tagName))) {
          return fallback;
        }
      }
    };

    Dropzone.prototype.setupEventListeners = function() {
      var elementListeners, event, listener, _i, _len, _ref, _results;
      _ref = this.listeners;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elementListeners = _ref[_i];
        _results.push((function() {
          var _ref1, _results1;
          _ref1 = elementListeners.events;
          _results1 = [];
          for (event in _ref1) {
            listener = _ref1[event];
            _results1.push(elementListeners.element.addEventListener(event, listener, false));
          }
          return _results1;
        })());
      }
      return _results;
    };

    Dropzone.prototype.removeEventListeners = function() {
      var elementListeners, event, listener, _i, _len, _ref, _results;
      _ref = this.listeners;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elementListeners = _ref[_i];
        _results.push((function() {
          var _ref1, _results1;
          _ref1 = elementListeners.events;
          _results1 = [];
          for (event in _ref1) {
            listener = _ref1[event];
            _results1.push(elementListeners.element.removeEventListener(event, listener, false));
          }
          return _results1;
        })());
      }
      return _results;
    };

    Dropzone.prototype.disable = function() {
      var file, _i, _len, _ref, _results;
      this.clickableElements.forEach(function(element) {
        return element.classList.remove("dz-clickable");
      });
      this.removeEventListeners();
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        _results.push(this.cancelUpload(file));
      }
      return _results;
    };

    Dropzone.prototype.enable = function() {
      this.clickableElements.forEach(function(element) {
        return element.classList.add("dz-clickable");
      });
      return this.setupEventListeners();
    };

    Dropzone.prototype.filesize = function(size) {
      var cutoff, i, selectedSize, selectedUnit, unit, units, _i, _len;
      selectedSize = 0;
      selectedUnit = "b";
      if (size > 0) {
        units = ['TB', 'GB', 'MB', 'KB', 'b'];
        for (i = _i = 0, _len = units.length; _i < _len; i = ++_i) {
          unit = units[i];
          cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;
          if (size >= cutoff) {
            selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
            selectedUnit = unit;
            break;
          }
        }
        selectedSize = Math.round(10 * selectedSize) / 10;
      }
      return "<strong>" + selectedSize + "</strong> " + selectedUnit;
    };

    Dropzone.prototype._updateMaxFilesReachedClass = function() {
      if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
        if (this.getAcceptedFiles().length === this.options.maxFiles) {
          this.emit('maxfilesreached', this.files);
        }
        return this.element.classList.add("dz-max-files-reached");
      } else {
        return this.element.classList.remove("dz-max-files-reached");
      }
    };

    Dropzone.prototype.drop = function(e) {
      var files, items;
      if (!e.dataTransfer) {
        return;
      }
      this.emit("drop", e);
      files = e.dataTransfer.files;
      this.emit("addedfiles", files);
      if (files.length) {
        items = e.dataTransfer.items;
        if (items && items.length && (items[0].webkitGetAsEntry != null)) {
          this._addFilesFromItems(items);
        } else {
          this.handleFiles(files);
        }
      }
    };

    Dropzone.prototype.paste = function(e) {
      var items, _ref;
      if ((e != null ? (_ref = e.clipboardData) != null ? _ref.items : void 0 : void 0) == null) {
        return;
      }
      this.emit("paste", e);
      items = e.clipboardData.items;
      if (items.length) {
        return this._addFilesFromItems(items);
      }
    };

    Dropzone.prototype.handleFiles = function(files) {
      var file, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        _results.push(this.addFile(file));
      }
      return _results;
    };

    Dropzone.prototype._addFilesFromItems = function(items) {
      var entry, item, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = items.length; _i < _len; _i++) {
        item = items[_i];
        if ((item.webkitGetAsEntry != null) && (entry = item.webkitGetAsEntry())) {
          if (entry.isFile) {
            _results.push(this.addFile(item.getAsFile()));
          } else if (entry.isDirectory) {
            _results.push(this._addFilesFromDirectory(entry, entry.name));
          } else {
            _results.push(void 0);
          }
        } else if (item.getAsFile != null) {
          if ((item.kind == null) || item.kind === "file") {
            _results.push(this.addFile(item.getAsFile()));
          } else {
            _results.push(void 0);
          }
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };

    Dropzone.prototype._addFilesFromDirectory = function(directory, path) {
      var dirReader, entriesReader;
      dirReader = directory.createReader();
      entriesReader = (function(_this) {
        return function(entries) {
          var entry, _i, _len;
          for (_i = 0, _len = entries.length; _i < _len; _i++) {
            entry = entries[_i];
            if (entry.isFile) {
              entry.file(function(file) {
                if (_this.options.ignoreHiddenFiles && file.name.substring(0, 1) === '.') {
                  return;
                }
                file.fullPath = "" + path + "/" + file.name;
                return _this.addFile(file);
              });
            } else if (entry.isDirectory) {
              _this._addFilesFromDirectory(entry, "" + path + "/" + entry.name);
            }
          }
        };
      })(this);
      return dirReader.readEntries(entriesReader, function(error) {
        return typeof console !== "undefined" && console !== null ? typeof console.log === "function" ? console.log(error) : void 0 : void 0;
      });
    };

    Dropzone.prototype.accept = function(file, done) {
      if (file.size > this.options.maxFilesize * 1024 * 1024) {
        return done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
      } else if (!Dropzone.isValidFile(file, this.options.acceptedFiles)) {
        return done(this.options.dictInvalidFileType);
      } else if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
        done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
        return this.emit("maxfilesexceeded", file);
      } else {
        return this.options.accept.call(this, file, done);
      }
    };

    Dropzone.prototype.addFile = function(file) {
      file.upload = {
        progress: 0,
        total: file.size,
        bytesSent: 0
      };
      this.files.push(file);
      file.status = Dropzone.ADDED;
      this.emit("addedfile", file);
      this._enqueueThumbnail(file);
      return this.accept(file, (function(_this) {
        return function(error) {
          if (error) {
            file.accepted = false;
            _this._errorProcessing([file], error);
          } else {
            file.accepted = true;
            if (_this.options.autoQueue) {
              _this.enqueueFile(file);
            }
          }
          return _this._updateMaxFilesReachedClass();
        };
      })(this));
    };

    Dropzone.prototype.enqueueFiles = function(files) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        this.enqueueFile(file);
      }
      return null;
    };

    Dropzone.prototype.enqueueFile = function(file) {
      if (file.status === Dropzone.ADDED && file.accepted === true) {
        file.status = Dropzone.QUEUED;
        if (this.options.autoProcessQueue) {
          return setTimeout(((function(_this) {
            return function() {
              return _this.processQueue();
            };
          })(this)), 0);
        }
      } else {
        throw new Error("This file can't be queued because it has already been processed or was rejected.");
      }
    };

    Dropzone.prototype._thumbnailQueue = [];

    Dropzone.prototype._processingThumbnail = false;

    Dropzone.prototype._enqueueThumbnail = function(file) {
      if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1024 * 1024) {
        this._thumbnailQueue.push(file);
        return setTimeout(((function(_this) {
          return function() {
            return _this._processThumbnailQueue();
          };
        })(this)), 0);
      }
    };

    Dropzone.prototype._processThumbnailQueue = function() {
      if (this._processingThumbnail || this._thumbnailQueue.length === 0) {
        return;
      }
      this._processingThumbnail = true;
      return this.createThumbnail(this._thumbnailQueue.shift(), (function(_this) {
        return function() {
          _this._processingThumbnail = false;
          return _this._processThumbnailQueue();
        };
      })(this));
    };

    Dropzone.prototype.removeFile = function(file) {
      if (file.status === Dropzone.UPLOADING) {
        this.cancelUpload(file);
      }
      this.files = without(this.files, file);
      this.emit("removedfile", file);
      if (this.files.length === 0) {
        return this.emit("reset");
      }
    };

    Dropzone.prototype.removeAllFiles = function(cancelIfNecessary) {
      var file, _i, _len, _ref;
      if (cancelIfNecessary == null) {
        cancelIfNecessary = false;
      }
      _ref = this.files.slice();
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status !== Dropzone.UPLOADING || cancelIfNecessary) {
          this.removeFile(file);
        }
      }
      return null;
    };

    Dropzone.prototype.createThumbnail = function(file, callback) {
      var fileReader;
      fileReader = new FileReader;
      fileReader.onload = (function(_this) {
        return function() {
          if (file.type === "image/svg+xml") {
            _this.emit("thumbnail", file, fileReader.result);
            if (callback != null) {
              callback();
            }
            return;
          }
          return _this.createThumbnailFromUrl(file, fileReader.result, callback);
        };
      })(this);
      return fileReader.readAsDataURL(file);
    };

    Dropzone.prototype.createThumbnailFromUrl = function(file, imageUrl, callback, crossOrigin) {
      var img;
      img = document.createElement("img");
      if (crossOrigin) {
        img.crossOrigin = crossOrigin;
      }
      img.onload = (function(_this) {
        return function() {
          var canvas, ctx, resizeInfo, thumbnail, _ref, _ref1, _ref2, _ref3;
          file.width = img.width;
          file.height = img.height;
          resizeInfo = _this.options.resize.call(_this, file);
          if (resizeInfo.trgWidth == null) {
            resizeInfo.trgWidth = resizeInfo.optWidth;
          }
          if (resizeInfo.trgHeight == null) {
            resizeInfo.trgHeight = resizeInfo.optHeight;
          }
          canvas = document.createElement("canvas");
          ctx = canvas.getContext("2d");
          canvas.width = resizeInfo.trgWidth;
          canvas.height = resizeInfo.trgHeight;
          drawImageIOSFix(ctx, img, (_ref = resizeInfo.srcX) != null ? _ref : 0, (_ref1 = resizeInfo.srcY) != null ? _ref1 : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, (_ref2 = resizeInfo.trgX) != null ? _ref2 : 0, (_ref3 = resizeInfo.trgY) != null ? _ref3 : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);
          thumbnail = canvas.toDataURL("image/png");
          _this.emit("thumbnail", file, thumbnail);
          if (callback != null) {
            return callback();
          }
        };
      })(this);
      if (callback != null) {
        img.onerror = callback;
      }
      return img.src = imageUrl;
    };

    Dropzone.prototype.processQueue = function() {
      var i, parallelUploads, processingLength, queuedFiles;
      parallelUploads = this.options.parallelUploads;
      processingLength = this.getUploadingFiles().length;
      i = processingLength;
      if (processingLength >= parallelUploads) {
        return;
      }
      queuedFiles = this.getQueuedFiles();
      if (!(queuedFiles.length > 0)) {
        return;
      }
      if (this.options.uploadMultiple) {
        return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
      } else {
        while (i < parallelUploads) {
          if (!queuedFiles.length) {
            return;
          }
          this.processFile(queuedFiles.shift());
          i++;
        }
      }
    };

    Dropzone.prototype.processFile = function(file) {
      return this.processFiles([file]);
    };

    Dropzone.prototype.processFiles = function(files) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.processing = true;
        file.status = Dropzone.UPLOADING;
        this.emit("processing", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("processingmultiple", files);
      }
      return this.uploadFiles(files);
    };

    Dropzone.prototype._getFilesWithXhr = function(xhr) {
      var file, files;
      return files = (function() {
        var _i, _len, _ref, _results;
        _ref = this.files;
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          file = _ref[_i];
          if (file.xhr === xhr) {
            _results.push(file);
          }
        }
        return _results;
      }).call(this);
    };

    Dropzone.prototype.cancelUpload = function(file) {
      var groupedFile, groupedFiles, _i, _j, _len, _len1, _ref;
      if (file.status === Dropzone.UPLOADING) {
        groupedFiles = this._getFilesWithXhr(file.xhr);
        for (_i = 0, _len = groupedFiles.length; _i < _len; _i++) {
          groupedFile = groupedFiles[_i];
          groupedFile.status = Dropzone.CANCELED;
        }
        file.xhr.abort();
        for (_j = 0, _len1 = groupedFiles.length; _j < _len1; _j++) {
          groupedFile = groupedFiles[_j];
          this.emit("canceled", groupedFile);
        }
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", groupedFiles);
        }
      } else if ((_ref = file.status) === Dropzone.ADDED || _ref === Dropzone.QUEUED) {
        file.status = Dropzone.CANCELED;
        this.emit("canceled", file);
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", [file]);
        }
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    resolveOption = function() {
      var args, option;
      option = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      if (typeof option === 'function') {
        return option.apply(this, args);
      }
      return option;
    };

    Dropzone.prototype.uploadFile = function(file) {
      return this.uploadFiles([file]);
    };

    Dropzone.prototype.uploadFiles = function(files) {
      var file, formData, handleError, headerName, headerValue, headers, i, input, inputName, inputType, key, method, option, progressObj, response, updateProgress, url, value, xhr, _i, _j, _k, _l, _len, _len1, _len2, _len3, _m, _ref, _ref1, _ref2, _ref3, _ref4, _ref5;
      xhr = new XMLHttpRequest();
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.xhr = xhr;
      }
      method = resolveOption(this.options.method, files);
      url = resolveOption(this.options.url, files);
      xhr.open(method, url, true);
      xhr.withCredentials = !!this.options.withCredentials;
      response = null;
      handleError = (function(_this) {
        return function() {
          var _j, _len1, _results;
          _results = [];
          for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
            file = files[_j];
            _results.push(_this._errorProcessing(files, response || _this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr));
          }
          return _results;
        };
      })(this);
      updateProgress = (function(_this) {
        return function(e) {
          var allFilesFinished, progress, _j, _k, _l, _len1, _len2, _len3, _results;
          if (e != null) {
            progress = 100 * e.loaded / e.total;
            for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
              file = files[_j];
              file.upload = {
                progress: progress,
                total: e.total,
                bytesSent: e.loaded
              };
            }
          } else {
            allFilesFinished = true;
            progress = 100;
            for (_k = 0, _len2 = files.length; _k < _len2; _k++) {
              file = files[_k];
              if (!(file.upload.progress === 100 && file.upload.bytesSent === file.upload.total)) {
                allFilesFinished = false;
              }
              file.upload.progress = progress;
              file.upload.bytesSent = file.upload.total;
            }
            if (allFilesFinished) {
              return;
            }
          }
          _results = [];
          for (_l = 0, _len3 = files.length; _l < _len3; _l++) {
            file = files[_l];
            _results.push(_this.emit("uploadprogress", file, progress, file.upload.bytesSent));
          }
          return _results;
        };
      })(this);
      xhr.onload = (function(_this) {
        return function(e) {
          var _ref;
          if (files[0].status === Dropzone.CANCELED) {
            return;
          }
          if (xhr.readyState !== 4) {
            return;
          }
          response = xhr.responseText;
          if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) {
            try {
              response = JSON.parse(response);
            } catch (_error) {
              e = _error;
              response = "Invalid JSON response from server.";
            }
          }
          updateProgress();
          if (!((200 <= (_ref = xhr.status) && _ref < 300))) {
            return handleError();
          } else {
            return _this._finished(files, response, e);
          }
        };
      })(this);
      xhr.onerror = (function(_this) {
        return function() {
          if (files[0].status === Dropzone.CANCELED) {
            return;
          }
          return handleError();
        };
      })(this);
      progressObj = (_ref = xhr.upload) != null ? _ref : xhr;
      progressObj.onprogress = updateProgress;
      headers = {
        "Accept": "application/json",
        "Cache-Control": "no-cache",
        "X-Requested-With": "XMLHttpRequest"
      };
      if (this.options.headers) {
        extend(headers, this.options.headers);
      }
      for (headerName in headers) {
        headerValue = headers[headerName];
        if (headerValue) {
          xhr.setRequestHeader(headerName, headerValue);
        }
      }
      formData = new FormData();
      if (this.options.params) {
        _ref1 = this.options.params;
        for (key in _ref1) {
          value = _ref1[key];
          formData.append(key, value);
        }
      }
      for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
        file = files[_j];
        this.emit("sending", file, xhr, formData);
      }
      if (this.options.uploadMultiple) {
        this.emit("sendingmultiple", files, xhr, formData);
      }
      if (this.element.tagName === "FORM") {
        _ref2 = this.element.querySelectorAll("input, textarea, select, button");
        for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
          input = _ref2[_k];
          inputName = input.getAttribute("name");
          inputType = input.getAttribute("type");
          if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
            _ref3 = input.options;
            for (_l = 0, _len3 = _ref3.length; _l < _len3; _l++) {
              option = _ref3[_l];
              if (option.selected) {
                formData.append(inputName, option.value);
              }
            }
          } else if (!inputType || ((_ref4 = inputType.toLowerCase()) !== "checkbox" && _ref4 !== "radio") || input.checked) {
            formData.append(inputName, input.value);
          }
        }
      }
      for (i = _m = 0, _ref5 = files.length - 1; 0 <= _ref5 ? _m <= _ref5 : _m >= _ref5; i = 0 <= _ref5 ? ++_m : --_m) {
        formData.append(this._getParamName(i), files[i], files[i].name);
      }
      return this.submitRequest(xhr, formData, files);
    };

    Dropzone.prototype.submitRequest = function(xhr, formData, files) {
      return xhr.send(formData);
    };

    Dropzone.prototype._finished = function(files, responseText, e) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.status = Dropzone.SUCCESS;
        this.emit("success", file, responseText, e);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("successmultiple", files, responseText, e);
        this.emit("completemultiple", files);
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    Dropzone.prototype._errorProcessing = function(files, message, xhr) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.status = Dropzone.ERROR;
        this.emit("error", file, message, xhr);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("errormultiple", files, message, xhr);
        this.emit("completemultiple", files);
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    return Dropzone;

  })(Emitter);

  Dropzone.version = "4.2.0";

  Dropzone.options = {};

  Dropzone.optionsForElement = function(element) {
    if (element.getAttribute("id")) {
      return Dropzone.options[camelize(element.getAttribute("id"))];
    } else {
      return void 0;
    }
  };

  Dropzone.instances = [];

  Dropzone.forElement = function(element) {
    if (typeof element === "string") {
      element = document.querySelector(element);
    }
    if ((element != null ? element.dropzone : void 0) == null) {
      throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
    }
    return element.dropzone;
  };

  Dropzone.autoDiscover = true;

  Dropzone.discover = function() {
    var checkElements, dropzone, dropzones, _i, _len, _results;
    if (document.querySelectorAll) {
      dropzones = document.querySelectorAll(".dropzone");
    } else {
      dropzones = [];
      checkElements = function(elements) {
        var el, _i, _len, _results;
        _results = [];
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
          el = elements[_i];
          if (/(^| )dropzone($| )/.test(el.className)) {
            _results.push(dropzones.push(el));
          } else {
            _results.push(void 0);
          }
        }
        return _results;
      };
      checkElements(document.getElementsByTagName("div"));
      checkElements(document.getElementsByTagName("form"));
    }
    _results = [];
    for (_i = 0, _len = dropzones.length; _i < _len; _i++) {
      dropzone = dropzones[_i];
      if (Dropzone.optionsForElement(dropzone) !== false) {
        _results.push(new Dropzone(dropzone));
      } else {
        _results.push(void 0);
      }
    }
    return _results;
  };

  Dropzone.blacklistedBrowsers = [/opera.*Macintosh.*version\/12/i];

  Dropzone.isBrowserSupported = function() {
    var capableBrowser, regex, _i, _len, _ref;
    capableBrowser = true;
    if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
      if (!("classList" in document.createElement("a"))) {
        capableBrowser = false;
      } else {
        _ref = Dropzone.blacklistedBrowsers;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          regex = _ref[_i];
          if (regex.test(navigator.userAgent)) {
            capableBrowser = false;
            continue;
          }
        }
      }
    } else {
      capableBrowser = false;
    }
    return capableBrowser;
  };

  without = function(list, rejectedItem) {
    var item, _i, _len, _results;
    _results = [];
    for (_i = 0, _len = list.length; _i < _len; _i++) {
      item = list[_i];
      if (item !== rejectedItem) {
        _results.push(item);
      }
    }
    return _results;
  };

  camelize = function(str) {
    return str.replace(/[\-_](\w)/g, function(match) {
      return match.charAt(1).toUpperCase();
    });
  };

  Dropzone.createElement = function(string) {
    var div;
    div = document.createElement("div");
    div.innerHTML = string;
    return div.childNodes[0];
  };

  Dropzone.elementInside = function(element, container) {
    if (element === container) {
      return true;
    }
    while (element = element.parentNode) {
      if (element === container) {
        return true;
      }
    }
    return false;
  };

  Dropzone.getElement = function(el, name) {
    var element;
    if (typeof el === "string") {
      element = document.querySelector(el);
    } else if (el.nodeType != null) {
      element = el;
    }
    if (element == null) {
      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector or a plain HTML element.");
    }
    return element;
  };

  Dropzone.getElements = function(els, name) {
    var e, el, elements, _i, _j, _len, _len1, _ref;
    if (els instanceof Array) {
      elements = [];
      try {
        for (_i = 0, _len = els.length; _i < _len; _i++) {
          el = els[_i];
          elements.push(this.getElement(el, name));
        }
      } catch (_error) {
        e = _error;
        elements = null;
      }
    } else if (typeof els === "string") {
      elements = [];
      _ref = document.querySelectorAll(els);
      for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
        el = _ref[_j];
        elements.push(el);
      }
    } else if (els.nodeType != null) {
      elements = [els];
    }
    if (!((elements != null) && elements.length)) {
      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");
    }
    return elements;
  };

  Dropzone.confirm = function(question, accepted, rejected) {
    if (window.confirm(question)) {
      return accepted();
    } else if (rejected != null) {
      return rejected();
    }
  };

  Dropzone.isValidFile = function(file, acceptedFiles) {
    var baseMimeType, mimeType, validType, _i, _len;
    if (!acceptedFiles) {
      return true;
    }
    acceptedFiles = acceptedFiles.split(",");
    mimeType = file.type;
    baseMimeType = mimeType.replace(/\/.*$/, "");
    for (_i = 0, _len = acceptedFiles.length; _i < _len; _i++) {
      validType = acceptedFiles[_i];
      validType = validType.trim();
      if (validType.charAt(0) === ".") {
        if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) {
          return true;
        }
      } else if (/\/\*$/.test(validType)) {
        if (baseMimeType === validType.replace(/\/.*$/, "")) {
          return true;
        }
      } else {
        if (mimeType === validType) {
          return true;
        }
      }
    }
    return false;
  };

  if (typeof jQuery !== "undefined" && jQuery !== null) {
    jQuery.fn.dropzone = function(options) {
      return this.each(function() {
        return new Dropzone(this, options);
      });
    };
  }

  if (typeof module !== "undefined" && module !== null) {
    module.exports = Dropzone;
  } else {
    window.Dropzone = Dropzone;
  }

  Dropzone.ADDED = "added";

  Dropzone.QUEUED = "queued";

  Dropzone.ACCEPTED = Dropzone.QUEUED;

  Dropzone.UPLOADING = "uploading";

  Dropzone.PROCESSING = Dropzone.UPLOADING;

  Dropzone.CANCELED = "canceled";

  Dropzone.ERROR = "error";

  Dropzone.SUCCESS = "success";


  /*
  
  Bugfix for iOS 6 and 7
  Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
  based on the work of https://github.com/stomita/ios-imagefile-megapixel
   */

  detectVerticalSquash = function(img) {
    var alpha, canvas, ctx, data, ey, ih, iw, py, ratio, sy;
    iw = img.naturalWidth;
    ih = img.naturalHeight;
    canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = ih;
    ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    data = ctx.getImageData(0, 0, 1, ih).data;
    sy = 0;
    ey = ih;
    py = ih;
    while (py > sy) {
      alpha = data[(py - 1) * 4 + 3];
      if (alpha === 0) {
        ey = py;
      } else {
        sy = py;
      }
      py = (ey + sy) >> 1;
    }
    ratio = py / ih;
    if (ratio === 0) {
      return 1;
    } else {
      return ratio;
    }
  };

  drawImageIOSFix = function(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
    var vertSquashRatio;
    vertSquashRatio = detectVerticalSquash(img);
    return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
  };


  /*
   * contentloaded.js
   *
   * Author: Diego Perini (diego.perini at gmail.com)
   * Summary: cross-browser wrapper for DOMContentLoaded
   * Updated: 20101020
   * License: MIT
   * Version: 1.2
   *
   * URL:
   * http://javascript.nwbox.com/ContentLoaded/
   * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
   */

  contentLoaded = function(win, fn) {
    var add, doc, done, init, poll, pre, rem, root, top;
    done = false;
    top = true;
    doc = win.document;
    root = doc.documentElement;
    add = (doc.addEventListener ? "addEventListener" : "attachEvent");
    rem = (doc.addEventListener ? "removeEventListener" : "detachEvent");
    pre = (doc.addEventListener ? "" : "on");
    init = function(e) {
      if (e.type === "readystatechange" && doc.readyState !== "complete") {
        return;
      }
      (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
      if (!done && (done = true)) {
        return fn.call(win, e.type || e);
      }
    };
    poll = function() {
      var e;
      try {
        root.doScroll("left");
      } catch (_error) {
        e = _error;
        setTimeout(poll, 50);
        return;
      }
      return init("poll");
    };
    if (doc.readyState !== "complete") {
      if (doc.createEventObject && root.doScroll) {
        try {
          top = !win.frameElement;
        } catch (_error) {}
        if (top) {
          poll();
        }
      }
      doc[add](pre + "DOMContentLoaded", init, false);
      doc[add](pre + "readystatechange", init, false);
      return win[add](pre + "load", init, false);
    }
  };

  Dropzone._autoDiscoverFunction = function() {
    if (Dropzone.autoDiscover) {
      return Dropzone.discover();
    }
  };

  contentLoaded(window, Dropzone._autoDiscoverFunction);

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js"), __webpack_require__("../../../node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "../../../node_modules/mousetrap/plugins/pause/mousetrap-pause.js":
/***/ (function(module, exports) {

/**
 * adds a pause and unpause method to Mousetrap
 * this allows you to enable or disable keyboard shortcuts
 * without having to reset Mousetrap and rebind everything
 */
/* global Mousetrap:true */
Mousetrap = (function(Mousetrap) {
    var self = Mousetrap,
        _originalStopCallback = self.stopCallback,
        enabled = true;

    self.stopCallback = function(e, element, combo) {
        if (!enabled) {
            return true;
        }

        return _originalStopCallback(e, element, combo);
    };

    self.pause = function() {
        enabled = false;
    };

    self.unpause = function() {
        enabled = true;
    };

    return self;
}) (Mousetrap);


/***/ }),

/***/ "../../../node_modules/webpack/buildin/module.js":
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "../images/no_avatar.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAAAAAAdJSU2AAACNElEQVR4AdXYBa7jMBCA4b3/JZahzIkjp2qt+BWUWnG5ln2XxaJJb2b5F2ukL4wvzK/rP7bUcbf92u6oftLSe1ldk8efsfaVeEjusZZeC6e1RllaCk/yG6ag1lZ4WwPX69uyD6tAe/g2ipAlNMRS37awDLaFrpcMWxXQOi0jnWCWjFkSZomYJWDWKmatYNZyEWkJsvQimoZYah5NgdaLxagCtF6GRy0DshZPkeYwS/KIJWGWYjwYUzDLxCwDtJ54OKglimBLqHWahii2g1pmHLLGBmwVoRjcKlmgOdw65H5qKuGWCVi5Qlhs6m1sENZi4q3AWNvca5UYy2RjT/SAsiZey6CsIvc0wVlV5lJ0ibPMyLUGCmlxQq0IM0hLdWyro7CWEc3sXsqaK4O2zLxOsmtpfW5Q1u68ZrVmepaaNXEewawtI9X5Xl3U3n1qND6+rfPzvqoIWz/fklNCSLY153YV53J/XUxGCJnKZ1lajsn3/Ffegf6Y5pV2LUsSNL2UHzxUfh3TlYpZqqTpXZm0KZk9zJcqaEmaWPHDw0pxe05K7bWOLHFLWXVetqpYmrjle4+1y0aBaF4UOQ1NU+lYezJClkjLUnSEjqhH6zjAW4OjtY39Ibq+sawUb6W2RQfoqG0VeKuwrRJvlba17faRdbe2pTtYq6Nty/S7yAbGsQjWIq41wVoT1+IdZNy1djUcVdu5lklQWC0xHkt1X31qNEE1Pr3qKv/9XiSNj6Aaifj3/69+AYujsR/MvkpZAAAAAElFTkSuQmCC"

/***/ }),

/***/ "./autosave.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__ = __webpack_require__("./lib/utils/accessor.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-param-reassign, prefer-template, no-var, no-void, consistent-return */



var Autosave = function () {
  function Autosave(field, key) {
    var _this = this;

    _classCallCheck(this, Autosave);

    this.field = field;

    this.isLocalStorageAvailable = __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__["a" /* default */].isLocalStorageAccessSafe();
    if (key.join != null) {
      key = key.join('/');
    }
    this.key = 'autosave/' + key;
    this.field.data('autosave', this);
    this.restore();
    this.field.on('input', function () {
      return _this.save();
    });
  }

  _createClass(Autosave, [{
    key: 'restore',
    value: function restore() {
      if (!this.isLocalStorageAvailable) return;
      if (!this.field.length) return;

      var text = window.localStorage.getItem(this.key);

      if ((text != null ? text.length : void 0) > 0) {
        this.field.val(text);
      }

      this.field.trigger('input');
      // v-model does not update with jQuery trigger
      // https://github.com/vuejs/vue/issues/2804#issuecomment-216968137
      var event = new Event('change', { bubbles: true, cancelable: false });
      var field = this.field.get(0);
      field.dispatchEvent(event);
    }
  }, {
    key: 'save',
    value: function save() {
      if (!this.field.length) return;

      var text = this.field.val();

      if (this.isLocalStorageAvailable && (text != null ? text.length : void 0) > 0) {
        return window.localStorage.setItem(this.key, text);
      }

      return this.reset();
    }
  }, {
    key: 'reset',
    value: function reset() {
      if (!this.isLocalStorageAvailable) return;

      return window.localStorage.removeItem(this.key);
    }
  }]);

  return Autosave;
}();

/* harmony default export */ __webpack_exports__["a"] = (Autosave);

/***/ }),

/***/ "./commit/image_file.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-use-before-define, prefer-arrow-callback, no-else-return, consistent-return, prefer-template, quotes, one-var, one-var-declaration-per-line, no-unused-vars, no-return-assign, comma-dangle, quote-props, no-unused-expressions, no-sequences, object-shorthand, max-len */

// Width where images must fits in, for 2-up this gets divided by 2
var availWidth = 900;
var viewModes = ['two-up', 'swipe'];

var ImageFile = function () {
  function ImageFile(file) {
    _classCallCheck(this, ImageFile);

    this.views = {
      'two-up': function twoUp() {
        return $('.two-up.view .wrap', this.file).each(function (_this) {
          return function (index, wrap) {
            $('img', wrap).each(function () {
              var currentWidth;
              currentWidth = $(this).width();
              if (currentWidth > availWidth / 2) {
                return $(this).width(availWidth / 2);
              }
            });
            return _this.requestImageInfo($('img', wrap), function (width, height) {
              $('.image-info .meta-width', wrap).text(width + "px");
              $('.image-info .meta-height', wrap).text(height + "px");
              return $('.image-info', wrap).removeClass('hide');
            });
          };
        }(this));
      },
      'swipe': function swipe() {
        var maxHeight, maxWidth;
        maxWidth = 0;
        maxHeight = 0;
        return $('.swipe.view', this.file).each(function (_this) {
          return function (index, view) {
            var $swipeWrap, $swipeBar, $swipeFrame, wrapPadding, ref;
            ref = _this.prepareFrames(view), maxWidth = ref[0], maxHeight = ref[1];
            $swipeFrame = $('.swipe-frame', view);
            $swipeWrap = $('.swipe-wrap', view);
            $swipeBar = $('.swipe-bar', view);

            $swipeFrame.css({
              width: maxWidth + 16,
              height: maxHeight + 28
            });
            $swipeWrap.css({
              width: maxWidth + 1,
              height: maxHeight + 2
            });
            // Set swipeBar left position to match image frame
            $swipeBar.css({
              left: 1
            });

            wrapPadding = parseInt($swipeWrap.css('right').replace('px', ''), 10);

            _this.initDraggable($swipeBar, wrapPadding, function (e, left) {
              if (left > 0 && left < $swipeFrame.width() - wrapPadding * 2) {
                $swipeWrap.width(maxWidth + 1 - left);
                $swipeBar.css('left', left);
              }
            });
          };
        }(this));
      },
      'onion-skin': function onionSkin() {
        var dragTrackWidth, maxHeight, maxWidth;
        maxWidth = 0;
        maxHeight = 0;
        dragTrackWidth = $('.drag-track', this.file).width() - $('.dragger', this.file).width();
        return $('.onion-skin.view', this.file).each(function (_this) {
          return function (index, view) {
            var $frame,
                $track,
                $dragger,
                $frameAdded,
                framePadding,
                ref,
                dragging = false;
            ref = _this.prepareFrames(view), maxWidth = ref[0], maxHeight = ref[1];
            $frame = $('.onion-skin-frame', view);
            $frameAdded = $('.frame.added', view);
            $track = $('.drag-track', view);
            $dragger = $('.dragger', $track);

            $frame.css({
              width: maxWidth + 16,
              height: maxHeight + 28
            });
            $('.swipe-wrap', view).css({
              width: maxWidth + 1,
              height: maxHeight + 2
            });
            $dragger.css({
              left: dragTrackWidth
            });

            $frameAdded.css('opacity', 1);
            framePadding = parseInt($frameAdded.css('right').replace('px', ''), 10);

            _this.initDraggable($dragger, framePadding, function (e, left) {
              var opacity = left / dragTrackWidth;

              if (opacity >= 0 && opacity <= 1) {
                $dragger.css('left', left);
                $frameAdded.css('opacity', opacity);
              }
            });
          };
        }(this));
      }
    };

    this.file = file;
    this.requestImageInfo($('.two-up.view .frame.deleted img', this.file), function (_this) {
      return function (deletedWidth, deletedHeight) {
        return _this.requestImageInfo($('.two-up.view .frame.added img', _this.file), function (width, height) {
          _this.initViewModes();

          // Load two-up view after images are loaded
          // so that we can display the correct width and height information
          var $images = $('.two-up.view img', _this.file);

          $images.waitForImages(function () {
            _this.initView('two-up');
          });
        });
      };
    }(this));
  }

  _createClass(ImageFile, [{
    key: 'initViewModes',
    value: function initViewModes() {
      var viewMode = viewModes[0];
      $('.view-modes', this.file).removeClass('hide');
      $('.view-modes-menu', this.file).on('click', 'li', function (_this) {
        return function (event) {
          if (!$(event.currentTarget).hasClass('active')) {
            return _this.activateViewMode(event.currentTarget.className);
          }
        };
      }(this));
      return this.activateViewMode(viewMode);
    }
  }, {
    key: 'activateViewMode',
    value: function activateViewMode(viewMode) {
      $('.view-modes-menu li', this.file).removeClass('active').filter("." + viewMode).addClass('active');
      return $(".view:visible:not(." + viewMode + ")", this.file).fadeOut(200, function (_this) {
        return function () {
          $(".view." + viewMode, _this.file).fadeIn(200);
          return _this.initView(viewMode);
        };
      }(this));
    }
  }, {
    key: 'initView',
    value: function initView(viewMode) {
      return this.views[viewMode].call(this);
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'initDraggable',
    value: function initDraggable($el, padding, callback) {
      var dragging = false;
      var $body = $('body');
      var $offsetEl = $el.parent();

      $el.off('mousedown').on('mousedown', function () {
        dragging = true;
        $body.css('user-select', 'none');
      });

      $body.off('mouseup').off('mousemove').on('mouseup', function () {
        dragging = false;
        $body.css('user-select', '');
      }).on('mousemove', function (e) {
        var left;
        if (!dragging) return;

        left = e.pageX - ($offsetEl.offset().left + padding);

        callback(e, left);
      });
    }
  }, {
    key: 'prepareFrames',
    value: function prepareFrames(view) {
      var maxHeight, maxWidth;
      maxWidth = 0;
      maxHeight = 0;
      $('.frame', view).each(function (_this) {
        return function (index, frame) {
          var height, width;
          width = $(frame).width();
          height = $(frame).height();
          maxWidth = width > maxWidth ? width : maxWidth;
          return maxHeight = height > maxHeight ? height : maxHeight;
        };
      }(this)).css({
        width: maxWidth,
        height: maxHeight
      });
      return [maxWidth, maxHeight];
    }
    // eslint-disable-next-line

  }, {
    key: 'requestImageInfo',
    value: function requestImageInfo(img, callback) {
      var domImg = img.get(0);
      if (domImg) {
        if (domImg.complete) {
          return callback.call(this, domImg.naturalWidth, domImg.naturalHeight);
        } else {
          return img.on('load', function (_this) {
            return function () {
              return callback.call(_this, domImg.naturalWidth, domImg.naturalHeight);
            };
          }(this));
        }
      }
    }
  }]);

  return ImageFile;
}();

/* harmony default export */ __webpack_exports__["a"] = (ImageFile);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./commit_merge_requests.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* unused harmony export getHeaderText */
/* unused harmony export createHeader */
/* unused harmony export createLink */
/* unused harmony export createTitle */
/* unused harmony export createItem */
/* unused harmony export createContent */
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchCommitMergeRequests;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__("./locale/index.js");
/* global Flash */




function getHeaderText(childElementCount, mergeRequestCount) {
  if (childElementCount === 0) {
    return mergeRequestCount + ' ' + Object(__WEBPACK_IMPORTED_MODULE_1__locale__["d" /* n__ */])('merge request', 'merge requests', mergeRequestCount);
  }
  return ',';
}

function createHeader(childElementCount, mergeRequestCount) {
  var headerText = getHeaderText(childElementCount, mergeRequestCount);

  return $('<span />', {
    class: 'append-right-5',
    text: headerText
  });
}

function createLink(mergeRequest) {
  return $('<a />', {
    class: 'append-right-5',
    href: mergeRequest.path,
    text: '!' + mergeRequest.iid
  });
}

function createTitle(mergeRequest) {
  return $('<span />', {
    text: mergeRequest.title
  });
}

function createItem(mergeRequest) {
  var $item = $('<span />');
  var $link = createLink(mergeRequest);
  var $title = createTitle(mergeRequest);
  $item.append($link);
  $item.append($title);

  return $item;
}

function createContent(mergeRequests) {
  var $content = $('<span />');

  if (mergeRequests.length === 0) {
    $content.text(Object(__WEBPACK_IMPORTED_MODULE_1__locale__["e" /* s__ */])('Commits|No related merge requests found'));
  } else {
    mergeRequests.forEach(function (mergeRequest) {
      var $header = createHeader($content.children().length, mergeRequests.length);
      var $item = createItem(mergeRequest);
      $content.append($header);
      $content.append($item);
    });
  }

  return $content;
}

function fetchCommitMergeRequests() {
  var $container = $('.merge-requests');

  __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].get($container.data('projectCommitPath')).then(function (response) {
    var $content = createContent(response.data);

    $container.html($content);
  }).catch(function () {
    return Flash(Object(__WEBPACK_IMPORTED_MODULE_1__locale__["e" /* s__ */])('Commits|An error occurred while fetching merge requests data.'));
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__files_comment_button__ = __webpack_require__("./files_comment_button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__single_file_diff__ = __webpack_require__("./single_file_diff.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__image_diff_helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }









var UNFOLD_COUNT = 20;
var isBound = false;

var Diff = function () {
  function Diff() {
    _classCallCheck(this, Diff);

    var $diffFile = $('.files .diff-file');

    $diffFile.each(function (index, file) {
      if (!$.data(file, 'singleFileDiff')) {
        $.data(file, 'singleFileDiff', new __WEBPACK_IMPORTED_MODULE_5__single_file_diff__["a" /* default */](file));
      }
    });

    var tab = document.getElementById('diffs');
    if (!tab || tab && tab.dataset && tab.dataset.isLocked !== '') __WEBPACK_IMPORTED_MODULE_4__files_comment_button__["a" /* default */].init($diffFile);

    var firstFile = $('.files').first().get(0);
    var canCreateNote = firstFile && firstFile.hasAttribute('data-can-create-note');
    $diffFile.each(function (index, file) {
      return __WEBPACK_IMPORTED_MODULE_6__image_diff_helpers_index__["a" /* default */].initImageDiff(file, canCreateNote);
    });

    if (!isBound) {
      $(document).on('click', '.js-unfold', this.handleClickUnfold.bind(this)).on('click', '.diff-line-num a', this.handleClickLineNum.bind(this)).on('mousedown', 'td.line_content.parallel', this.handleParallelLineDown.bind(this));
      isBound = true;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_url_utility__["a" /* getLocationHash */])()) {
      this.highlightSelectedLine();
    }

    this.openAnchoredDiff();
  }

  _createClass(Diff, [{
    key: 'handleClickUnfold',
    value: function handleClickUnfold(e) {
      var $target = $(e.target);

      var _lineNumbers = this.lineNumbers($target.parent()),
          _lineNumbers2 = _slicedToArray(_lineNumbers, 2),
          oldLineNumber = _lineNumbers2[0],
          newLineNumber = _lineNumbers2[1];

      var offset = newLineNumber - oldLineNumber;
      var bottom = $target.hasClass('js-unfold-bottom');
      var since = void 0;
      var to = void 0;
      var unfold = true;

      if (bottom) {
        var lineNumber = newLineNumber + 1;
        since = lineNumber;
        to = lineNumber + UNFOLD_COUNT;
      } else {
        var _lineNumber = newLineNumber - 1;
        since = _lineNumber - UNFOLD_COUNT;
        to = _lineNumber;

        // make sure we aren't loading more than we need
        var prevNewLine = this.lineNumbers($target.parent().prev())[1];
        if (since <= prevNewLine + 1) {
          since = prevNewLine + 1;
          unfold = false;
        }
      }

      var file = $target.parents('.diff-file');
      var link = file.data('blobDiffPath');
      var view = file.data('view');

      var params = { since: since, to: to, bottom: bottom, offset: offset, unfold: unfold, view: view };
      __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].get(link, { params: params }).then(function (_ref) {
        var data = _ref.data;
        return $target.parent().replaceWith(data);
      }).catch(function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__locale__["a" /* __ */])('An error occurred while loading diff'));
      });
    }
  }, {
    key: 'openAnchoredDiff',
    value: function openAnchoredDiff(cb) {
      var _this = this;

      var locationHash = Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_url_utility__["a" /* getLocationHash */])();
      var anchoredDiff = locationHash && locationHash.split('_')[0];

      if (!anchoredDiff) return;

      var diffTitle = $('#' + anchoredDiff);
      var diffFile = diffTitle.closest('.diff-file');
      var nothingHereBlock = $('.nothing-here-block:visible', diffFile);
      if (nothingHereBlock.length) {
        var clickTarget = $('.js-file-title, .click-to-expand', diffFile);
        diffFile.data('singleFileDiff').toggleDiff(clickTarget, function () {
          _this.highlightSelectedLine();
          if (cb) cb();
        });
      } else if (cb) {
        cb();
      }
    }
  }, {
    key: 'handleClickLineNum',
    value: function handleClickLineNum(e) {
      var hash = $(e.currentTarget).attr('href');
      e.preventDefault();
      if (window.history.pushState) {
        window.history.pushState(null, null, hash);
      } else {
        window.location.hash = hash;
      }
      this.highlightSelectedLine();
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'handleParallelLineDown',
    value: function handleParallelLineDown(e) {
      var line = $(e.currentTarget);
      var table = line.closest('table');

      table.removeClass('left-side-selected right-side-selected');

      var lineClass = ['left-side', 'right-side'].filter(function (name) {
        return line.hasClass(name);
      })[0];
      if (lineClass) {
        table.addClass(lineClass + '-selected');
      }
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'diffViewType',
    value: function diffViewType() {
      return $('.inline-parallel-buttons a.active').data('viewType');
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'lineNumbers',
    value: function lineNumbers(line) {
      var children = line.find('.diff-line-num').toArray();
      if (children.length !== 2) {
        return [0, 0];
      }
      return children.map(function (elm) {
        return parseInt($(elm).data('linenumber'), 10) || 0;
      });
    }
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'highlightSelectedLine',
    value: function highlightSelectedLine() {
      var hash = Object(__WEBPACK_IMPORTED_MODULE_3__lib_utils_url_utility__["a" /* getLocationHash */])();
      var $diffFiles = $('.diff-file');
      $diffFiles.find('.hll').removeClass('hll');

      if (hash) {
        $diffFiles.find('tr#' + hash + ':not(.match) td, td#' + hash + ', td[data-line-code="' + hash + '"]').addClass('hll');
      }
    }
  }]);

  return Diff;
}();

/* harmony default export */ __webpack_exports__["a"] = (Diff);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/components/comment_resolve_btn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* eslint-disable comma-dangle, object-shorthand, func-names, no-else-return, quotes, no-lonely-if, max-len */
/* global CommentsStore */



var CommentAndResolveBtn = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    discussionId: String
  },
  data: function data() {
    return {
      textareaIsEmpty: true,
      discussion: {}
    };
  },

  computed: {
    showButton: function showButton() {
      if (this.discussion) {
        return this.discussion.isResolvable();
      } else {
        return false;
      }
    },
    isDiscussionResolved: function isDiscussionResolved() {
      return this.discussion.isResolved();
    },
    buttonText: function buttonText() {
      if (this.isDiscussionResolved) {
        if (this.textareaIsEmpty) {
          return "未解决讨论";
        } else {
          return "评论 & 未解决讨论";
        }
      } else {
        if (this.textareaIsEmpty) {
          return "解决讨论";
        } else {
          return "评论 & 解决讨论";
        }
      }
    }
  },
  created: function created() {
    if (this.discussionId) {
      this.discussion = CommentsStore.state[this.discussionId];
    }
  },

  mounted: function mounted() {
    var _this = this;

    if (!this.discussionId) return;

    var $textarea = $(".js-discussion-note-form[data-discussion-id=" + this.discussionId + "] .note-textarea");
    this.textareaIsEmpty = $textarea.val() === '';

    $textarea.on('input.comment-and-resolve-btn', function () {
      _this.textareaIsEmpty = $textarea.val() === '';
    });
  },
  destroyed: function destroyed() {
    if (!this.discussionId) return;

    $(".js-discussion-note-form[data-discussion-id=" + this.discussionId + "] .note-textarea").off('input.comment-and-resolve-btn');
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('comment-and-resolve-btn', CommentAndResolveBtn);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/components/diff_note_avatars.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons_collapse_icon_svg__ = __webpack_require__("./diff_notes/icons/collapse_icon.svg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__icons_collapse_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__icons_collapse_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notes__ = __webpack_require__("./notes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_user_avatar_user_avatar_image_vue__ = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_image.vue");
/* global CommentsStore */






var DiffNoteAvatars = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: ['discussionId'],
  data: function data() {
    return {
      isVisible: false,
      lineType: '',
      storeState: CommentsStore.state,
      shownAvatars: 3,
      collapseIcon: __WEBPACK_IMPORTED_MODULE_1__icons_collapse_icon_svg___default.a
    };
  },

  components: {
    userAvatarImage: __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_user_avatar_user_avatar_image_vue__["a" /* default */]
  },
  template: '\n    <div class="diff-comment-avatar-holders"\n      :class="discussionClassName"\n      v-show="notesCount !== 0">\n      <div v-if="!isVisible">\n        <!-- FIXME: Pass an alt attribute here for accessibility -->\n        <user-avatar-image\n          v-for="note in notesSubset"\n          :key="note.id"\n          class="diff-comment-avatar js-diff-comment-avatar"\n          @click.native="clickedAvatar($event)"\n          :img-src="note.authorAvatar"\n          :tooltip-text="getTooltipText(note)"\n          :data-line-type="lineType"\n          :size="19"\n          data-html="true"\n        />\n        <span v-if="notesCount > shownAvatars"\n          class="diff-comments-more-count has-tooltip js-diff-comment-avatar"\n          data-container="body"\n          data-placement="top"\n          ref="extraComments"\n          role="button"\n          :data-line-type="lineType"\n          :title="extraNotesTitle"\n          @click="clickedAvatar($event)">{{ moreText }}</span>\n      </div>\n      <button class="diff-notes-collapse js-diff-comment-avatar"\n        type="button"\n        aria-label="Show comments"\n        :data-line-type="lineType"\n        @click="clickedAvatar($event)"\n        v-if="isVisible"\n        v-html="collapseIcon">\n      </button>\n    </div>\n  ',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.addNoCommentClass();
      _this.setDiscussionVisible();

      _this.lineType = $(_this.$el).closest('.diff-line-num').hasClass('old_line') ? 'old' : 'new';
    });

    $(document).on('toggle.comments', function () {
      _this.$nextTick(function () {
        _this.setDiscussionVisible();
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.addNoCommentClass();
    $(document).off('toggle.comments');
  },

  watch: {
    storeState: {
      handler: function handler() {
        var _this2 = this;

        this.$nextTick(function () {
          $('.has-tooltip', _this2.$el).tooltip('fixTitle');

          // We need to add/remove a class to an element that is outside the Vue instance
          _this2.addNoCommentClass();
        });
      },

      deep: true
    }
  },
  computed: {
    discussionClassName: function discussionClassName() {
      return 'js-diff-avatars-' + this.discussionId;
    },
    notesSubset: function notesSubset() {
      var _this3 = this;

      var notes = [];

      if (this.discussion) {
        notes = Object.keys(this.discussion.notes).slice(0, this.shownAvatars).map(function (noteId) {
          return _this3.discussion.notes[noteId];
        });
      }

      return notes;
    },
    extraNotesTitle: function extraNotesTitle() {
      if (this.discussion) {
        var extra = this.discussion.notesCount() - this.shownAvatars;

        return extra + ' more comment' + (extra > 1 ? 's' : '');
      }

      return '';
    },
    discussion: function discussion() {
      return this.storeState[this.discussionId];
    },
    notesCount: function notesCount() {
      if (this.discussion) {
        return this.discussion.notesCount();
      }

      return 0;
    },
    moreText: function moreText() {
      var plusSign = this.notesCount < 100 ? '+' : '';

      return '' + plusSign + (this.notesCount - this.shownAvatars);
    }
  },
  methods: {
    clickedAvatar: function clickedAvatar(e) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__notes__["a" /* default */].instance.onAddDiffNote(e);

      // Toggle the active state of the toggle all button
      this.toggleDiscussionsToggleState();

      this.$nextTick(function () {
        _this4.setDiscussionVisible();

        $('.has-tooltip', _this4.$el).tooltip('fixTitle');
        $('.has-tooltip', _this4.$el).tooltip('hide');
      });
    },
    addNoCommentClass: function addNoCommentClass() {
      var notesCount = this.notesCount;

      $(this.$el).closest('.js-avatar-container').toggleClass('no-comment-btn', notesCount > 0).nextUntil('.js-avatar-container').toggleClass('no-comment-btn', notesCount > 0);
    },
    toggleDiscussionsToggleState: function toggleDiscussionsToggleState() {
      var $notesHolders = $(this.$el).closest('.code').find('.notes_holder');
      var $visibleNotesHolders = $notesHolders.filter(':visible');
      var $toggleDiffCommentsBtn = $(this.$el).closest('.diff-file').find('.js-toggle-diff-comments');

      $toggleDiffCommentsBtn.toggleClass('active', $notesHolders.length === $visibleNotesHolders.length);
    },
    setDiscussionVisible: function setDiscussionVisible() {
      this.isVisible = $('.diffs .notes[data-discussion-id="' + this.discussion.id + '"]').is(':visible');
    },
    getTooltipText: function getTooltipText(note) {
      return note.authorName + ': ' + note.noteTruncated;
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('diff-note-avatars', DiffNoteAvatars);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/components/jump_to_discussion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_discussion__ = __webpack_require__("./diff_notes/mixins/discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_discussion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__mixins_discussion__);
/* eslint-disable comma-dangle, object-shorthand, func-names, no-else-return, guard-for-in, no-restricted-syntax, one-var, space-before-function-paren, no-lonely-if, no-continue, brace-style, max-len, quotes */
/* global DiscussionMixins */
/* global CommentsStore */





var JumpToDiscussion = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  mixins: [DiscussionMixins],
  props: {
    discussionId: String
  },
  data: function data() {
    return {
      discussions: CommentsStore.state,
      discussion: {}
    };
  },
  computed: {
    buttonText: function buttonText() {
      if (this.discussionId) {
        return 'Jump to next unresolved discussion';
      } else {
        return 'Jump to first unresolved discussion';
      }
    },
    allResolved: function allResolved() {
      return this.unresolvedDiscussionCount === 0;
    },
    showButton: function showButton() {
      if (this.discussionId) {
        if (this.unresolvedDiscussionCount > 1) {
          return true;
        } else {
          return this.discussionId !== this.lastResolvedId;
        }
      } else {
        return this.unresolvedDiscussionCount >= 1;
      }
    },
    lastResolvedId: function lastResolvedId() {
      var lastId = void 0;
      for (var discussionId in this.discussions) {
        var discussion = this.discussions[discussionId];

        if (!discussion.isResolved()) {
          lastId = discussion.id;
        }
      }
      return lastId;
    }
  },
  methods: {
    jumpToNextUnresolvedDiscussion: function jumpToNextUnresolvedDiscussion() {
      var discussionsSelector = void 0;
      var discussionIdsInScope = void 0;
      var firstUnresolvedDiscussionId = void 0;
      var nextUnresolvedDiscussionId = void 0;
      var activeTab = window.mrTabs.currentAction;
      var hasDiscussionsToJumpTo = true;
      var jumpToFirstDiscussion = !this.discussionId;

      var discussionIdsForElements = function discussionIdsForElements(elements) {
        return elements.map(function () {
          return $(this).attr('data-discussion-id');
        }).toArray();
      };

      var discussions = this.discussions;

      if (activeTab === 'diffs') {
        discussionsSelector = '.diffs .notes[data-discussion-id]';
        discussionIdsInScope = discussionIdsForElements($(discussionsSelector));

        var unresolvedDiscussionCount = 0;

        for (var i = 0; i < discussionIdsInScope.length; i += 1) {
          var discussionId = discussionIdsInScope[i];
          var discussion = discussions[discussionId];
          if (discussion && !discussion.isResolved()) {
            unresolvedDiscussionCount += 1;
          }
        }

        if (this.discussionId && !this.discussion.isResolved()) {
          // If this is the last unresolved discussion on the diffs tab,
          // there are no discussions to jump to.
          if (unresolvedDiscussionCount === 1) {
            hasDiscussionsToJumpTo = false;
          }
        } else {
          // If there are no unresolved discussions on the diffs tab at all,
          // there are no discussions to jump to.
          if (unresolvedDiscussionCount === 0) {
            hasDiscussionsToJumpTo = false;
          }
        }
      } else if (activeTab !== 'show') {
        // If we are on the commits or builds tabs,
        // there are no discussions to jump to.
        hasDiscussionsToJumpTo = false;
      }

      if (!hasDiscussionsToJumpTo) {
        // If there are no discussions to jump to on the current page,
        // switch to the notes tab and jump to the first disucssion there.
        window.mrTabs.activateTab('show');
        activeTab = 'show';
        jumpToFirstDiscussion = true;
      }

      if (activeTab === 'show') {
        discussionsSelector = '.discussion[data-discussion-id]';
        discussionIdsInScope = discussionIdsForElements($(discussionsSelector));
      }

      var currentDiscussionFound = false;
      for (var _i = 0; _i < discussionIdsInScope.length; _i += 1) {
        var _discussionId = discussionIdsInScope[_i];
        var _discussion = discussions[_discussionId];

        if (!_discussion) {
          // Discussions for comments on commits in this MR don't have a resolved status.
          continue;
        }

        if (!firstUnresolvedDiscussionId && !_discussion.isResolved()) {
          firstUnresolvedDiscussionId = _discussionId;

          if (jumpToFirstDiscussion) {
            break;
          }
        }

        if (!jumpToFirstDiscussion) {
          if (currentDiscussionFound) {
            if (!_discussion.isResolved()) {
              nextUnresolvedDiscussionId = _discussionId;
              break;
            } else {
              continue;
            }
          }

          if (_discussionId === this.discussionId) {
            currentDiscussionFound = true;
          }
        }
      }

      nextUnresolvedDiscussionId = nextUnresolvedDiscussionId || firstUnresolvedDiscussionId;

      if (!nextUnresolvedDiscussionId) {
        return;
      }

      var $target = $(discussionsSelector + '[data-discussion-id="' + nextUnresolvedDiscussionId + '"]');

      if (activeTab === 'show') {
        $target = $target.closest('.note-discussion');

        // If the next discussion is closed, toggle it open.
        if ($target.find('.js-toggle-content').is(':hidden')) {
          $target.find('.js-toggle-button i').trigger('click');
        }
      } else if (activeTab === 'diffs') {
        // Resolved discussions are hidden in the diffs tab by default.
        // If they are marked unresolved on the notes tab, they will still be hidden on the diffs tab.
        // When jumping between unresolved discussions on the diffs tab, we show them.
        $target.closest(".content").show();

        var $notesHolder = $target.closest("tr.notes_holder");

        // Image diff discussions does not use notes_holder
        // so we should keep original $target value in those cases
        if ($notesHolder.length > 0) {
          $target = $notesHolder;
        }

        $target.show();

        // If we are on the diffs tab, we don't scroll to the discussion itself, but to
        // 4 diff lines above it: the line the discussion was in response to + 3 context
        var prevEl = void 0;
        for (var _i2 = 0; _i2 < 4; _i2 += 1) {
          prevEl = $target.prev();

          // If the discussion doesn't have 4 lines above it, we'll have to do with fewer.
          if (!prevEl.hasClass("line_holder")) {
            break;
          }

          $target = prevEl;
        }
      }

      $.scrollTo($target, {
        offset: -150
      });
    }
  },
  created: function created() {
    this.discussion = this.discussions[this.discussionId];
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('jump-to-discussion', JumpToDiscussion);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/components/new_issue_for_discussion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* global CommentsStore */



var NewIssueForDiscussion = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    discussionId: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      discussions: CommentsStore.state
    };
  },

  computed: {
    discussion: function discussion() {
      return this.discussions[this.discussionId];
    },
    showButton: function showButton() {
      if (this.discussion) return !this.discussion.isResolved();
      return false;
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('new-issue-for-discussion-btn', NewIssueForDiscussion);

/***/ }),

/***/ "./diff_notes/components/resolve_btn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash__ = __webpack_require__("./flash.js");
/* eslint-disable comma-dangle, object-shorthand, func-names, quote-props, no-else-return, camelcase, max-len */
/* global CommentsStore */
/* global ResolveService */




var ResolveBtn = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    noteId: Number,
    discussionId: String,
    resolved: Boolean,
    canResolve: Boolean,
    resolvedBy: String,
    authorName: String,
    authorAvatar: String,
    noteTruncated: String
  },
  data: function data() {
    return {
      discussions: CommentsStore.state,
      loading: false
    };
  },
  watch: {
    'discussions': {
      handler: 'updateTooltip',
      deep: true
    }
  },
  computed: {
    discussion: function discussion() {
      return this.discussions[this.discussionId];
    },
    note: function note() {
      return this.discussion ? this.discussion.getNote(this.noteId) : {};
    },
    buttonText: function buttonText() {
      if (this.isResolved) {
        return 'Resolved by ' + this.resolvedByName;
      } else if (this.canResolve) {
        return '标记为已解决';
      } else {
        return '无法解决';
      }
    },
    isResolved: function isResolved() {
      if (this.note) {
        return this.note.resolved;
      } else {
        return false;
      }
    },
    resolvedByName: function resolvedByName() {
      return this.note.resolved_by;
    }
  },
  methods: {
    updateTooltip: function updateTooltip() {
      var _this = this;

      this.$nextTick(function () {
        $(_this.$refs.button).tooltip('hide').tooltip('fixTitle');
      });
    },
    resolve: function resolve() {
      var _this2 = this;

      if (!this.canResolve) return;

      var promise = void 0;
      this.loading = true;

      if (this.isResolved) {
        promise = ResolveService.unresolve(this.noteId);
      } else {
        promise = ResolveService.resolve(this.noteId);
      }

      promise.then(function (resp) {
        return resp.json();
      }).then(function (data) {
        _this2.loading = false;

        var resolved_by = data ? data.resolved_by : null;

        CommentsStore.update(_this2.discussionId, _this2.noteId, !_this2.isResolved, resolved_by);
        _this2.discussion.updateHeadline(data);
        gl.mrWidget.checkStatus();
        document.dispatchEvent(new CustomEvent('refreshVueNotes'));

        _this2.updateTooltip();
      }).catch(function () {
        return new __WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */]('An error occurred when trying to resolve a comment. Please try again.');
      });
    }
  },
  mounted: function mounted() {
    $(this.$refs.button).tooltip({
      container: 'body'
    });
  },
  beforeDestroy: function beforeDestroy() {
    CommentsStore.delete(this.discussionId, this.noteId);
  },
  created: function created() {
    CommentsStore.create({
      discussionId: this.discussionId,
      noteId: this.noteId,
      canResolve: this.canResolve,
      resolved: this.resolved,
      resolvedBy: this.resolvedBy,
      authorName: this.authorName,
      authorAvatar: this.authorAvatar,
      noteTruncated: this.noteTruncated
    });
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('resolve-btn', ResolveBtn);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/components/resolve_count.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_discussion__ = __webpack_require__("./diff_notes/mixins/discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_discussion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__mixins_discussion__);
/* eslint-disable comma-dangle, object-shorthand, func-names, no-param-reassign */
/* global DiscussionMixins */
/* global CommentsStore */





window.ResolveCount = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  mixins: [DiscussionMixins],
  props: {
    loggedOut: Boolean
  },
  data: function data() {
    return {
      discussions: CommentsStore.state
    };
  },
  computed: {
    allResolved: function allResolved() {
      return this.resolvedDiscussionCount === this.discussionCount;
    },
    resolvedCountText: function resolvedCountText() {
      return this.discussionCount === 1 ? '讨论' : '讨论';
    }
  }
});

/***/ }),

/***/ "./diff_notes/components/resolve_discussion_btn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* eslint-disable object-shorthand, func-names, space-before-function-paren, comma-dangle, no-else-return, quotes, max-len */
/* global CommentsStore */
/* global ResolveService */



var ResolveDiscussionBtn = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
  props: {
    discussionId: String,
    mergeRequestId: Number,
    canResolve: Boolean
  },
  data: function data() {
    return {
      discussion: {}
    };
  },
  computed: {
    showButton: function showButton() {
      if (this.discussion) {
        return this.discussion.isResolvable();
      } else {
        return false;
      }
    },
    isDiscussionResolved: function isDiscussionResolved() {
      if (this.discussion) {
        return this.discussion.isResolved();
      } else {
        return false;
      }
    },
    buttonText: function buttonText() {
      if (this.isDiscussionResolved) {
        return "Unresolve discussion";
      } else {
        return "Resolve discussion";
      }
    },
    loading: function loading() {
      if (this.discussion) {
        return this.discussion.loading;
      } else {
        return false;
      }
    }
  },
  methods: {
    resolve: function resolve() {
      ResolveService.toggleResolveForDiscussion(this.mergeRequestId, this.discussionId);
    }
  },
  created: function created() {
    CommentsStore.createDiscussion(this.discussionId, this.canResolve);

    this.discussion = CommentsStore.state[this.discussionId];
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('resolve-discussion-btn', ResolveDiscussionBtn);

/***/ }),

/***/ "./diff_notes/diff_notes_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_discussion__ = __webpack_require__("./diff_notes/models/discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_note__ = __webpack_require__("./diff_notes/models/note.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__models_note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_comments__ = __webpack_require__("./diff_notes/stores/comments.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_resolve__ = __webpack_require__("./diff_notes/services/resolve.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_discussion__ = __webpack_require__("./diff_notes/mixins/discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_discussion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__mixins_discussion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_comment_resolve_btn__ = __webpack_require__("./diff_notes/components/comment_resolve_btn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_jump_to_discussion__ = __webpack_require__("./diff_notes/components/jump_to_discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_resolve_btn__ = __webpack_require__("./diff_notes/components/resolve_btn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_resolve_count__ = __webpack_require__("./diff_notes/components/resolve_count.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_resolve_discussion_btn__ = __webpack_require__("./diff_notes/components/resolve_discussion_btn.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_diff_note_avatars__ = __webpack_require__("./diff_notes/components/diff_note_avatars.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_new_issue_for_discussion__ = __webpack_require__("./diff_notes/components/new_issue_for_discussion.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_utils_common_utils__ = __webpack_require__("./lib/utils/common_utils.js");
/* eslint-disable func-names, comma-dangle, new-cap, no-new, max-len */
/* global ResolveCount */
















/* harmony default export */ __webpack_exports__["a"] = (function () {
  var projectPathHolder = document.querySelector('.merge-request') || document.querySelector('.commit-box');
  var projectPath = projectPathHolder.dataset.projectPath;
  var COMPONENT_SELECTOR = 'resolve-btn, resolve-discussion-btn, jump-to-discussion, comment-and-resolve-btn, new-issue-for-discussion-btn';

  window.gl = window.gl || {};
  window.gl.diffNoteApps = {};

  window.ResolveService = new gl.DiffNotesResolveServiceClass(projectPath);

  gl.diffNotesCompileComponents = function () {
    $('diff-note-avatars').each(function () {
      var tmp = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
        template: $(this).get(0).outerHTML
      });
      var tmpApp = new tmp().$mount();

      $(this).replaceWith(tmpApp.$el);
      $(tmpApp.$el).one('remove.vue', function () {
        tmpApp.$destroy();
        tmpApp.$el.remove();
      });
    });

    var $components = $(COMPONENT_SELECTOR).filter(function () {
      return $(this).closest('resolve-count').length !== 1;
    });

    if ($components) {
      $components.each(function () {
        var $this = $(this);
        var noteId = $this.attr(':note-id');
        var discussionId = $this.attr(':discussion-id');

        if ($this.is('comment-and-resolve-btn') && !discussionId) return;

        var tmp = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].extend({
          template: $this.get(0).outerHTML
        });
        var tmpApp = new tmp().$mount();

        if (noteId) {
          gl.diffNoteApps['note_' + noteId] = tmpApp;
        }

        $this.replaceWith(tmpApp.$el);
      });
    }
  };

  gl.diffNotesCompileComponents();

  if (!Object(__WEBPACK_IMPORTED_MODULE_13__lib_utils_common_utils__["n" /* hasVueMRDiscussionsCookie */])()) {
    new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
      el: '#resolve-count-app',
      components: {
        'resolve-count': ResolveCount
      }
    });
  }

  $(window).trigger('resize.nav');
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/icons/collapse_icon.svg":
/***/ (function(module, exports) {

module.exports = "<svg width=\"11\" height=\"11\" viewBox=\"0 0 9 13\"><path d=\"M2.57568253,6.49866948 C2.50548852,6.57199715 2.44637866,6.59708255 2.39835118,6.57392645 C2.3503237,6.55077034 2.32631032,6.48902165 2.32631032,6.38867852 L2.32631032,-2.13272614 C2.32631032,-2.23306927 2.3503237,-2.29481796 2.39835118,-2.31797406 C2.44637866,-2.34113017 2.50548852,-2.31604477 2.57568253,-2.24271709 L6.51022184,1.86747129 C6.53977721,1.8983461 6.56379059,1.93500939 6.5822627,1.97746225 L6.5822627,2.27849013 C6.56379059,2.31708364 6.53977721,2.35374693 6.51022184,2.38848109 L2.57568253,6.49866948 Z\" transform=\"translate(4.454287, 2.127976) rotate(90.000000) translate(-4.454287, -2.127976) \"></path><path d=\"M3.74312342,2.09553332 C3.74312342,1.99519019 3.77821989,1.9083561 3.8484139,1.83502843 C3.91860791,1.76170075 4.00173115,1.72503747 4.09778611,1.72503747 L4.80711151,1.72503747 C4.90316647,1.72503747 4.98628971,1.76170075 5.05648372,1.83502843 C5.12667773,1.9083561 5.16177421,1.99519019 5.16177421,2.09553332 L5.16177421,10.2464421 C5.16177421,10.3467853 5.12667773,10.4336194 5.05648372,10.506947 C4.98628971,10.5802747 4.90316647,10.616938 4.80711151,10.616938 L4.09778611,10.616938 C4.00173115,10.616938 3.91860791,10.5802747 3.8484139,10.506947 C3.77821989,10.4336194 3.74312342,10.3467853 3.74312342,10.2464421 L3.74312342,2.09553332 Z\" transform=\"translate(4.452449, 6.170988) rotate(-90.000000) translate(-4.452449, -6.170988) \"></path><path d=\"M2.57568253,14.6236695 C2.50548852,14.6969971 2.44637866,14.7220826 2.39835118,14.6989264 C2.3503237,14.6757703 2.32631032,14.6140216 2.32631032,14.5136785 L2.32631032,5.99227386 C2.32631032,5.89193073 2.3503237,5.83018204 2.39835118,5.80702594 C2.44637866,5.78386983 2.50548852,5.80895523 2.57568253,5.88228291 L6.51022184,9.99247129 C6.53977721,10.0233461 6.56379059,10.0600094 6.5822627,10.1024622 L6.5822627,10.4034901 C6.56379059,10.4420836 6.53977721,10.4787469 6.51022184,10.5134811 L2.57568253,14.6236695 Z\" transform=\"translate(4.454287, 10.252976) scale(1, -1) rotate(90.000000) translate(-4.454287, -10.252976) \"></path></svg>\n"

/***/ }),

/***/ "./diff_notes/mixins/discussion.js":
/***/ (function(module, exports) {

/* eslint-disable object-shorthand, func-names, guard-for-in, no-restricted-syntax, comma-dangle, no-param-reassign, max-len */

window.DiscussionMixins = {
  computed: {
    discussionCount: function discussionCount() {
      return Object.keys(this.discussions).length;
    },
    resolvedDiscussionCount: function resolvedDiscussionCount() {
      var resolvedCount = 0;

      for (var discussionId in this.discussions) {
        var discussion = this.discussions[discussionId];

        if (discussion.isResolved()) {
          resolvedCount += 1;
        }
      }

      return resolvedCount;
    },
    unresolvedDiscussionCount: function unresolvedDiscussionCount() {
      var unresolvedCount = 0;

      for (var discussionId in this.discussions) {
        var discussion = this.discussions[discussionId];

        if (!discussion.isResolved()) {
          unresolvedCount += 1;
        }
      }

      return unresolvedCount;
    }
  }
};

/***/ }),

/***/ "./diff_notes/models/discussion.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_datetime_utility__ = __webpack_require__("./lib/utils/datetime_utility.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable space-before-function-paren, camelcase, guard-for-in, no-restricted-syntax, no-unused-vars, max-len */
/* global NoteModel */




var DiscussionModel = function () {
  function DiscussionModel(discussionId) {
    _classCallCheck(this, DiscussionModel);

    this.id = discussionId;
    this.notes = {};
    this.loading = false;
    this.canResolve = false;
  }

  _createClass(DiscussionModel, [{
    key: 'createNote',
    value: function createNote(noteObj) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.notes, noteObj.noteId, new NoteModel(this.id, noteObj));
    }
  }, {
    key: 'deleteNote',
    value: function deleteNote(noteId) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].delete(this.notes, noteId);
    }
  }, {
    key: 'getNote',
    value: function getNote(noteId) {
      return this.notes[noteId];
    }
  }, {
    key: 'notesCount',
    value: function notesCount() {
      return Object.keys(this.notes).length;
    }
  }, {
    key: 'isResolved',
    value: function isResolved() {
      for (var noteId in this.notes) {
        var note = this.notes[noteId];

        if (!note.resolved) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: 'resolveAllNotes',
    value: function resolveAllNotes(resolved_by) {
      for (var noteId in this.notes) {
        var note = this.notes[noteId];

        if (!note.resolved) {
          note.resolved = true;
          note.resolved_by = resolved_by;
        }
      }
    }
  }, {
    key: 'unResolveAllNotes',
    value: function unResolveAllNotes() {
      for (var noteId in this.notes) {
        var note = this.notes[noteId];

        if (note.resolved) {
          note.resolved = false;
          note.resolved_by = null;
        }
      }
    }
  }, {
    key: 'updateHeadline',
    value: function updateHeadline(data) {
      var discussionSelector = '.discussion[data-discussion-id="' + this.id + '"]';
      var $discussionHeadline = $(discussionSelector + ' .js-discussion-headline');

      if (data.discussion_headline_html) {
        if ($discussionHeadline.length) {
          $discussionHeadline.replaceWith(data.discussion_headline_html);
        } else {
          $(discussionSelector + ' .discussion-header').append(data.discussion_headline_html);
        }

        Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils_datetime_utility__["e" /* localTimeAgo */])($('.js-timeago', '' + discussionSelector));
      } else {
        $discussionHeadline.remove();
      }
    }
  }, {
    key: 'isResolvable',
    value: function isResolvable() {
      if (!this.canResolve) {
        return false;
      }

      for (var noteId in this.notes) {
        var note = this.notes[noteId];

        if (note.canResolve) {
          return true;
        }
      }

      return false;
    }
  }]);

  return DiscussionModel;
}();

window.DiscussionModel = DiscussionModel;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./diff_notes/models/note.js":
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable camelcase, no-unused-vars */

var NoteModel = function NoteModel(discussionId, noteObj) {
  _classCallCheck(this, NoteModel);

  this.discussionId = discussionId;
  this.id = noteObj.noteId;
  this.canResolve = noteObj.canResolve;
  this.resolved = noteObj.resolved;
  this.resolved_by = noteObj.resolvedBy;
  this.authorName = noteObj.authorName;
  this.authorAvatar = noteObj.authorAvatar;
  this.noteTruncated = noteObj.noteTruncated;
};

window.NoteModel = NoteModel;

/***/ }),

/***/ "./diff_notes/services/resolve.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_vue_resource_interceptor__ = __webpack_require__("./vue_shared/vue_resource_interceptor.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global CommentsStore */





window.gl = window.gl || {};

var ResolveServiceClass = function () {
  function ResolveServiceClass(root) {
    _classCallCheck(this, ResolveServiceClass);

    this.noteResource = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].resource(root + '/notes{/noteId}/resolve?html=true');
    this.discussionResource = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].resource(root + '/merge_requests{/mergeRequestId}/discussions{/discussionId}/resolve?html=true');
  }

  _createClass(ResolveServiceClass, [{
    key: 'resolve',
    value: function resolve(noteId) {
      return this.noteResource.save({ noteId: noteId }, {});
    }
  }, {
    key: 'unresolve',
    value: function unresolve(noteId) {
      return this.noteResource.delete({ noteId: noteId }, {});
    }
  }, {
    key: 'toggleResolveForDiscussion',
    value: function toggleResolveForDiscussion(mergeRequestId, discussionId) {
      var discussion = CommentsStore.state[discussionId];
      var isResolved = discussion.isResolved();
      var promise = void 0;

      if (isResolved) {
        promise = this.unResolveAll(mergeRequestId, discussionId);
      } else {
        promise = this.resolveAll(mergeRequestId, discussionId);
      }

      promise.then(function (resp) {
        return resp.json();
      }).then(function (data) {
        discussion.loading = false;
        var resolvedBy = data ? data.resolved_by : null;

        if (isResolved) {
          discussion.unResolveAllNotes();
        } else {
          discussion.resolveAllNotes(resolvedBy);
        }

        if (gl.mrWidget) gl.mrWidget.checkStatus();
        discussion.updateHeadline(data);
        document.dispatchEvent(new CustomEvent('refreshVueNotes'));
      }).catch(function () {
        return new __WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */]('An error occurred when trying to resolve a discussion. Please try again.');
      });
    }
  }, {
    key: 'resolveAll',
    value: function resolveAll(mergeRequestId, discussionId) {
      var discussion = CommentsStore.state[discussionId];

      discussion.loading = true;

      return this.discussionResource.save({
        mergeRequestId: mergeRequestId,
        discussionId: discussionId
      }, {});
    }
  }, {
    key: 'unResolveAll',
    value: function unResolveAll(mergeRequestId, discussionId) {
      var discussion = CommentsStore.state[discussionId];

      discussion.loading = true;

      return this.discussionResource.delete({
        mergeRequestId: mergeRequestId,
        discussionId: discussionId
      }, {});
    }
  }]);

  return ResolveServiceClass;
}();

gl.DiffNotesResolveServiceClass = ResolveServiceClass;

/***/ }),

/***/ "./diff_notes/stores/comments.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* eslint-disable object-shorthand, func-names, camelcase, no-restricted-syntax, guard-for-in, comma-dangle, max-len, no-param-reassign */
/* global DiscussionModel */



window.CommentsStore = {
  state: {},
  get: function get(discussionId, noteId) {
    return this.state[discussionId].getNote(noteId);
  },
  createDiscussion: function createDiscussion(discussionId, canResolve) {
    var discussion = this.state[discussionId];
    if (!this.state[discussionId]) {
      discussion = new DiscussionModel(discussionId);
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.state, discussionId, discussion);
    }

    if (canResolve !== undefined) {
      discussion.canResolve = canResolve;
    }

    return discussion;
  },
  create: function create(noteObj) {
    var discussion = this.createDiscussion(noteObj.discussionId);

    discussion.createNote(noteObj);
  },
  update: function update(discussionId, noteId, resolved, resolved_by) {
    var discussion = this.state[discussionId];
    var note = discussion.getNote(noteId);
    note.resolved = resolved;
    note.resolved_by = resolved_by;
  },
  delete: function _delete(discussionId, noteId) {
    var discussion = this.state[discussionId];
    discussion.deleteNote(noteId);

    if (discussion.notesCount() === 0) {
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].delete(this.state, discussionId);
    }
  },
  unresolvedDiscussionIds: function unresolvedDiscussionIds() {
    var ids = [];

    for (var discussionId in this.state) {
      var discussion = this.state[discussionId];

      if (!discussion.isResolved()) {
        ids.push(discussion.id);
      }
    }

    return ids;
  }
};

/***/ }),

/***/ "./droplab/plugins/input_setter.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */

var InputSetter = {
  init: function init(hook) {
    this.hook = hook;
    this.destroyed = false;
    this.config = hook.config.InputSetter || (this.hook.config.InputSetter = {});

    this.eventWrapper = {};

    this.addEvents();
  },
  addEvents: function addEvents() {
    this.eventWrapper.setInputs = this.setInputs.bind(this);
    this.hook.list.list.addEventListener('click.dl', this.eventWrapper.setInputs);
  },
  removeEvents: function removeEvents() {
    this.hook.list.list.removeEventListener('click.dl', this.eventWrapper.setInputs);
  },
  setInputs: function setInputs(e) {
    var _this = this;

    if (this.destroyed) return;

    var selectedItem = e.detail.selected;

    if (!Array.isArray(this.config)) this.config = [this.config];

    this.config.forEach(function (config) {
      return _this.setInput(config, selectedItem);
    });
  },
  setInput: function setInput(config, selectedItem) {
    var input = config.input || this.hook.trigger;
    var newValue = selectedItem.getAttribute(config.valueAttribute);
    var inputAttribute = config.inputAttribute;

    if (input.hasAttribute(inputAttribute)) return input.setAttribute(inputAttribute, newValue);
    if (input.tagName === 'INPUT') return input.value = newValue;
    return input.textContent = newValue;
  },
  destroy: function destroy() {
    this.destroyed = true;

    this.removeEvents();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (InputSetter);

/***/ }),

/***/ "./dropzone_input.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = dropzoneInput;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dropzone__ = __webpack_require__("../../../node_modules/dropzone/dist/dropzone.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__preview_markdown__ = __webpack_require__("./preview_markdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_csrf__ = __webpack_require__("./lib/utils/csrf.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");






__WEBPACK_IMPORTED_MODULE_0_dropzone___default.a.autoDiscover = false;

function dropzoneInput(form) {
  var divHover = '<div class="div-dropzone-hover"></div>';
  var iconPaperclip = '<i class="fa fa-paperclip div-dropzone-icon"></i>';
  var $attachButton = form.find('.button-attach-file');
  var $attachingFileMessage = form.find('.attaching-file-message');
  var $cancelButton = form.find('.button-cancel-uploading-files');
  var $retryLink = form.find('.retry-uploading-link');
  var $uploadProgress = form.find('.uploading-progress');
  var $uploadingErrorContainer = form.find('.uploading-error-container');
  var $uploadingErrorMessage = form.find('.uploading-error-message');
  var $uploadingProgressContainer = form.find('.uploading-progress-container');
  var uploadsPath = window.uploads_path || null;
  var maxFileSize = gon.max_file_size || 10;
  var formTextarea = form.find('.js-gfm-input');
  var handlePaste = void 0;
  var pasteText = void 0;
  var addFileToForm = void 0;
  var updateAttachingMessage = void 0;
  var isImage = void 0;
  var getFilename = void 0;
  var uploadFile = void 0;

  formTextarea.wrap('<div class="div-dropzone"></div>');
  formTextarea.on('paste', function (event) {
    return handlePaste(event);
  });

  // Add dropzone area to the form.
  var $mdArea = formTextarea.closest('.md-area');
  form.setupMarkdownPreview();
  var $formDropzone = form.find('.div-dropzone');
  $formDropzone.parent().addClass('div-dropzone-wrapper');
  $formDropzone.append(divHover);
  $formDropzone.find('.div-dropzone-hover').append(iconPaperclip);

  if (!uploadsPath) {
    $formDropzone.addClass('js-invalid-dropzone');
    return;
  }

  var dropzone = $formDropzone.dropzone({
    url: uploadsPath,
    dictDefaultMessage: '',
    clickable: true,
    paramName: 'file',
    maxFilesize: maxFileSize,
    uploadMultiple: false,
    headers: __WEBPACK_IMPORTED_MODULE_3__lib_utils_csrf__["a" /* default */].headers,
    previewContainer: false,
    processing: function processing() {
      return $('.div-dropzone-alert').alert('close');
    },
    dragover: function dragover() {
      $mdArea.addClass('is-dropzone-hover');
      form.find('.div-dropzone-hover').css('opacity', 0.7);
    },
    dragleave: function dragleave() {
      $mdArea.removeClass('is-dropzone-hover');
      form.find('.div-dropzone-hover').css('opacity', 0);
    },
    drop: function drop() {
      $mdArea.removeClass('is-dropzone-hover');
      form.find('.div-dropzone-hover').css('opacity', 0);
      formTextarea.focus();
    },
    success: function success(header, response) {
      var processingFileCount = this.getQueuedFiles().length + this.getUploadingFiles().length;
      var shouldPad = processingFileCount >= 1;

      pasteText(response.link.markdown, shouldPad);
      // Show 'Attach a file' link only when all files have been uploaded.
      if (!processingFileCount) $attachButton.removeClass('hide');
      addFileToForm(response.link.url);
    },

    error: function error(file) {
      var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Attaching the file failed.';
      var xhr = arguments[2];

      // If 'error' event is fired by dropzone, the second parameter is error message.
      // If the 'errorMessage' parameter is empty, the default error message is set.
      // If the 'error' event is fired by backend (xhr) error response, the third parameter is
      // xhr object (xhr.responseText is error message).
      // On error we hide the 'Attach' and 'Cancel' buttons
      // and show an error.

      // If there's xhr error message, let's show it instead of dropzone's one.
      var message = xhr ? xhr.responseText : errorMessage;

      $uploadingErrorContainer.removeClass('hide');
      $uploadingErrorMessage.html(message);
      $attachButton.addClass('hide');
      $cancelButton.addClass('hide');
    },
    totaluploadprogress: function totaluploadprogress(totalUploadProgress) {
      updateAttachingMessage(this.files, $attachingFileMessage);
      $uploadProgress.text(Math.round(totalUploadProgress) + '%');
    },

    sending: function sending() {
      // DOM elements already exist.
      // Instead of dynamically generating them,
      // we just either hide or show them.
      $attachButton.addClass('hide');
      $uploadingErrorContainer.addClass('hide');
      $uploadingProgressContainer.removeClass('hide');
      $cancelButton.removeClass('hide');
    },
    removedfile: function removedfile() {
      $attachButton.removeClass('hide');
      $cancelButton.addClass('hide');
      $uploadingProgressContainer.addClass('hide');
      $uploadingErrorContainer.addClass('hide');
    },
    queuecomplete: function queuecomplete() {
      $('.dz-preview').remove();
      $('.markdown-area').trigger('input');

      $uploadingProgressContainer.addClass('hide');
      $cancelButton.addClass('hide');
    }
  });

  var child = $(dropzone[0]).children('textarea');

  // removeAllFiles(true) stops uploading files (if any)
  // and remove them from dropzone files queue.
  $cancelButton.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    __WEBPACK_IMPORTED_MODULE_0_dropzone___default.a.forElement($formDropzone.get(0)).removeAllFiles(true);
  });

  // If 'error' event is fired, we store a failed files,
  // clear dropzone files queue, change status of failed files to undefined,
  // and add that files to the dropzone files queue again.
  // addFile() adds file to dropzone files queue and upload it.
  $retryLink.on('click', function (e) {
    var dropzoneInstance = __WEBPACK_IMPORTED_MODULE_0_dropzone___default.a.forElement(e.target.closest('.js-main-target-form').querySelector('.div-dropzone'));
    var failedFiles = dropzoneInstance.files;

    e.preventDefault();

    // 'true' parameter of removeAllFiles() cancels
    // uploading of files that are being uploaded at the moment.
    dropzoneInstance.removeAllFiles(true);

    failedFiles.map(function (failedFile) {
      var file = failedFile;

      if (file.status === __WEBPACK_IMPORTED_MODULE_0_dropzone___default.a.ERROR) {
        file.status = undefined;
        file.accepted = undefined;
      }

      return dropzoneInstance.addFile(file);
    });
  });
  // eslint-disable-next-line consistent-return
  handlePaste = function handlePaste(event) {
    var pasteEvent = event.originalEvent;
    if (pasteEvent.clipboardData && pasteEvent.clipboardData.items) {
      var image = isImage(pasteEvent);
      if (image) {
        event.preventDefault();
        var filename = getFilename(pasteEvent) || 'image.png';
        var text = '{{' + filename + '}}';
        pasteText(text);
        return uploadFile(image.getAsFile(), filename);
      }
    }
  };

  isImage = function isImage(data) {
    var i = 0;
    while (i < data.clipboardData.items.length) {
      var item = data.clipboardData.items[i];
      if (item.type.indexOf('image') !== -1) {
        return item;
      }
      i += 1;
    }
    return false;
  };

  pasteText = function pasteText(text, shouldPad) {
    var formattedText = text;
    if (shouldPad) {
      formattedText += '\n\n';
    }
    var textarea = child.get(0);
    var caretStart = textarea.selectionStart;
    var caretEnd = textarea.selectionEnd;
    var textEnd = $(child).val().length;
    var beforeSelection = $(child).val().substring(0, caretStart);
    var afterSelection = $(child).val().substring(caretEnd, textEnd);
    $(child).val(beforeSelection + formattedText + afterSelection);
    textarea.setSelectionRange(caretStart + formattedText.length, caretEnd + formattedText.length);
    textarea.style.height = textarea.scrollHeight + 'px';
    formTextarea.get(0).dispatchEvent(new Event('input'));
    return formTextarea.trigger('input');
  };

  addFileToForm = function addFileToForm(path) {
    $(form).append('<input type="hidden" name="files[]" value="' + __WEBPACK_IMPORTED_MODULE_1_underscore___default.a.escape(path) + '">');
  };

  getFilename = function getFilename(e) {
    var value = void 0;
    if (window.clipboardData && window.clipboardData.getData) {
      value = window.clipboardData.getData('Text');
    } else if (e.clipboardData && e.clipboardData.getData) {
      value = e.clipboardData.getData('text/plain');
    }
    value = value.split('\r');
    return value[0];
  };

  var showSpinner = function showSpinner() {
    return $uploadingProgressContainer.removeClass('hide');
  };

  var closeSpinner = function closeSpinner() {
    return $uploadingProgressContainer.addClass('hide');
  };

  var showError = function showError(message) {
    $uploadingErrorContainer.removeClass('hide');
    $uploadingErrorMessage.html(message);
  };

  var closeAlertMessage = function closeAlertMessage() {
    return form.find('.div-dropzone-alert').alert('close');
  };

  var insertToTextArea = function insertToTextArea(filename, url) {
    var $child = $(child);
    $child.val(function (index, val) {
      return val.replace('{{' + filename + '}}', url);
    });

    $child.trigger('change');
  };

  uploadFile = function uploadFile(item, filename) {
    var formData = new FormData();
    formData.append('file', item, filename);

    showSpinner();
    closeAlertMessage();

    __WEBPACK_IMPORTED_MODULE_4__lib_utils_axios_utils__["a" /* default */].post(uploadsPath, formData).then(function (_ref) {
      var data = _ref.data;

      var md = data.link.markdown;

      insertToTextArea(filename, md);
      closeSpinner();
    }).catch(function (e) {
      showError(e.response.data.message);
      closeSpinner();
    });
  };

  updateAttachingMessage = function updateAttachingMessage(files, messageContainer) {
    var attachingMessage = void 0;
    var filesCount = files.filter(function (file) {
      return file.status === 'uploading' || file.status === 'queued';
    }).length;

    // Dinamycally change uploading files text depending on files number in
    // dropzone files queue.
    if (filesCount > 1) {
      attachingMessage = 'Attaching ' + filesCount + ' files -';
    } else {
      attachingMessage = 'Attaching a file -';
    }

    messageContainer.text(attachingMessage);
  };

  form.find('.markdown-selector').click(function onMarkdownClick(e) {
    e.preventDefault();
    $(this).closest('.gfm-form').find('.div-dropzone').click();
    formTextarea.focus();
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./files_comment_button.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* Developer beware! Do not add logic to showButton or hideButton
 * that will force a reflow. Doing so will create a signficant performance
 * bottleneck for pages with large diffs. For a comprehensive list of what
 * causes reflows, visit https://gist.github.com/paulirish/5d52fb081b3570c81e3a
 */



var LINE_NUMBER_CLASS = 'diff-line-num';
var UNFOLDABLE_LINE_CLASS = 'js-unfold';
var NO_COMMENT_CLASS = 'no-comment-btn';
var EMPTY_CELL_CLASS = 'empty-cell';
var OLD_LINE_CLASS = 'old_line';
var LINE_COLUMN_CLASSES = '.' + LINE_NUMBER_CLASS + ', .line_content';
var DIFF_CONTAINER_SELECTOR = '.files';
var DIFF_EXPANDED_CLASS = 'diff-expanded';

/* harmony default export */ __webpack_exports__["a"] = ({
  init: function init($diffFile) {
    var _this = this;

    /* Caching is used only when the following members are *true*.
     * This is because there are likely to be
     * differently configured versions of diffs in the same session.
     * However if these values are true, they
     * will be true in all cases */

    if (!this.userCanCreateNote) {
      // data-can-create-note is an empty string when true, otherwise undefined
      this.userCanCreateNote = $diffFile.closest(DIFF_CONTAINER_SELECTOR).data('canCreateNote') === '';
    }

    this.isParallelView = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('diff_view') === 'parallel';

    if (this.userCanCreateNote) {
      $diffFile.on('mouseover', LINE_COLUMN_CLASSES, function (e) {
        return _this.showButton(_this.isParallelView, e);
      }).on('mouseleave', LINE_COLUMN_CLASSES, function (e) {
        return _this.hideButton(_this.isParallelView, e);
      });
    }
  },
  showButton: function showButton(isParallelView, e) {
    var buttonParentElement = this.getButtonParent(e.currentTarget, isParallelView);

    if (!this.validateButtonParent(buttonParentElement)) return;

    buttonParentElement.classList.add('is-over');
    buttonParentElement.nextElementSibling.classList.add('is-over');
  },
  hideButton: function hideButton(isParallelView, e) {
    var buttonParentElement = this.getButtonParent(e.currentTarget, isParallelView);

    buttonParentElement.classList.remove('is-over');
    buttonParentElement.nextElementSibling.classList.remove('is-over');
  },
  getButtonParent: function getButtonParent(hoveredElement, isParallelView) {
    if (isParallelView) {
      if (!hoveredElement.classList.contains(LINE_NUMBER_CLASS)) {
        return hoveredElement.previousElementSibling;
      }
    } else if (!hoveredElement.classList.contains(OLD_LINE_CLASS)) {
      return hoveredElement.parentNode.querySelector('.' + OLD_LINE_CLASS);
    }
    return hoveredElement;
  },
  validateButtonParent: function validateButtonParent(buttonParentElement) {
    return !buttonParentElement.classList.contains(EMPTY_CELL_CLASS) && !buttonParentElement.classList.contains(UNFOLDABLE_LINE_CLASS) && !buttonParentElement.classList.contains(NO_COMMENT_CLASS) && !buttonParentElement.parentNode.classList.contains(DIFF_EXPANDED_CLASS);
  }
});

/***/ }),

/***/ "./gl_form.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_autosize__ = __webpack_require__("../../../node_modules/autosize/dist/autosize.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gfm_auto_complete__ = __webpack_require__("./gfm_auto_complete.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dropzone_input__ = __webpack_require__("./dropzone_input.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_utils_text_markdown__ = __webpack_require__("./lib/utils/text_markdown.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var GLForm = function () {
  function GLForm(form) {
    var enableGFM = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, GLForm);

    this.form = form;
    this.textarea = this.form.find('textarea.js-gfm-input');
    this.enableGFM = enableGFM;
    // Before we start, we should clean up any previous data for this form
    this.destroy();
    // Setup the form
    this.setupForm();
    this.form.data('glForm', this);
  }

  _createClass(GLForm, [{
    key: 'destroy',
    value: function destroy() {
      // Clean form listeners
      this.clearEventListeners();
      if (this.autoComplete) {
        this.autoComplete.destroy();
      }
      this.form.data('glForm', null);
    }
  }, {
    key: 'setupForm',
    value: function setupForm() {
      var isNewForm = this.form.is(':not(.gfm-form)');
      this.form.removeClass('js-new-note-form');
      if (isNewForm) {
        this.form.find('.div-dropzone').remove();
        this.form.addClass('gfm-form');
        // remove notify commit author checkbox for non-commit notes
        gl.utils.disableButtonIfEmptyField(this.form.find('.js-note-text'), this.form.find('.js-comment-button, .js-note-new-discussion'));
        this.autoComplete = new __WEBPACK_IMPORTED_MODULE_1__gfm_auto_complete__["a" /* default */](gl.GfmAutoComplete && gl.GfmAutoComplete.dataSources);
        this.autoComplete.setup(this.form.find('.js-gfm-input'), {
          emojis: true,
          members: this.enableGFM,
          issues: this.enableGFM,
          milestones: this.enableGFM,
          mergeRequests: this.enableGFM,
          labels: this.enableGFM
        });
        Object(__WEBPACK_IMPORTED_MODULE_2__dropzone_input__["a" /* default */])(this.form);
        __WEBPACK_IMPORTED_MODULE_0_autosize___default()(this.textarea);
      }
      // form and textarea event listeners
      this.addEventListeners();
      __WEBPACK_IMPORTED_MODULE_3__lib_utils_text_markdown__["a" /* default */].init(this.form);
      // hide discard button
      this.form.find('.js-note-discard').hide();
      this.form.show();
      if (this.isAutosizeable) this.setupAutosize();
    }
  }, {
    key: 'setupAutosize',
    value: function setupAutosize() {
      var _this = this;

      this.textarea.off('autosize:resized').on('autosize:resized', this.setHeightData.bind(this));

      this.textarea.off('mouseup.autosize').on('mouseup.autosize', this.destroyAutosize.bind(this));

      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_autosize___default()(_this.textarea);
        _this.textarea.css('resize', 'vertical');
      }, 0);
    }
  }, {
    key: 'setHeightData',
    value: function setHeightData() {
      this.textarea.data('height', this.textarea.outerHeight());
    }
  }, {
    key: 'destroyAutosize',
    value: function destroyAutosize() {
      var outerHeight = this.textarea.outerHeight();

      if (this.textarea.data('height') === outerHeight) return;

      __WEBPACK_IMPORTED_MODULE_0_autosize___default.a.destroy(this.textarea);

      this.textarea.data('height', outerHeight);
      this.textarea.outerHeight(outerHeight);
      this.textarea.css('max-height', window.outerHeight);
    }
  }, {
    key: 'clearEventListeners',
    value: function clearEventListeners() {
      this.textarea.off('focus');
      this.textarea.off('blur');
      __WEBPACK_IMPORTED_MODULE_3__lib_utils_text_markdown__["a" /* default */].removeListeners(this.form);
    }
  }, {
    key: 'addEventListeners',
    value: function addEventListeners() {
      this.textarea.on('focus', function focusTextArea() {
        $(this).closest('.md-area').addClass('is-focused');
      });
      this.textarea.on('blur', function blurTextArea() {
        $(this).closest('.md-area').removeClass('is-focused');
      });
    }
  }]);

  return GLForm;
}();

/* harmony default export */ __webpack_exports__["a"] = (GLForm);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./image_diff/helpers/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./image_diff/helpers/badge_helper.js
function createImageBadge(noteId, _ref) {
  var x = _ref.x,
      y = _ref.y;
  var classNames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var buttonEl = document.createElement('button');
  var classList = classNames.concat(['js-image-badge']);
  classList.forEach(function (className) {
    return buttonEl.classList.add(className);
  });
  buttonEl.setAttribute('type', 'button');
  buttonEl.setAttribute('disabled', true);
  buttonEl.dataset.noteId = noteId;
  buttonEl.style.left = x + 'px';
  buttonEl.style.top = y + 'px';

  return buttonEl;
}

function addImageBadge(containerEl, _ref2) {
  var coordinate = _ref2.coordinate,
      badgeText = _ref2.badgeText,
      noteId = _ref2.noteId;

  var buttonEl = createImageBadge(noteId, coordinate, ['badge']);
  buttonEl.innerText = badgeText;

  containerEl.appendChild(buttonEl);
}

function addImageCommentBadge(containerEl, _ref3) {
  var coordinate = _ref3.coordinate,
      noteId = _ref3.noteId;

  var buttonEl = createImageBadge(noteId, coordinate, ['image-comment-badge']);
  buttonEl.innerHTML = gl.utils.spriteIcon('image-comment-dark');

  containerEl.appendChild(buttonEl);
}

function addAvatarBadge(el, event) {
  var _event$detail = event.detail,
      noteId = _event$detail.noteId,
      badgeNumber = _event$detail.badgeNumber;

  // Add badge to new comment

  var avatarBadgeEl = el.querySelector('#' + noteId + ' .badge');
  avatarBadgeEl.innerText = badgeNumber;
  avatarBadgeEl.classList.remove('hidden');
}
// CONCATENATED MODULE: ./image_diff/helpers/comment_indicator_helper.js
function addCommentIndicator(containerEl, _ref) {
  var x = _ref.x,
      y = _ref.y;

  var buttonEl = document.createElement('button');
  buttonEl.classList.add('btn-transparent');
  buttonEl.classList.add('comment-indicator');
  buttonEl.setAttribute('type', 'button');
  buttonEl.style.left = x + 'px';
  buttonEl.style.top = y + 'px';

  buttonEl.innerHTML = gl.utils.spriteIcon('image-comment-dark');

  containerEl.appendChild(buttonEl);
}

function removeCommentIndicator(imageFrameEl) {
  var commentIndicatorEl = imageFrameEl.querySelector('.comment-indicator');
  var imageEl = imageFrameEl.querySelector('img');
  var willRemove = !!commentIndicatorEl;
  var meta = {};

  if (willRemove) {
    meta = {
      x: parseInt(commentIndicatorEl.style.left, 10),
      y: parseInt(commentIndicatorEl.style.top, 10),
      image: {
        width: imageEl.width,
        height: imageEl.height
      }
    };

    commentIndicatorEl.remove();
  }

  return Object.assign({}, meta, {
    removed: willRemove
  });
}

function showCommentIndicator(imageFrameEl, coordinate) {
  var x = coordinate.x,
      y = coordinate.y;

  var commentIndicatorEl = imageFrameEl.querySelector('.comment-indicator');

  if (commentIndicatorEl) {
    commentIndicatorEl.style.left = x + 'px';
    commentIndicatorEl.style.top = y + 'px';
  } else {
    addCommentIndicator(imageFrameEl, coordinate);
  }
}

function commentIndicatorOnClick(event) {
  // Prevent from triggering onAddImageDiffNote in notes.js
  event.stopPropagation();

  var buttonEl = event.currentTarget;
  var diffViewerEl = buttonEl.closest('.diff-viewer');
  var textareaEl = diffViewerEl.querySelector('.note-container .note-textarea');
  textareaEl.focus();
}
// CONCATENATED MODULE: ./image_diff/helpers/dom_helper.js
function setPositionDataAttribute(el, options) {
  // Update position data attribute so that the
  // new comment form can use this data for ajax request
  var x = options.x,
      y = options.y,
      width = options.width,
      height = options.height;

  var position = el.dataset.position;
  var positionObject = Object.assign({}, JSON.parse(position), {
    x: x,
    y: y,
    width: width,
    height: height
  });

  el.setAttribute('data-position', JSON.stringify(positionObject));
}

function updateDiscussionAvatarBadgeNumber(discussionEl, newBadgeNumber) {
  var avatarBadgeEl = discussionEl.querySelector('.image-diff-avatar-link .badge');
  avatarBadgeEl.innerText = newBadgeNumber;
}

function updateDiscussionBadgeNumber(discussionEl, newBadgeNumber) {
  var discussionBadgeEl = discussionEl.querySelector('.badge');
  discussionBadgeEl.innerText = newBadgeNumber;
}

function toggleCollapsed(event) {
  var toggleButtonEl = event.currentTarget;
  var discussionNotesEl = toggleButtonEl.closest('.discussion-notes');
  var formEl = discussionNotesEl.querySelector('.discussion-form');
  var isCollapsed = discussionNotesEl.classList.contains('collapsed');

  if (isCollapsed) {
    discussionNotesEl.classList.remove('collapsed');
  } else {
    discussionNotesEl.classList.add('collapsed');
  }

  // Override the inline display style set in notes.js
  if (formEl && !isCollapsed) {
    formEl.style.display = 'none';
  } else if (formEl && isCollapsed) {
    formEl.style.display = 'block';
  }
}
// EXTERNAL MODULE: ./image_diff/image_badge.js
var image_badge = __webpack_require__("./image_diff/image_badge.js");

// EXTERNAL MODULE: ./image_diff/image_diff.js
var image_diff = __webpack_require__("./image_diff/image_diff.js");

// CONCATENATED MODULE: ./image_diff/view_types.js
var viewTypes = {
  TWO_UP: 'TWO_UP',
  SWIPE: 'SWIPE',
  ONION_SKIN: 'ONION_SKIN'
};

function isValidViewType(validate) {
  return !!Object.getOwnPropertyNames(viewTypes).find(function (viewType) {
    return viewType === validate;
  });
}
// CONCATENATED MODULE: ./image_diff/replaced_image_diff.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var replaced_image_diff_ReplacedImageDiff = function (_ImageDiff) {
  _inherits(ReplacedImageDiff, _ImageDiff);

  function ReplacedImageDiff() {
    _classCallCheck(this, ReplacedImageDiff);

    return _possibleConstructorReturn(this, (ReplacedImageDiff.__proto__ || Object.getPrototypeOf(ReplacedImageDiff)).apply(this, arguments));
  }

  _createClass(ReplacedImageDiff, [{
    key: 'init',
    value: function init() {
      var _imageFrameEls, _viewModesEls;

      var defaultViewType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : viewTypes.TWO_UP;

      this.imageFrameEls = (_imageFrameEls = {}, _defineProperty(_imageFrameEls, viewTypes.TWO_UP, this.el.querySelector('.two-up .js-image-frame')), _defineProperty(_imageFrameEls, viewTypes.SWIPE, this.el.querySelector('.swipe .js-image-frame')), _defineProperty(_imageFrameEls, viewTypes.ONION_SKIN, this.el.querySelector('.onion-skin .js-image-frame')), _imageFrameEls);

      var viewModesEl = this.el.querySelector('.view-modes-menu');
      this.viewModesEls = (_viewModesEls = {}, _defineProperty(_viewModesEls, viewTypes.TWO_UP, viewModesEl.querySelector('.two-up')), _defineProperty(_viewModesEls, viewTypes.SWIPE, viewModesEl.querySelector('.swipe')), _defineProperty(_viewModesEls, viewTypes.ONION_SKIN, viewModesEl.querySelector('.onion-skin')), _viewModesEls);

      this.currentView = defaultViewType;
      this.generateImageEls();
      this.bindEvents();
    }
  }, {
    key: 'generateImageEls',
    value: function generateImageEls() {
      var _this2 = this;

      this.imageEls = {};

      var viewTypeNames = Object.getOwnPropertyNames(viewTypes);
      viewTypeNames.forEach(function (viewType) {
        _this2.imageEls[viewType] = _this2.imageFrameEls[viewType].querySelector('img');
      });
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      _get(ReplacedImageDiff.prototype.__proto__ || Object.getPrototypeOf(ReplacedImageDiff.prototype), 'bindEvents', this).call(this);

      this.changeToViewTwoUp = this.changeView.bind(this, viewTypes.TWO_UP);
      this.changeToViewSwipe = this.changeView.bind(this, viewTypes.SWIPE);
      this.changeToViewOnionSkin = this.changeView.bind(this, viewTypes.ONION_SKIN);

      this.viewModesEls[viewTypes.TWO_UP].addEventListener('click', this.changeToViewTwoUp);
      this.viewModesEls[viewTypes.SWIPE].addEventListener('click', this.changeToViewSwipe);
      this.viewModesEls[viewTypes.ONION_SKIN].addEventListener('click', this.changeToViewOnionSkin);
    }
  }, {
    key: 'changeView',
    value: function changeView(newView) {
      if (!isValidViewType(newView)) {
        return;
      }

      var indicator = helpers.removeCommentIndicator(this.imageFrameEl);

      this.currentView = newView;

      // Clear existing badges on new view
      var existingBadges = this.imageFrameEl.querySelectorAll('.badge');
      [].concat(_toConsumableArray(existingBadges)).map(function (badge) {
        return badge.remove();
      });

      // Remove existing references to old view image badges
      this.imageBadges = [];

      // Image_file.js has a fade animation of 200ms for loading the view
      // Need to wait an additional 250ms for the images to be displayed
      // on window in order to re-normalize their dimensions
      setTimeout(this.renderNewView.bind(this, indicator), 250);
    }
  }, {
    key: 'renderNewView',
    value: function renderNewView(indicator) {
      // Generate badge coordinates on new view
      this.renderBadges();

      // Re-render indicator in new view
      if (indicator.removed) {
        var normalizedIndicator = helpers.resizeCoordinatesToImageElement(this.imageEl, {
          x: indicator.x,
          y: indicator.y,
          width: indicator.image.width,
          height: indicator.image.height
        });
        helpers.showCommentIndicator(this.imageFrameEl, normalizedIndicator);
      }
    }
  }, {
    key: 'imageEl',
    get: function get() {
      return this.imageEls[this.currentView];
    }
  }, {
    key: 'imageFrameEl',
    get: function get() {
      return this.imageFrameEls[this.currentView];
    }
  }]);

  return ReplacedImageDiff;
}(image_diff["a" /* default */]);

/* harmony default export */ var replaced_image_diff = (replaced_image_diff_ReplacedImageDiff);
// EXTERNAL MODULE: ./commit/image_file.js
var image_file = __webpack_require__("./commit/image_file.js");

// CONCATENATED MODULE: ./image_diff/helpers/utils_helper.js





function resizeCoordinatesToImageElement(imageEl, meta) {
  var x = meta.x,
      y = meta.y,
      width = meta.width,
      height = meta.height;


  var imageWidth = imageEl.width;
  var imageHeight = imageEl.height;

  var widthRatio = imageWidth / width;
  var heightRatio = imageHeight / height;

  return {
    x: Math.round(x * widthRatio),
    y: Math.round(y * heightRatio),
    width: imageWidth,
    height: imageHeight
  };
}

function generateBadgeFromDiscussionDOM(imageFrameEl, discussionEl) {
  var position = JSON.parse(discussionEl.dataset.position);
  var firstNoteEl = discussionEl.querySelector('.note');
  var badge = new image_badge["a" /* default */]({
    actual: position,
    imageEl: imageFrameEl.querySelector('img'),
    noteId: firstNoteEl.id,
    discussionId: discussionEl.dataset.discussionId
  });

  return badge;
}

function getTargetSelection(event) {
  var containerEl = event.currentTarget;
  var imageEl = containerEl.querySelector('img');

  var x = event.offsetX;
  var y = event.offsetY;

  var width = imageEl.width;
  var height = imageEl.height;

  var actualWidth = imageEl.naturalWidth;
  var actualHeight = imageEl.naturalHeight;

  var widthRatio = actualWidth / width;
  var heightRatio = actualHeight / height;

  // Browser will include the frame as a clickable target,
  // which would result in potential 1px out of bounds value
  // This bound the coordinates to inside the frame
  var normalizedX = Math.max(0, x) && Math.min(x, width);
  var normalizedY = Math.max(0, y) && Math.min(y, height);

  return {
    browser: {
      x: normalizedX,
      y: normalizedY,
      width: width,
      height: height
    },
    actual: {
      // Round x, y so that we don't need to deal with decimals
      x: Math.round(normalizedX * widthRatio),
      y: Math.round(normalizedY * heightRatio),
      width: actualWidth,
      height: actualHeight
    }
  };
}

function initImageDiff(fileEl, canCreateNote, renderCommentBadge) {
  var options = {
    canCreateNote: canCreateNote,
    renderCommentBadge: renderCommentBadge
  };
  var diff = void 0;

  // ImageFile needs to be invoked before initImageDiff so that badges
  // can mount to the correct location
  new image_file["a" /* default */](fileEl); // eslint-disable-line no-new

  if (fileEl.querySelector('.diff-file .js-single-image')) {
    diff = new image_diff["a" /* default */](fileEl, options);
    diff.init();
  } else if (fileEl.querySelector('.diff-file .js-replaced-image')) {
    diff = new replaced_image_diff(fileEl, options);
    diff.init();
  }

  return diff;
}
// CONCATENATED MODULE: ./image_diff/helpers/index.js





/* harmony default export */ var helpers = __webpack_exports__["a"] = ({
  addCommentIndicator: addCommentIndicator,
  removeCommentIndicator: removeCommentIndicator,
  showCommentIndicator: showCommentIndicator,
  commentIndicatorOnClick: commentIndicatorOnClick,

  addImageBadge: addImageBadge,
  addImageCommentBadge: addImageCommentBadge,
  addAvatarBadge: addAvatarBadge,

  setPositionDataAttribute: setPositionDataAttribute,
  updateDiscussionAvatarBadgeNumber: updateDiscussionAvatarBadgeNumber,
  updateDiscussionBadgeNumber: updateDiscussionBadgeNumber,
  toggleCollapsed: toggleCollapsed,

  resizeCoordinatesToImageElement: resizeCoordinatesToImageElement,
  generateBadgeFromDiscussionDOM: generateBadgeFromDiscussionDOM,
  getTargetSelection: getTargetSelection,
  initImageDiff: initImageDiff
});

/***/ }),

/***/ "./image_diff/image_badge.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var defaultMeta = {
  x: 0,
  y: 0,
  width: 0,
  height: 0
};

var ImageBadge = function ImageBadge(options) {
  _classCallCheck(this, ImageBadge);

  var noteId = options.noteId,
      discussionId = options.discussionId;


  this.actual = options.actual || defaultMeta;
  this.browser = options.browser || defaultMeta;
  this.noteId = noteId;
  this.discussionId = discussionId;

  if (options.imageEl && !options.browser) {
    this.browser = __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].resizeCoordinatesToImageElement(options.imageEl, this.actual);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ImageBadge);

/***/ }),

/***/ "./image_diff/image_diff.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__image_badge__ = __webpack_require__("./image_diff/image_badge.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_image_utility__ = __webpack_require__("./lib/utils/image_utility.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var ImageDiff = function () {
  function ImageDiff(el, options) {
    _classCallCheck(this, ImageDiff);

    this.el = el;
    this.canCreateNote = !!(options && options.canCreateNote);
    this.renderCommentBadge = !!(options && options.renderCommentBadge);
    this.$noteContainer = $('.note-container', this.el);
    this.imageBadges = [];
  }

  _createClass(ImageDiff, [{
    key: 'init',
    value: function init() {
      this.imageFrameEl = this.el.querySelector('.diff-file .js-image-frame');
      this.imageEl = this.imageFrameEl.querySelector('img');

      this.bindEvents();
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.imageClickedWrapper = this.imageClicked.bind(this);
      this.imageBlurredWrapper = __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].removeCommentIndicator.bind(null, this.imageFrameEl);
      this.addBadgeWrapper = this.addBadge.bind(this);
      this.removeBadgeWrapper = this.removeBadge.bind(this);
      this.renderBadgesWrapper = this.renderBadges.bind(this);

      // Render badges
      if (Object(__WEBPACK_IMPORTED_MODULE_2__lib_utils_image_utility__["a" /* isImageLoaded */])(this.imageEl)) {
        this.renderBadges();
      } else {
        this.imageEl.addEventListener('load', this.renderBadgesWrapper);
      }

      // jquery makes the event delegation here much simpler
      this.$noteContainer.on('click', '.js-diff-notes-toggle', __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].toggleCollapsed);
      $(this.el).on('click', '.comment-indicator', __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].commentIndicatorOnClick);

      if (this.canCreateNote) {
        this.el.addEventListener('click.imageDiff', this.imageClickedWrapper);
        this.el.addEventListener('blur.imageDiff', this.imageBlurredWrapper);
        this.el.addEventListener('addBadge.imageDiff', this.addBadgeWrapper);
        this.el.addEventListener('removeBadge.imageDiff', this.removeBadgeWrapper);
      }
    }
  }, {
    key: 'imageClicked',
    value: function imageClicked(event) {
      var customEvent = event.detail;
      var selection = __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].getTargetSelection(customEvent);
      var el = customEvent.currentTarget;

      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].setPositionDataAttribute(el, selection.actual);
      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].showCommentIndicator(this.imageFrameEl, selection.browser);
    }
  }, {
    key: 'renderBadges',
    value: function renderBadges() {
      var discussionsEls = this.el.querySelectorAll('.note-container .discussion-notes .notes');
      [].concat(_toConsumableArray(discussionsEls)).forEach(this.renderBadge.bind(this));
    }
  }, {
    key: 'renderBadge',
    value: function renderBadge(discussionEl, index) {
      var imageBadge = __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].generateBadgeFromDiscussionDOM(this.imageFrameEl, discussionEl);

      this.imageBadges.push(imageBadge);

      var options = {
        coordinate: imageBadge.browser,
        noteId: imageBadge.noteId
      };

      if (this.renderCommentBadge) {
        __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].addImageCommentBadge(this.imageFrameEl, options);
      } else {
        var numberBadgeOptions = Object.assign({}, options, {
          badgeText: index + 1
        });

        __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].addImageBadge(this.imageFrameEl, numberBadgeOptions);
      }
    }
  }, {
    key: 'addBadge',
    value: function addBadge(event) {
      var _event$detail = event.detail,
          x = _event$detail.x,
          y = _event$detail.y,
          width = _event$detail.width,
          height = _event$detail.height,
          noteId = _event$detail.noteId,
          discussionId = _event$detail.discussionId;

      var badgeText = this.imageBadges.length + 1;
      var imageBadge = new __WEBPACK_IMPORTED_MODULE_1__image_badge__["a" /* default */]({
        actual: {
          x: x,
          y: y,
          width: width,
          height: height
        },
        imageEl: this.imageFrameEl.querySelector('img'),
        noteId: noteId,
        discussionId: discussionId
      });

      this.imageBadges.push(imageBadge);

      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].addImageBadge(this.imageFrameEl, {
        coordinate: imageBadge.browser,
        badgeText: badgeText,
        noteId: noteId
      });

      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].addAvatarBadge(this.el, {
        detail: {
          noteId: noteId,
          badgeNumber: badgeText
        }
      });

      var discussionEl = this.el.querySelector('#discussion_' + discussionId);
      __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].updateDiscussionBadgeNumber(discussionEl, badgeText);
    }
  }, {
    key: 'removeBadge',
    value: function removeBadge(event) {
      var _this = this;

      var badgeNumber = event.detail.badgeNumber;

      var indexToRemove = badgeNumber - 1;
      var imageBadgeEls = this.imageFrameEl.querySelectorAll('.badge');

      if (this.imageBadges.length !== badgeNumber) {
        // Cascade badges count numbers for (avatar badges + image badges)
        this.imageBadges.forEach(function (badge, index) {
          if (index > indexToRemove) {
            var discussionId = badge.discussionId;

            var updatedBadgeNumber = index;
            var discussionEl = _this.el.querySelector('#discussion_' + discussionId);

            imageBadgeEls[index].innerText = updatedBadgeNumber;

            __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].updateDiscussionBadgeNumber(discussionEl, updatedBadgeNumber);
            __WEBPACK_IMPORTED_MODULE_0__helpers_index__["a" /* default */].updateDiscussionAvatarBadgeNumber(discussionEl, updatedBadgeNumber);
          }
        });
      }

      this.imageBadges.splice(indexToRemove, 1);

      var imageBadgeEl = imageBadgeEls[indexToRemove];
      imageBadgeEl.remove();
    }
  }]);

  return ImageDiff;
}();

/* harmony default export */ __webpack_exports__["a"] = (ImageDiff);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./init_changes_dropdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_sticky__ = __webpack_require__("./lib/utils/sticky.js");


/* harmony default export */ __webpack_exports__["a"] = (function (stickyTop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__lib_utils_sticky__["a" /* default */])(document.querySelector('.js-diff-files-changed'), stickyTop);

  $('.js-diff-stats-dropdown').glDropdown({
    filterable: true,
    remoteFilter: false
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./init_notes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notes__ = __webpack_require__("./notes.js");


/* harmony default export */ __webpack_exports__["a"] = (function () {
  var dataEl = document.querySelector('.js-notes-data');

  var _JSON$parse = JSON.parse(dataEl.innerHTML),
      notesUrl = _JSON$parse.notesUrl,
      notesIds = _JSON$parse.notesIds,
      now = _JSON$parse.now,
      diffView = _JSON$parse.diffView,
      autocomplete = _JSON$parse.autocomplete;

  // Create a singleton so that we don't need to assign
  // into the window object, we can just access the current isntance with Notes.instance


  __WEBPACK_IMPORTED_MODULE_0__notes__["a" /* default */].initialize(notesUrl, notesIds, now, diffView, autocomplete);
});

/***/ }),

/***/ "./lib/utils/image_utility.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isImageLoaded;
/* eslint-disable import/prefer-default-export */

function isImageLoaded(element) {
  return element.complete && element.naturalHeight !== 0;
}

/***/ }),

/***/ "./lib/utils/sticky.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createPlaceholder */
/* unused harmony export isSticky */
var createPlaceholder = function createPlaceholder() {
  var placeholder = document.createElement('div');
  placeholder.classList.add('sticky-placeholder');

  return placeholder;
};

var isSticky = function isSticky(el, scrollY, stickyTop, insertPlaceholder) {
  var top = Math.floor(el.offsetTop - scrollY);

  if (top <= stickyTop && !el.classList.contains('is-stuck')) {
    var placeholder = insertPlaceholder ? createPlaceholder() : null;
    var heightBefore = el.offsetHeight;

    el.classList.add('is-stuck');

    if (insertPlaceholder) {
      el.parentNode.insertBefore(placeholder, el.nextElementSibling);

      placeholder.style.height = heightBefore - el.offsetHeight + 'px';
    }
  } else if (top > stickyTop && el.classList.contains('is-stuck')) {
    el.classList.remove('is-stuck');

    if (insertPlaceholder && el.nextElementSibling && el.nextElementSibling.classList.contains('sticky-placeholder')) {
      el.nextElementSibling.remove();
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function (el, stickyTop) {
  var insertPlaceholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!el) return;

  if (typeof CSS === 'undefined' || !CSS.supports('(position: -webkit-sticky) or (position: sticky)')) return;

  document.addEventListener('scroll', function () {
    return isSticky(el, window.scrollY, stickyTop, insertPlaceholder);
  }, {
    passive: true
  });
});

/***/ }),

/***/ "./lib/utils/text_markdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable import/prefer-default-export, func-names, space-before-function-paren, wrap-iife, no-var, no-param-reassign, no-cond-assign, quotes, one-var, one-var-declaration-per-line, operator-assignment, no-else-return, prefer-template, prefer-arrow-callback, no-empty, max-len, consistent-return, no-unused-vars, no-return-assign, max-len, vars-on-top */

var textUtils = {};

textUtils.selectedText = function (text, textarea) {
  return text.substring(textarea.selectionStart, textarea.selectionEnd);
};

textUtils.lineBefore = function (text, textarea) {
  var split;
  split = text.substring(0, textarea.selectionStart).trim().split('\n');
  return split[split.length - 1];
};

textUtils.lineAfter = function (text, textarea) {
  return text.substring(textarea.selectionEnd).trim().split('\n')[0];
};

textUtils.blockTagText = function (text, textArea, blockTag, selected) {
  var lineAfter, lineBefore;
  lineBefore = this.lineBefore(text, textArea);
  lineAfter = this.lineAfter(text, textArea);
  if (lineBefore === blockTag && lineAfter === blockTag) {
    // To remove the block tag we have to select the line before & after
    if (blockTag != null) {
      textArea.selectionStart = textArea.selectionStart - (blockTag.length + 1);
      textArea.selectionEnd = textArea.selectionEnd + (blockTag.length + 1);
    }
    return selected;
  } else {
    return blockTag + "\n" + selected + "\n" + blockTag;
  }
};

textUtils.insertText = function (textArea, text, tag, blockTag, selected, wrap) {
  var insertText, inserted, selectedSplit, startChar, removedLastNewLine, removedFirstNewLine, currentLineEmpty, lastNewLine;
  removedLastNewLine = false;
  removedFirstNewLine = false;
  currentLineEmpty = false;

  // Remove the first newline
  if (selected.indexOf('\n') === 0) {
    removedFirstNewLine = true;
    selected = selected.replace(/\n+/, '');
  }

  // Remove the last newline
  if (textArea.selectionEnd - textArea.selectionStart > selected.replace(/\n$/, '').length) {
    removedLastNewLine = true;
    selected = selected.replace(/\n$/, '');
  }

  selectedSplit = selected.split('\n');

  if (!wrap) {
    lastNewLine = textArea.value.substr(0, textArea.selectionStart).lastIndexOf('\n');

    // Check whether the current line is empty or consists only of spaces(=handle as empty)
    if (/^\s*$/.test(textArea.value.substring(lastNewLine, textArea.selectionStart))) {
      currentLineEmpty = true;
    }
  }

  startChar = !wrap && !currentLineEmpty && textArea.selectionStart > 0 ? '\n' : '';

  if (selectedSplit.length > 1 && (!wrap || blockTag != null && blockTag !== '')) {
    if (blockTag != null && blockTag !== '') {
      insertText = this.blockTagText(text, textArea, blockTag, selected);
    } else {
      insertText = selectedSplit.map(function (val) {
        if (val.indexOf(tag) === 0) {
          return "" + val.replace(tag, '');
        } else {
          return "" + tag + val;
        }
      }).join('\n');
    }
  } else {
    insertText = "" + startChar + tag + selected + (wrap ? tag : ' ');
  }

  if (removedFirstNewLine) {
    insertText = '\n' + insertText;
  }

  if (removedLastNewLine) {
    insertText += '\n';
  }

  if (document.queryCommandSupported('insertText')) {
    inserted = document.execCommand('insertText', false, insertText);
  }
  if (!inserted) {
    try {
      document.execCommand("ms-beginUndoUnit");
    } catch (error) {}
    textArea.value = this.replaceRange(text, textArea.selectionStart, textArea.selectionEnd, insertText);
    try {
      document.execCommand("ms-endUndoUnit");
    } catch (error) {}
  }
  return this.moveCursor(textArea, tag, wrap, removedLastNewLine);
};

textUtils.moveCursor = function (textArea, tag, wrapped, removedLastNewLine) {
  var pos;
  if (!textArea.setSelectionRange) {
    return;
  }
  if (textArea.selectionStart === textArea.selectionEnd) {
    if (wrapped) {
      pos = textArea.selectionStart - tag.length;
    } else {
      pos = textArea.selectionStart;
    }

    if (removedLastNewLine) {
      pos -= 1;
    }

    return textArea.setSelectionRange(pos, pos);
  }
};

textUtils.updateText = function (textArea, tag, blockTag, wrap) {
  var $textArea, selected, text;
  $textArea = $(textArea);
  textArea = $textArea.get(0);
  text = $textArea.val();
  selected = this.selectedText(text, textArea);
  $textArea.focus();
  return this.insertText(textArea, text, tag, blockTag, selected, wrap);
};

textUtils.init = function (form) {
  var self;
  self = this;
  return $('.js-md', form).off('click').on('click', function () {
    var $this;
    $this = $(this);
    return self.updateText($this.closest('.md-area').find('textarea'), $this.data('mdTag'), $this.data('mdBlock'), !$this.data('mdPrepend'));
  });
};

textUtils.removeListeners = function (form) {
  return $('.js-md', form).off('click');
};

textUtils.replaceRange = function (s, start, end, substitute) {
  return s.substring(0, start) + substitute + s.substring(end);
};

/* harmony default export */ __webpack_exports__["a"] = (textUtils);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./mini_pipeline_graph_dropdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-new */



/**
 * In each pipelines table we have a mini pipeline graph for each pipeline.
 *
 * When we click in a pipeline stage, we need to make an API call to get the
 * builds list to render in a dropdown.
 *
 * The container should be the table element.
 *
 * The stage icon clicked needs to have the following HTML structure:
 * <div class="dropdown">
 *   <button class="dropdown js-builds-dropdown-button" data-toggle="dropdown"></button>
 *   <div class="js-builds-dropdown-container dropdown-menu"></div>
 * </div>
 */

var MiniPipelineGraph = function () {
  function MiniPipelineGraph() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MiniPipelineGraph);

    this.container = opts.container || '';
    this.dropdownListSelector = '.js-builds-dropdown-container';
    this.getBuildsList = this.getBuildsList.bind(this);
  }

  /**
   * Adds the event listener when the dropdown is opened.
   * All dropdown events are fired at the .dropdown-menu's parent element.
   */


  _createClass(MiniPipelineGraph, [{
    key: 'bindEvents',
    value: function bindEvents() {
      $(document).off('shown.bs.dropdown', this.container).on('shown.bs.dropdown', this.container, this.getBuildsList);
    }

    /**
     * When the user right clicks or cmd/ctrl + click in the job name
     * the dropdown should not be closed and the link should open in another tab,
     * so we stop propagation of the click event inside the dropdown.
     *
     * Since this component is rendered multiple times per page we need to guarantee we only
     * target the click event of this component.
     */

  }, {
    key: 'stopDropdownClickPropagation',
    value: function stopDropdownClickPropagation() {
      $(document).on('click', this.container + ' .js-builds-dropdown-list a.mini-pipeline-graph-dropdown-item', function (e) {
        e.stopPropagation();
      });
    }

    /**
     * For the clicked stage, renders the given data in the dropdown list.
     *
     * @param  {HTMLElement} stageContainer
     * @param  {Object} data
     */

  }, {
    key: 'renderBuildsList',
    value: function renderBuildsList(stageContainer, data) {
      var dropdownContainer = stageContainer.parentElement.querySelector(this.dropdownListSelector + ' .js-builds-dropdown-list');

      dropdownContainer.innerHTML = data;
    }

    /**
     * For the clicked stage, gets the list of builds.
     *
     * All dropdown events have a relatedTarget property,
     * whose value is the toggling anchor element.
     *
     * @param  {Object} e bootstrap dropdown event
     * @return {Promise}
     */

  }, {
    key: 'getBuildsList',
    value: function getBuildsList(e) {
      var _this = this;

      var button = e.relatedTarget;
      var endpoint = button.dataset.stageEndpoint;

      this.renderBuildsList(button, '');
      this.toggleLoading(button);

      __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(endpoint).then(function (_ref) {
        var data = _ref.data;

        _this.toggleLoading(button);
        _this.renderBuildsList(button, data.html);
        _this.stopDropdownClickPropagation();
      }).catch(function () {
        _this.toggleLoading(button);
        if ($(button).parent().hasClass('open')) {
          $(button).dropdown('toggle');
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__flash__["a" /* default */])('An error occurred while fetching the builds.', 'alert');
      });
    }

    /**
     * Toggles the visibility of the loading icon.
     *
     * @param  {HTMLElement} stageContainer
     * @return {type}
     */

  }, {
    key: 'toggleLoading',
    value: function toggleLoading(stageContainer) {
      stageContainer.parentElement.querySelector(this.dropdownListSelector + ' .js-builds-dropdown-loading').classList.toggle('hidden');
    }
  }]);

  return MiniPipelineGraph;
}();

/* harmony default export */ __webpack_exports__["a"] = (MiniPipelineGraph);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./notes.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("../../../node_modules/jquery/dist/jquery.js");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/underscore/underscore.js
var underscore = __webpack_require__("../../../node_modules/underscore/underscore.js");
var underscore_default = /*#__PURE__*/__webpack_require__.n(underscore);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/autosize/dist/autosize.js
var autosize = __webpack_require__("../../../node_modules/autosize/dist/autosize.js");
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/vendor/assets/javascripts/jquery.caret.js
var jquery_caret = __webpack_require__("../../../vendor/assets/javascripts/jquery.caret.js");
var jquery_caret_default = /*#__PURE__*/__webpack_require__.n(jquery_caret);

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/vendor/assets/javascripts/jquery.atwho.js
var jquery_atwho = __webpack_require__("../../../vendor/assets/javascripts/jquery.atwho.js");
var jquery_atwho_default = /*#__PURE__*/__webpack_require__.n(jquery_atwho);

// EXTERNAL MODULE: ./lib/utils/ajax_cache.js
var ajax_cache = __webpack_require__("./lib/utils/ajax_cache.js");

// EXTERNAL MODULE: ./lib/utils/axios_utils.js
var axios_utils = __webpack_require__("./lib/utils/axios_utils.js");

// EXTERNAL MODULE: ./lib/utils/url_utility.js
var url_utility = __webpack_require__("./lib/utils/url_utility.js");

// EXTERNAL MODULE: ./flash.js
var flash = __webpack_require__("./flash.js");

// EXTERNAL MODULE: ./droplab/drop_lab.js + 7 modules
var drop_lab = __webpack_require__("./droplab/drop_lab.js");

// EXTERNAL MODULE: ./droplab/plugins/input_setter.js
var input_setter = __webpack_require__("./droplab/plugins/input_setter.js");

// CONCATENATED MODULE: ./comment_type_toggle.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




// Todo: Remove this when fixing issue in input_setter plugin
var InputSetter = Object.assign({}, input_setter["a" /* default */]);

var comment_type_toggle_CommentTypeToggle = function () {
  function CommentTypeToggle() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CommentTypeToggle);

    this.dropdownTrigger = opts.dropdownTrigger;
    this.dropdownList = opts.dropdownList;
    this.noteTypeInput = opts.noteTypeInput;
    this.submitButton = opts.submitButton;
    this.closeButton = opts.closeButton;
    this.reopenButton = opts.reopenButton;
  }

  _createClass(CommentTypeToggle, [{
    key: 'initDroplab',
    value: function initDroplab() {
      this.droplab = new drop_lab["a" /* default */]();

      var config = this.setConfig();

      this.droplab.init(this.dropdownTrigger, this.dropdownList, [InputSetter], config);
    }
  }, {
    key: 'setConfig',
    value: function setConfig() {
      var config = {
        InputSetter: [{
          input: this.noteTypeInput,
          valueAttribute: 'data-value'
        }, {
          input: this.submitButton,
          valueAttribute: 'data-submit-text'
        }]
      };

      if (this.closeButton) {
        config.InputSetter.push({
          input: this.closeButton,
          valueAttribute: 'data-close-text'
        }, {
          input: this.closeButton,
          valueAttribute: 'data-close-text',
          inputAttribute: 'data-alternative-text'
        });
      }

      if (this.reopenButton) {
        config.InputSetter.push({
          input: this.reopenButton,
          valueAttribute: 'data-reopen-text'
        }, {
          input: this.reopenButton,
          valueAttribute: 'data-reopen-text',
          inputAttribute: 'data-alternative-text'
        });
      }

      return config;
    }
  }]);

  return CommentTypeToggle;
}();

/* harmony default export */ var comment_type_toggle = (comment_type_toggle_CommentTypeToggle);
// EXTERNAL MODULE: ./gl_form.js
var gl_form = __webpack_require__("./gl_form.js");

// EXTERNAL MODULE: ./awards_handler.js
var awards_handler = __webpack_require__("./awards_handler.js");

// EXTERNAL MODULE: ./autosave.js
var autosave = __webpack_require__("./autosave.js");

// EXTERNAL MODULE: ./task_list.js
var task_list = __webpack_require__("./task_list.js");

// EXTERNAL MODULE: ./lib/utils/common_utils.js
var common_utils = __webpack_require__("./lib/utils/common_utils.js");

// EXTERNAL MODULE: ./image_diff/helpers/index.js + 6 modules
var helpers = __webpack_require__("./image_diff/helpers/index.js");

// EXTERNAL MODULE: ./lib/utils/datetime_utility.js
var datetime_utility = __webpack_require__("./lib/utils/datetime_utility.js");

// CONCATENATED MODULE: ./notes.js
var notes__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function notes__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-restricted-properties, func-names, space-before-function-paren,
no-var, prefer-rest-params, wrap-iife, no-use-before-define, camelcase,
no-unused-expressions, quotes, max-len, one-var, one-var-declaration-per-line,
default-case, prefer-template, consistent-return, no-alert, no-return-assign,
no-param-reassign, prefer-arrow-callback, no-else-return, comma-dangle, no-new,
brace-style, no-lonely-if, vars-on-top, no-unused-vars, no-sequences, no-shadow,
newline-per-chained-call, no-useless-escape, class-methods-use-this */

/* global ResolveService */
/* global mrRefreshWidgetUrl */





 // required by jquery.atwho














window.autosize = autosize_default.a;

function normalizeNewlines(str) {
  return str.replace(/\r\n/g, '\n');
}

var MAX_VISIBLE_COMMIT_LIST_COUNT = 3;
var REGEX_QUICK_ACTIONS = /^\/\w+.*$/gm;

var notes_Notes = function () {
  notes__createClass(Notes, null, [{
    key: 'initialize',
    value: function initialize(notes_url, note_ids, last_fetched_at, view) {
      var enableGFM = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

      if (!this.instance) {
        this.instance = new Notes(notes_url, note_ids, last_fetched_at, view, enableGFM);
      }
    }
  }, {
    key: 'getInstance',
    value: function getInstance() {
      return this.instance;
    }
  }]);

  function Notes(notes_url, note_ids, last_fetched_at, view) {
    var enableGFM = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

    notes__classCallCheck(this, Notes);

    this.updateTargetButtons = this.updateTargetButtons.bind(this);
    this.updateComment = this.updateComment.bind(this);
    this.visibilityChange = this.visibilityChange.bind(this);
    this.cancelDiscussionForm = this.cancelDiscussionForm.bind(this);
    this.onAddDiffNote = this.onAddDiffNote.bind(this);
    this.onAddImageDiffNote = this.onAddImageDiffNote.bind(this);
    this.setupDiscussionNoteForm = this.setupDiscussionNoteForm.bind(this);
    this.onReplyToDiscussionNote = this.onReplyToDiscussionNote.bind(this);
    this.removeNote = this.removeNote.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.updateNote = this.updateNote.bind(this);
    this.addDiscussionNote = this.addDiscussionNote.bind(this);
    this.addNoteError = this.addNoteError.bind(this);
    this.addNote = this.addNote.bind(this);
    this.resetMainTargetForm = this.resetMainTargetForm.bind(this);
    this.refresh = this.refresh.bind(this);
    this.keydownNoteText = this.keydownNoteText.bind(this);
    this.toggleCommitList = this.toggleCommitList.bind(this);
    this.postComment = this.postComment.bind(this);
    this.clearFlashWrapper = this.clearFlash.bind(this);
    this.onHashChange = this.onHashChange.bind(this);

    this.notes_url = notes_url;
    this.note_ids = note_ids;
    this.enableGFM = enableGFM;
    // Used to keep track of updated notes while people are editing things
    this.updatedNotesTrackingMap = {};
    this.last_fetched_at = last_fetched_at;
    this.noteable_url = document.URL;
    this.notesCountBadge || (this.notesCountBadge = jquery_default()('.issuable-details').find('.notes-tab .badge'));
    this.basePollingInterval = 15000;
    this.maxPollingSteps = 4;

    this.$wrapperEl = Object(common_utils["n" /* hasVueMRDiscussionsCookie */])() ? jquery_default()(document).find('.diffs') : jquery_default()(document);
    this.cleanBinding();
    this.addBinding();
    this.setPollingInterval();
    this.setupMainTargetNoteForm();
    this.taskList = new task_list["a" /* default */]({
      dataType: 'note',
      fieldName: 'note',
      selector: '.notes'
    });
    this.collapseLongCommitList();
    this.setViewType(view);

    // We are in the Merge Requests page so we need another edit form for Changes tab
    if (Object(common_utils["h" /* getPagePath */])(1) === 'merge_requests') {
      jquery_default()('.note-edit-form').clone().addClass('mr-note-edit-form').insertAfter('.note-edit-form');
    }
  }

  notes__createClass(Notes, [{
    key: 'setViewType',
    value: function setViewType(view) {
      this.view = js_cookie_default.a.get('diff_view') || view;
    }
  }, {
    key: 'addBinding',
    value: function addBinding() {
      // Edit note link
      this.$wrapperEl.on('click', '.js-note-edit', this.showEditForm.bind(this));
      this.$wrapperEl.on('click', '.note-edit-cancel', this.cancelEdit);
      // Reopen and close actions for Issue/MR combined with note form submit
      this.$wrapperEl.on('click', '.js-comment-submit-button', this.postComment);
      this.$wrapperEl.on('click', '.js-comment-save-button', this.updateComment);
      this.$wrapperEl.on('keyup input', '.js-note-text', this.updateTargetButtons);
      // resolve a discussion
      this.$wrapperEl.on('click', '.js-comment-resolve-button', this.postComment);
      // remove a note (in general)
      this.$wrapperEl.on('click', '.js-note-delete', this.removeNote);
      // delete note attachment
      this.$wrapperEl.on('click', '.js-note-attachment-delete', this.removeAttachment);
      // reset main target form when clicking discard
      this.$wrapperEl.on('click', '.js-note-discard', this.resetMainTargetForm);
      // update the file name when an attachment is selected
      this.$wrapperEl.on('change', '.js-note-attachment-input', this.updateFormAttachment);
      // reply to diff/discussion notes
      this.$wrapperEl.on('click', '.js-discussion-reply-button', this.onReplyToDiscussionNote);
      // add diff note
      this.$wrapperEl.on('click', '.js-add-diff-note-button', this.onAddDiffNote);
      // add diff note for images
      this.$wrapperEl.on('click', '.js-add-image-diff-note-button', this.onAddImageDiffNote);
      // hide diff note form
      this.$wrapperEl.on('click', '.js-close-discussion-note-form', this.cancelDiscussionForm);
      // toggle commit list
      this.$wrapperEl.on('click', '.system-note-commit-list-toggler', this.toggleCommitList);
      // fetch notes when tab becomes visible
      this.$wrapperEl.on('visibilitychange', this.visibilityChange);
      // when issue status changes, we need to refresh data
      this.$wrapperEl.on('issuable:change', this.refresh);
      // ajax:events that happen on Form when actions like Reopen, Close are performed on Issues and MRs.
      this.$wrapperEl.on('ajax:success', '.js-main-target-form', this.addNote);
      this.$wrapperEl.on('ajax:success', '.js-discussion-note-form', this.addDiscussionNote);
      this.$wrapperEl.on('ajax:success', '.js-main-target-form', this.resetMainTargetForm);
      this.$wrapperEl.on('ajax:complete', '.js-main-target-form', this.reenableTargetFormSubmitButton);
      // when a key is clicked on the notes
      this.$wrapperEl.on('keydown', '.js-note-text', this.keydownNoteText);
      // When the URL fragment/hash has changed, `#note_xxx`
      jquery_default()(window).on('hashchange', this.onHashChange);
      this.boundGetContent = this.getContent.bind(this);
      document.addEventListener('refreshLegacyNotes', this.boundGetContent);
    }
  }, {
    key: 'cleanBinding',
    value: function cleanBinding() {
      this.$wrapperEl.off('click', '.js-note-edit');
      this.$wrapperEl.off('click', '.note-edit-cancel');
      this.$wrapperEl.off('click', '.js-note-delete');
      this.$wrapperEl.off('click', '.js-note-attachment-delete');
      this.$wrapperEl.off('click', '.js-discussion-reply-button');
      this.$wrapperEl.off('click', '.js-add-diff-note-button');
      this.$wrapperEl.off('click', '.js-add-image-diff-note-button');
      this.$wrapperEl.off('visibilitychange');
      this.$wrapperEl.off('keyup input', '.js-note-text');
      this.$wrapperEl.off('click', '.js-note-target-reopen');
      this.$wrapperEl.off('click', '.js-note-target-close');
      this.$wrapperEl.off('click', '.js-note-discard');
      this.$wrapperEl.off('keydown', '.js-note-text');
      this.$wrapperEl.off('click', '.js-comment-resolve-button');
      this.$wrapperEl.off('click', '.system-note-commit-list-toggler');
      this.$wrapperEl.off('ajax:success', '.js-main-target-form');
      this.$wrapperEl.off('ajax:success', '.js-discussion-note-form');
      this.$wrapperEl.off('ajax:complete', '.js-main-target-form');
      document.removeEventListener('refreshLegacyNotes', this.boundGetContent);
      jquery_default()(window).off('hashchange', this.onHashChange);
    }
  }, {
    key: 'keydownNoteText',
    value: function keydownNoteText(e) {
      var $textarea, discussionNoteForm, editNote, myLastNote, myLastNoteEditBtn, newText, originalText;
      if (Object(common_utils["v" /* isMetaKey */])(e)) {
        return;
      }

      $textarea = jquery_default()(e.target);
      // Edit previous note when UP arrow is hit
      switch (e.which) {
        case 38:
          if ($textarea.val() !== '') {
            return;
          }
          myLastNote = jquery_default()('li.note[data-author-id=\'' + gon.current_user_id + '\'][data-editable]:last', $textarea.closest('.note, .notes_holder, #notes'));
          if (myLastNote.length) {
            myLastNoteEditBtn = myLastNote.find('.js-note-edit');
            return myLastNoteEditBtn.trigger('click', [true, myLastNote]);
          }
          break;
        // Cancel creating diff note or editing any note when ESCAPE is hit
        case 27:
          discussionNoteForm = $textarea.closest('.js-discussion-note-form');
          if (discussionNoteForm.length) {
            if ($textarea.val() !== '') {
              if (!confirm('您确定要取消发表评论？')) {
                return;
              }
            }
            this.removeDiscussionNoteForm(discussionNoteForm);
            return;
          }
          editNote = $textarea.closest('.note');
          if (editNote.length) {
            originalText = $textarea.closest('form').data('originalNote');
            newText = $textarea.val();
            if (originalText !== newText) {
              if (!confirm('您确定要取消编辑评论？')) {
                return;
              }
            }
            return this.removeNoteEditForm(editNote);
          }
      }
    }
  }, {
    key: 'initRefresh',
    value: function initRefresh() {
      if (Notes.interval) {
        clearInterval(Notes.interval);
      }
      return Notes.interval = setInterval(function (_this) {
        return function () {
          return _this.refresh();
        };
      }(this), this.pollingInterval);
    }
  }, {
    key: 'refresh',
    value: function refresh() {
      if (!document.hidden) {
        return this.getContent();
      }
    }
  }, {
    key: 'getContent',
    value: function getContent() {
      var _this2 = this;

      if (this.refreshing) {
        return;
      }

      this.refreshing = true;

      axios_utils["a" /* default */].get(this.notes_url + '?html=true', {
        headers: {
          'X-Last-Fetched-At': this.last_fetched_at
        }
      }).then(function (_ref) {
        var data = _ref.data;

        var notes = data.notes;
        _this2.last_fetched_at = data.last_fetched_at;
        _this2.setPollingInterval(data.notes.length);
        jquery_default.a.each(notes, function (i, note) {
          return _this2.renderNote(note);
        });

        _this2.refreshing = false;
      }).catch(function () {
        _this2.refreshing = false;
      });
    }

    /**
     * Increase @pollingInterval up to 120 seconds on every function call,
     * if `shouldReset` has a truthy value, 'null' or 'undefined' the variable
     * will reset to @basePollingInterval.
     *
     * Note: this function is used to gradually increase the polling interval
     * if there aren't new notes coming from the server
     */

  }, {
    key: 'setPollingInterval',
    value: function setPollingInterval(shouldReset) {
      var nthInterval;
      if (shouldReset == null) {
        shouldReset = true;
      }
      nthInterval = this.basePollingInterval * Math.pow(2, this.maxPollingSteps - 1);
      if (shouldReset) {
        this.pollingInterval = this.basePollingInterval;
      } else if (this.pollingInterval < nthInterval) {
        this.pollingInterval *= 2;
      }
      return this.initRefresh();
    }
  }, {
    key: 'handleQuickActions',
    value: function handleQuickActions(noteEntity) {
      var votesBlock;
      if (noteEntity.commands_changes) {
        if ('merge' in noteEntity.commands_changes) {
          Notes.checkMergeRequestStatus();
        }

        if ('emoji_award' in noteEntity.commands_changes) {
          votesBlock = jquery_default()('.js-awards-block').eq(0);

          Object(awards_handler["a" /* default */])().then(function (awardsHandler) {
            awardsHandler.addAwardToEmojiBar(votesBlock, noteEntity.commands_changes.emoji_award);
            awardsHandler.scrollToAwards();
          }).catch(function () {
            // ignore
          });
        }
      }
    }
  }, {
    key: 'setupNewNote',
    value: function setupNewNote($note) {
      // Update datetime format on the recent note
      Object(datetime_utility["e" /* localTimeAgo */])($note.find('.js-timeago'), false);

      this.collapseLongCommitList();
      this.taskList.init();

      // This stops the note highlight, #note_xxx`, from being removed after real time update
      // The `:target` selector does not re-evaluate after we replace element in the DOM
      Notes.updateNoteTargetSelector($note);
      this.$noteToCleanHighlight = $note;
    }
  }, {
    key: 'onHashChange',
    value: function onHashChange() {
      if (this.$noteToCleanHighlight) {
        Notes.updateNoteTargetSelector(this.$noteToCleanHighlight);
      }

      this.$noteToCleanHighlight = null;
    }
  }, {
    key: 'renderNote',


    /**
     * Render note in main comments area.
     *
     * Note: for rendering inline notes use renderDiscussionNote
     */
    value: function renderNote(noteEntity, $form) {
      var $notesList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : jquery_default()('.main-notes-list');

      if (noteEntity.discussion_html) {
        return this.renderDiscussionNote(noteEntity, $form);
      }

      if (!noteEntity.valid) {
        if (noteEntity.errors && noteEntity.errors.commands_only) {
          if (noteEntity.commands_changes && Object.keys(noteEntity.commands_changes).length > 0) {
            $notesList.find('.system-note.being-posted').remove();
          }
          this.addFlash(noteEntity.errors.commands_only, 'notice', this.parentTimeline.get(0));
          this.refresh();
        }
        return;
      }

      var $note = $notesList.find('#note_' + noteEntity.id);
      if (Notes.isNewNote(noteEntity, this.note_ids)) {
        if (Object(common_utils["n" /* hasVueMRDiscussionsCookie */])()) {
          return;
        }

        this.note_ids.push(noteEntity.id);

        if ($notesList.length) {
          $notesList.find('.system-note.being-posted').remove();
        }
        var $newNote = Notes.animateAppendNote(noteEntity.html, $notesList);

        this.setupNewNote($newNote);
        this.refresh();
        return this.updateNotesCount(1);
      }
      // The server can send the same update multiple times so we need to make sure to only update once per actual update.
      else if (Notes.isUpdatedNote(noteEntity, $note)) {
          var isEditing = $note.hasClass('is-editing');
          var initialContent = normalizeNewlines($note.find('.original-note-content').text().trim());
          var $textarea = $note.find('.js-note-text');
          var currentContent = $textarea.val();
          // There can be CRLF vs LF mismatches if we don't sanitize and compare the same way
          var sanitizedNoteNote = normalizeNewlines(noteEntity.note);
          var isTextareaUntouched = currentContent === initialContent || currentContent === sanitizedNoteNote;

          if (isEditing && isTextareaUntouched) {
            $textarea.val(noteEntity.note);
            this.updatedNotesTrackingMap[noteEntity.id] = noteEntity;
          } else if (isEditing && !isTextareaUntouched) {
            this.putConflictEditWarningInPlace(noteEntity, $note);
            this.updatedNotesTrackingMap[noteEntity.id] = noteEntity;
          } else {
            var $updatedNote = Notes.animateUpdateNote(noteEntity.html, $note);
            this.setupNewNote($updatedNote);
          }
        }

      Notes.refreshVueNotes();
    }
  }, {
    key: 'isParallelView',
    value: function isParallelView() {
      return js_cookie_default.a.get('diff_view') === 'parallel';
    }

    /**
     * Render note in discussion area. To render inline notes use renderDiscussionNote.
     */

  }, {
    key: 'renderDiscussionNote',
    value: function renderDiscussionNote(noteEntity, $form) {
      var discussionContainer, form, row, lineType, diffAvatarContainer;

      if (!Notes.isNewNote(noteEntity, this.note_ids)) {
        return;
      }
      this.note_ids.push(noteEntity.id);

      form = $form || jquery_default()('.js-discussion-note-form[data-discussion-id="' + noteEntity.discussion_id + '"]');
      row = form.length || !noteEntity.discussion_line_code ? form.closest('tr') : jquery_default()('#' + noteEntity.discussion_line_code);

      if (noteEntity.on_image) {
        row = form;
      }

      lineType = this.isParallelView() ? form.find('#line_type').val() : 'old';
      diffAvatarContainer = row.prevAll('.line_holder').first().find('.js-avatar-container.' + lineType + '_line');
      // is this the first note of discussion?
      discussionContainer = jquery_default()('.notes[data-discussion-id="' + noteEntity.discussion_id + '"]');
      if (!discussionContainer.length) {
        discussionContainer = form.closest('.discussion').find('.notes');
      }
      if (discussionContainer.length === 0) {
        if (noteEntity.diff_discussion_html) {
          var $discussion = jquery_default()(noteEntity.diff_discussion_html).renderGFM();

          if (!this.isParallelView() || row.hasClass('js-temp-notes-holder') || noteEntity.on_image) {
            // insert the note and the reply button after the temp row
            row.after($discussion);
          } else {
            // Merge new discussion HTML in
            var $notes = $discussion.find('.notes[data-discussion-id="' + noteEntity.discussion_id + '"]');
            var contentContainerClass = '.' + $notes.closest('.notes_content').attr('class').split(' ').join('.');

            row.find(contentContainerClass + ' .content').append($notes.closest('.content').children());
          }
        }
        // Init discussion on 'Discussion' page if it is merge request page
        var page = jquery_default()('body').attr('data-page');
        if (page && page.indexOf('projects:merge_request') !== -1 || !noteEntity.diff_discussion_html) {
          if (!Object(common_utils["n" /* hasVueMRDiscussionsCookie */])()) {
            Notes.animateAppendNote(noteEntity.discussion_html, jquery_default()('.main-notes-list'));
          }
        }
      } else {
        // append new note to all matching discussions
        Notes.animateAppendNote(noteEntity.html, discussionContainer);
      }

      if (typeof gl.diffNotesCompileComponents !== 'undefined' && noteEntity.discussion_resolvable) {
        gl.diffNotesCompileComponents();

        this.renderDiscussionAvatar(diffAvatarContainer, noteEntity);
      }

      Object(datetime_utility["e" /* localTimeAgo */])(jquery_default()('.js-timeago'), false);
      Notes.checkMergeRequestStatus();
      return this.updateNotesCount(1);
    }
  }, {
    key: 'getLineHolder',
    value: function getLineHolder(changesDiscussionContainer) {
      return jquery_default()(changesDiscussionContainer).closest('.notes_holder').prevAll('.line_holder').first().get(0);
    }
  }, {
    key: 'renderDiscussionAvatar',
    value: function renderDiscussionAvatar(diffAvatarContainer, noteEntity) {
      var avatarHolder = diffAvatarContainer.find('.diff-comment-avatar-holders');

      if (!avatarHolder.length) {
        avatarHolder = document.createElement('diff-note-avatars');
        avatarHolder.setAttribute('discussion-id', noteEntity.discussion_id);

        diffAvatarContainer.append(avatarHolder);

        gl.diffNotesCompileComponents();
      }
    }

    /**
     * Called in response the main target form has been successfully submitted.
     *
     * Removes any errors.
     * Resets text and preview.
     * Resets buttons.
     */

  }, {
    key: 'resetMainTargetForm',
    value: function resetMainTargetForm(e) {
      var form;
      form = jquery_default()('.js-main-target-form');
      // remove validation errors
      form.find('.js-errors').remove();
      // reset text and preview
      form.find('.js-md-write-button').click();
      form.find('.js-note-text').val('').trigger('input');
      form.find('.js-note-text').data('autosave').reset();

      var event = document.createEvent('Event');
      event.initEvent('autosize:update', true, false);
      form.find('.js-autosize')[0].dispatchEvent(event);

      this.updateTargetButtons(e);
    }
  }, {
    key: 'reenableTargetFormSubmitButton',
    value: function reenableTargetFormSubmitButton() {
      var form;
      form = jquery_default()('.js-main-target-form');
      return form.find('.js-note-text').trigger('input');
    }

    /**
     * Shows the main form and does some setup on it.
     *
     * Sets some hidden fields in the form.
     */

  }, {
    key: 'setupMainTargetNoteForm',
    value: function setupMainTargetNoteForm() {
      var form;
      // find the form
      form = jquery_default()('.js-new-note-form');
      // Set a global clone of the form for later cloning
      this.formClone = form.clone();
      // show the form
      this.setupNoteForm(form);
      // fix classes
      form.removeClass('js-new-note-form');
      form.addClass('js-main-target-form');
      form.find('#note_line_code').remove();
      form.find('#note_position').remove();
      form.find('#note_type').val('');
      form.find('#note_project_id').remove();
      form.find('#in_reply_to_discussion_id').remove();
      form.find('.js-comment-resolve-button').closest('comment-and-resolve-btn').remove();
      this.parentTimeline = form.parents('.timeline');

      if (form.length) {
        Notes.initCommentTypeToggle(form.get(0));
      }
    }

    /**
     * General note form setup.
     *
     * deactivates the submit button when text is empty
     * hides the preview button when text is empty
     * setup GFM auto complete
     * show the form
     */

  }, {
    key: 'setupNoteForm',
    value: function setupNoteForm(form) {
      var textarea, key;
      this.glForm = new gl_form["a" /* default */](form, this.enableGFM);
      textarea = form.find('.js-note-text');
      key = ['Note', form.find('#note_noteable_type').val(), form.find('#note_noteable_id').val(), form.find('#note_commit_id').val(), form.find('#note_type').val(), form.find('#note_project_id').val(), form.find('#in_reply_to_discussion_id').val(),

      // LegacyDiffNote
      form.find('#note_line_code').val(),

      // DiffNote
      form.find('#note_position').val()];
      return new autosave["a" /* default */](textarea, key);
    }

    /**
     * Called in response to the new note form being submitted
     *
     * Adds new note to list.
     */

  }, {
    key: 'addNote',
    value: function addNote($form, note) {
      return this.renderNote(note);
    }
  }, {
    key: 'addNoteError',
    value: function addNoteError($form) {
      var formParentTimeline = void 0;
      if ($form.hasClass('js-main-target-form')) {
        formParentTimeline = $form.parents('.timeline');
      } else if ($form.hasClass('js-discussion-note-form')) {
        formParentTimeline = $form.closest('.discussion-notes').find('.notes');
      }
      return this.addFlash('Your comment could not be submitted! Please check your network connection and try again.', 'alert', formParentTimeline.get(0));
    }
  }, {
    key: 'updateNoteError',
    value: function updateNoteError($parentTimeline) {
      new flash["a" /* default */]('Your comment could not be updated! Please check your network connection and try again.');
    }

    /**
     * Called in response to the new note form being submitted
     *
     * Adds new note to list.
     */

  }, {
    key: 'addDiscussionNote',
    value: function addDiscussionNote($form, note, isNewDiffComment) {
      if ($form.attr('data-resolve-all') != null) {
        var projectPath = $form.data('projectPath');
        var discussionId = $form.data('discussionId');
        var mergeRequestId = $form.data('noteableIid');

        if (ResolveService != null) {
          ResolveService.toggleResolveForDiscussion(mergeRequestId, discussionId);
        }
      }

      this.renderNote(note, $form);
      // cleanup after successfully creating a diff/discussion note
      if (isNewDiffComment) {
        this.removeDiscussionNoteForm($form);
      }
    }

    /**
     * Called in response to the edit note form being submitted
     *
     * Updates the current note field.
     */

  }, {
    key: 'updateNote',
    value: function updateNote(noteEntity, $targetNote) {
      var $noteEntityEl, $note_li;
      // Convert returned HTML to a jQuery object so we can modify it further
      $noteEntityEl = jquery_default()(noteEntity.html);
      this.revertNoteEditForm($targetNote);
      $noteEntityEl.renderGFM();
      // Find the note's `li` element by ID and replace it with the updated HTML
      $note_li = jquery_default()('.note-row-' + noteEntity.id);

      $note_li.replaceWith($noteEntityEl);
      this.setupNewNote($noteEntityEl);

      if (typeof gl.diffNotesCompileComponents !== 'undefined') {
        gl.diffNotesCompileComponents();
      }
    }
  }, {
    key: 'checkContentToAllowEditing',
    value: function checkContentToAllowEditing($el) {
      var initialContent = $el.find('.original-note-content').text().trim();
      var currentContent = $el.find('.js-note-text').val();
      var isAllowed = true;

      if (currentContent === initialContent) {
        this.removeNoteEditForm($el);
      } else {
        var $buttons = $el.find('.note-form-actions');
        var isWidgetVisible = Object(common_utils["t" /* isInViewport */])($el.get(0));

        if (!isWidgetVisible) {
          Object(common_utils["D" /* scrollToElement */])($el);
        }

        $el.find('.js-finish-edit-warning').show();
        isAllowed = false;
      }

      return isAllowed;
    }

    /**
     * Called in response to clicking the edit note link
     *
     * Replaces the note text with the note edit form
     * Adds a data attribute to the form with the original content of the note for cancellations
     */

  }, {
    key: 'showEditForm',
    value: function showEditForm(e, scrollTo, myLastNote) {
      e.preventDefault();

      var $target = jquery_default()(e.target);
      var $editForm = jquery_default()(this.getEditFormSelector($target));
      var $note = $target.closest('.note');
      var $currentlyEditing = jquery_default()('.note.is-editing:visible');

      if ($currentlyEditing.length) {
        var isEditAllowed = this.checkContentToAllowEditing($currentlyEditing);

        if (!isEditAllowed) {
          return;
        }
      }

      $note.find('.js-note-attachment-delete').show();
      $editForm.addClass('current-note-edit-form');
      $note.addClass('is-editing');
      this.putEditFormInPlace($target);
    }

    /**
     * Called in response to clicking the edit note link
     *
     * Hides edit form and restores the original note text to the editor textarea.
     */

  }, {
    key: 'cancelEdit',
    value: function cancelEdit(e) {
      e.preventDefault();
      var $target = jquery_default()(e.target);
      var $note = $target.closest('.note');
      var noteId = $note.attr('data-note-id');

      this.revertNoteEditForm($target);

      if (this.updatedNotesTrackingMap[noteId]) {
        var $newNote = jquery_default()(this.updatedNotesTrackingMap[noteId].html);
        $note.replaceWith($newNote);
        this.setupNewNote($newNote);
        // Now that we have taken care of the update, clear it out
        delete this.updatedNotesTrackingMap[noteId];
      } else {
        $note.find('.js-finish-edit-warning').hide();
        this.removeNoteEditForm($note);
      }
    }
  }, {
    key: 'revertNoteEditForm',
    value: function revertNoteEditForm($target) {
      $target = $target || jquery_default()('.note.is-editing:visible');
      var selector = this.getEditFormSelector($target);
      var $editForm = jquery_default()(selector);

      $editForm.insertBefore('.diffs');
      $editForm.find('.js-comment-save-button').enable();
      $editForm.find('.js-finish-edit-warning').hide();
    }
  }, {
    key: 'getEditFormSelector',
    value: function getEditFormSelector($el) {
      var selector = '.note-edit-form:not(.mr-note-edit-form)';

      if ($el.parents('#diffs').length) {
        selector = '.note-edit-form.mr-note-edit-form';
      }

      return selector;
    }
  }, {
    key: 'removeNoteEditForm',
    value: function removeNoteEditForm($note) {
      var form = $note.find('.diffs .current-note-edit-form');

      $note.removeClass('is-editing');
      form.removeClass('current-note-edit-form');
      form.find('.js-finish-edit-warning').hide();
      // Replace markdown textarea text with original note text.
      return form.find('.js-note-text').val(form.find('form.edit-note').data('originalNote'));
    }

    /**
     * Called in response to deleting a note of any kind.
     *
     * Removes the actual note from view.
     * Removes the whole discussion if the last note is being removed.
     */

  }, {
    key: 'removeNote',
    value: function removeNote(e) {
      var noteElId, noteId, dataNoteId, $note, lineHolder;
      $note = jquery_default()(e.currentTarget).closest('.note');
      noteElId = $note.attr('id');
      noteId = $note.attr('data-note-id');
      lineHolder = jquery_default()(e.currentTarget).closest('.notes[data-discussion-id]').closest('.notes_holder').prev('.line_holder');
      jquery_default()('.note[id="' + noteElId + '"]').each(function (_this) {
        // A same note appears in the "Discussion" and in the "Changes" tab, we have
        // to remove all. Using $('.note[id='noteId']') ensure we get all the notes,
        // where $('#noteId') would return only one.
        return function (i, el) {
          var $note, $notes;
          $note = jquery_default()(el);
          $notes = $note.closest('.discussion-notes');
          var discussionId = jquery_default()('.notes', $notes).data('discussionId');

          if (typeof gl.diffNotesCompileComponents !== 'undefined') {
            if (gl.diffNoteApps[noteElId]) {
              gl.diffNoteApps[noteElId].$destroy();
            }
          }

          $note.remove();

          // check if this is the last note for this line
          if ($notes.find('.note').length === 0) {
            var notesTr = $notes.closest('tr');

            // "Discussions" tab
            $notes.closest('.timeline-entry').remove();

            jquery_default()('.js-diff-avatars-' + discussionId).trigger('remove.vue');

            // The notes tr can contain multiple lists of notes, like on the parallel diff
            // notesTr does not exist for image diffs
            if (notesTr.find('.discussion-notes').length > 1 || notesTr.length === 0) {
              var $diffFile = $notes.closest('.diff-file');
              if ($diffFile.length > 0) {
                var removeBadgeEvent = new CustomEvent('removeBadge.imageDiff', {
                  detail: {
                    // badgeNumber's start with 1 and index starts with 0
                    badgeNumber: $notes.index() + 1
                  }
                });

                $diffFile[0].dispatchEvent(removeBadgeEvent);
              }

              $notes.remove();
            } else if (notesTr.length > 0) {
              notesTr.remove();
            }
          }
        };
      }(this));

      Notes.refreshVueNotes();
      Notes.checkMergeRequestStatus();
      return this.updateNotesCount(-1);
    }

    /**
     * Called in response to clicking the delete attachment link
     *
     * Removes the attachment wrapper view, including image tag if it exists
     * Resets the note editing form
     */

  }, {
    key: 'removeAttachment',
    value: function removeAttachment() {
      var $note = jquery_default()(this).closest('.note');
      $note.find('.note-attachment').remove();
      $note.find('.note-body > .note-text').show();
      $note.find('.note-header').show();
      return $note.find('.current-note-edit-form').remove();
    }

    /**
     * Called when clicking on the "reply" button for a diff line.
     *
     * Shows the note form below the notes.
     */

  }, {
    key: 'onReplyToDiscussionNote',
    value: function onReplyToDiscussionNote(e) {
      this.replyToDiscussionNote(e.target);
    }
  }, {
    key: 'replyToDiscussionNote',
    value: function replyToDiscussionNote(target) {
      var form, replyLink;
      form = this.cleanForm(this.formClone.clone());
      replyLink = jquery_default()(target).closest('.js-discussion-reply-button');
      // insert the form after the button
      replyLink.closest('.discussion-reply-holder').hide().after(form);
      // show the form
      return this.setupDiscussionNoteForm(replyLink, form);
    }

    /**
     * Shows the diff or discussion form and does some setup on it.
     *
     * Sets some hidden fields in the form.
     *
     * Note: dataHolder must have the "discussionId" and "lineCode" data attributes set.
     */

  }, {
    key: 'setupDiscussionNoteForm',
    value: function setupDiscussionNoteForm(dataHolder, form) {
      // setup note target
      var diffFileData = dataHolder.closest('.text-file');

      if (diffFileData.length === 0) {
        diffFileData = dataHolder.closest('.image');
      }

      var discussionID = dataHolder.data('discussionId');

      if (discussionID) {
        form.attr('data-discussion-id', discussionID);
        form.find('#in_reply_to_discussion_id').val(discussionID);
      }

      form.find('#note_project_id').val(dataHolder.data('discussionProjectId'));

      form.attr('data-line-code', dataHolder.data('lineCode'));
      form.find('#line_type').val(dataHolder.data('lineType'));

      form.find('#note_noteable_type').val(diffFileData.data('noteableType'));
      form.find('#note_noteable_id').val(diffFileData.data('noteableId'));
      form.find('#note_commit_id').val(diffFileData.data('commitId'));

      form.find('#note_type').val(dataHolder.data('noteType'));

      // LegacyDiffNote
      form.find('#note_line_code').val(dataHolder.data('lineCode'));

      // DiffNote
      form.find('#note_position').val(dataHolder.attr('data-position'));

      form.find('.js-note-discard').show().removeClass('js-note-discard').addClass('js-close-discussion-note-form').text(form.find('.js-close-discussion-note-form').data('cancelText'));
      form.find('.js-note-target-close').remove();
      form.find('.js-note-new-discussion').remove();
      this.setupNoteForm(form);

      form.removeClass('js-main-target-form').addClass('discussion-form js-discussion-note-form');

      if (typeof gl.diffNotesCompileComponents !== 'undefined') {
        var $commentBtn = form.find('comment-and-resolve-btn');
        $commentBtn.attr(':discussion-id', '\'' + discussionID + '\'');

        gl.diffNotesCompileComponents();
      }

      form.find('.js-note-text').focus();
      form.find('.js-comment-resolve-button').attr('data-discussion-id', discussionID);
    }

    /**
     * Called when clicking on the "add a comment" button on the side of a diff line.
     *
     * Inserts a temporary row for the form below the line.
     * Sets up the form and shows it.
     */

  }, {
    key: 'onAddDiffNote',
    value: function onAddDiffNote(e) {
      e.preventDefault();
      var link = e.currentTarget || e.target;
      var $link = jquery_default()(link);
      var showReplyInput = !$link.hasClass('js-diff-comment-avatar');
      this.toggleDiffNote({
        target: $link,
        lineType: link.dataset.lineType,
        showReplyInput: showReplyInput
      });
    }
  }, {
    key: 'onAddImageDiffNote',
    value: function onAddImageDiffNote(e) {
      var $link = jquery_default()(e.currentTarget || e.target);
      var $diffFile = $link.closest('.diff-file');

      var clickEvent = new CustomEvent('click.imageDiff', {
        detail: e
      });

      $diffFile[0].dispatchEvent(clickEvent);

      // Setup comment form
      var newForm = void 0;
      var $noteContainer = $link.closest('.diff-viewer').find('.note-container');
      var $form = $noteContainer.find('> .discussion-form');

      if ($form.length === 0) {
        newForm = this.cleanForm(this.formClone.clone());
        newForm.appendTo($noteContainer);
      } else {
        newForm = $form;
      }

      this.setupDiscussionNoteForm($link, newForm);
    }
  }, {
    key: 'toggleDiffNote',
    value: function toggleDiffNote(_ref2) {
      var target = _ref2.target,
          lineType = _ref2.lineType,
          forceShow = _ref2.forceShow,
          _ref2$showReplyInput = _ref2.showReplyInput,
          showReplyInput = _ref2$showReplyInput === undefined ? false : _ref2$showReplyInput;

      var $link, addForm, hasNotes, newForm, noteForm, replyButton, row, rowCssToAdd, targetContent, isDiffCommentAvatar;
      $link = jquery_default()(target);
      row = $link.closest('tr');
      var nextRow = row.next();
      var targetRow = row;
      if (nextRow.is('.notes_holder')) {
        targetRow = nextRow;
      }

      hasNotes = nextRow.is('.notes_holder');
      addForm = false;
      var lineTypeSelector = '';
      rowCssToAdd = '<tr class="notes_holder js-temp-notes-holder"><td class="notes_line" colspan="2"></td><td class="notes_content"><div class="content"></div></td></tr>';
      // In parallel view, look inside the correct left/right pane
      if (this.isParallelView()) {
        lineTypeSelector = '.' + lineType;
        rowCssToAdd = '<tr class="notes_holder js-temp-notes-holder"><td class="notes_line old"></td><td class="notes_content parallel old"><div class="content"></div></td><td class="notes_line new"></td><td class="notes_content parallel new"><div class="content"></div></td></tr>';
      }
      var notesContentSelector = '.notes_content' + lineTypeSelector + ' .content';
      var notesContent = targetRow.find(notesContentSelector);

      if (hasNotes && showReplyInput) {
        targetRow.show();
        notesContent = targetRow.find(notesContentSelector);
        if (notesContent.length) {
          notesContent.show();
          replyButton = notesContent.find('.js-discussion-reply-button:visible');
          if (replyButton.length) {
            this.replyToDiscussionNote(replyButton[0]);
          } else {
            // In parallel view, the form may not be present in one of the panes
            noteForm = notesContent.find('.js-discussion-note-form');
            if (noteForm.length === 0) {
              addForm = true;
            }
          }
        }
      } else if (showReplyInput) {
        // add a notes row and insert the form
        row.after(rowCssToAdd);
        targetRow = row.next();
        notesContent = targetRow.find(notesContentSelector);
        addForm = true;
      } else {
        var isCurrentlyShown = targetRow.find('.content:not(:empty)').is(':visible');
        var isForced = forceShow === true || forceShow === false;
        var showNow = forceShow === true || !isCurrentlyShown && !isForced;

        targetRow.toggle(showNow);
        notesContent.toggle(showNow);
      }

      if (addForm) {
        newForm = this.cleanForm(this.formClone.clone());
        newForm.appendTo(notesContent);
        // show the form
        return this.setupDiscussionNoteForm($link, newForm);
      }
    }

    /**
     * Called in response to "cancel" on a diff note form.
     *
     * Shows the reply button again.
     * Removes the form and if necessary it's temporary row.
     */

  }, {
    key: 'removeDiscussionNoteForm',
    value: function removeDiscussionNoteForm(form) {
      var glForm, row;
      row = form.closest('tr');
      glForm = form.data('glForm');
      glForm.destroy();
      form.find('.js-note-text').data('autosave').reset();
      // show the reply button (will only work for replies)
      form.prev('.discussion-reply-holder').show();
      if (row.is('.js-temp-notes-holder')) {
        // remove temporary row for diff lines
        return row.remove();
      } else {
        // only remove the form
        return form.remove();
      }
    }
  }, {
    key: 'cancelDiscussionForm',
    value: function cancelDiscussionForm(e) {
      e.preventDefault();
      var $form = jquery_default()(e.target).closest('.js-discussion-note-form');
      var $discussionNote = jquery_default()(e.target).closest('.discussion-notes');

      if ($discussionNote.length === 0) {
        // Only send blur event when the discussion form
        // is not part of a discussion note
        var $diffFile = $form.closest('.diff-file');

        if ($diffFile.length > 0) {
          var blurEvent = new CustomEvent('blur.imageDiff', {
            detail: e
          });

          $diffFile[0].dispatchEvent(blurEvent);
        }
      }

      return this.removeDiscussionNoteForm($form);
    }

    /**
     * Called after an attachment file has been selected.
     *
     * Updates the file name for the selected attachment.
     */

  }, {
    key: 'updateFormAttachment',
    value: function updateFormAttachment() {
      var filename, form;
      form = jquery_default()(this).closest('form');
      // get only the basename
      filename = jquery_default()(this).val().replace(/^.*[\\\/]/, '');
      return form.find('.js-attachment-filename').text(filename);
    }

    /**
     * Called when the tab visibility changes
     */

  }, {
    key: 'visibilityChange',
    value: function visibilityChange() {
      return this.refresh();
    }
  }, {
    key: 'updateTargetButtons',
    value: function updateTargetButtons(e) {
      var closebtn, closetext, discardbtn, form, reopenbtn, reopentext, textarea;
      textarea = jquery_default()(e.target);
      form = textarea.parents('form');
      reopenbtn = form.find('.js-note-target-reopen');
      closebtn = form.find('.js-note-target-close');
      discardbtn = form.find('.js-note-discard');

      if (textarea.val().trim().length > 0) {
        reopentext = reopenbtn.attr('data-alternative-text');
        closetext = closebtn.attr('data-alternative-text');
        if (reopenbtn.text() !== reopentext) {
          reopenbtn.text(reopentext);
        }
        if (closebtn.text() !== closetext) {
          closebtn.text(closetext);
        }
        if (reopenbtn.is(':not(.btn-comment-and-reopen)')) {
          reopenbtn.addClass('btn-comment-and-reopen');
        }
        if (closebtn.is(':not(.btn-comment-and-close)')) {
          closebtn.addClass('btn-comment-and-close');
        }
        if (discardbtn.is(':hidden')) {
          return discardbtn.show();
        }
      } else {
        reopentext = reopenbtn.data('originalText');
        closetext = closebtn.data('originalText');
        if (reopenbtn.text() !== reopentext) {
          reopenbtn.text(reopentext);
        }
        if (closebtn.text() !== closetext) {
          closebtn.text(closetext);
        }
        if (reopenbtn.is('.btn-comment-and-reopen')) {
          reopenbtn.removeClass('btn-comment-and-reopen');
        }
        if (closebtn.is('.btn-comment-and-close')) {
          closebtn.removeClass('btn-comment-and-close');
        }
        if (discardbtn.is(':visible')) {
          return discardbtn.hide();
        }
      }
    }
  }, {
    key: 'putEditFormInPlace',
    value: function putEditFormInPlace($el) {
      var $editForm = jquery_default()(this.getEditFormSelector($el));
      var $note = $el.closest('.note');

      $editForm.insertAfter($note.find('.note-text'));

      var $originalContentEl = $note.find('.original-note-content');
      var originalContent = $originalContentEl.text().trim();
      var postUrl = $originalContentEl.data('postUrl');
      var targetId = $originalContentEl.data('targetId');
      var targetType = $originalContentEl.data('targetType');

      this.glForm = new gl_form["a" /* default */]($editForm.find('form'), this.enableGFM);

      $editForm.find('form').attr('action', postUrl + '?html=true').attr('data-remote', 'true');
      $editForm.find('.js-form-target-id').val(targetId);
      $editForm.find('.js-form-target-type').val(targetType);
      $editForm.find('.js-note-text').focus().val(originalContent);
      $editForm.find('.js-md-write-button').trigger('click');
      $editForm.find('.referenced-users').hide();
    }
  }, {
    key: 'putConflictEditWarningInPlace',
    value: function putConflictEditWarningInPlace(noteEntity, $note) {
      if ($note.find('.js-conflict-edit-warning').length === 0) {
        var $alert = jquery_default()('<div class="js-conflict-edit-warning alert alert-danger">\n        This comment has changed since you started editing, please review the\n        <a href="#note_' + noteEntity.id + '" target="_blank" rel="noopener noreferrer">\n          updated comment\n        </a>\n        to ensure information is not lost\n      </div>');
        $alert.insertAfter($note.find('.note-text'));
      }
    }
  }, {
    key: 'updateNotesCount',
    value: function updateNotesCount(updateCount) {
      return this.notesCountBadge.text(parseInt(this.notesCountBadge.text(), 10) + updateCount);
    }
  }, {
    key: 'toggleCommitList',
    value: function toggleCommitList(e) {
      var $element = jquery_default()(e.currentTarget);
      var $closestSystemCommitList = $element.siblings('.system-note-commit-list');

      $element.find('.fa').toggleClass('fa-angle-down').toggleClass('fa-angle-up');
      $closestSystemCommitList.toggleClass('hide-shade');
    }

    /**
     * Scans system notes with `ul` elements in system note body
     * then collapse long commit list pushed by user to make it less
     * intrusive.
     */

  }, {
    key: 'collapseLongCommitList',
    value: function collapseLongCommitList() {
      var systemNotes = jquery_default()('#notes-list').find('li.system-note').has('ul');

      jquery_default.a.each(systemNotes, function (index, systemNote) {
        var $systemNote = jquery_default()(systemNote);
        var headerMessage = $systemNote.find('.note-text').find('p:first').text().replace(':', '');

        $systemNote.find('.note-header .system-note-message').html(headerMessage);

        if ($systemNote.find('li').length > MAX_VISIBLE_COMMIT_LIST_COUNT) {
          $systemNote.find('.note-text').addClass('system-note-commit-list');
          $systemNote.find('.system-note-commit-list-toggler').show();
        } else {
          $systemNote.find('.note-text').addClass('system-note-commit-list hide-shade');
        }
      });
    }
  }, {
    key: 'addFlash',
    value: function addFlash() {
      for (var _len = arguments.length, flashParams = Array(_len), _key = 0; _key < _len; _key++) {
        flashParams[_key] = arguments[_key];
      }

      this.flashContainer = new (Function.prototype.bind.apply(flash["a" /* default */], [null].concat(flashParams)))();
    }
  }, {
    key: 'clearFlash',
    value: function clearFlash() {
      if (this.flashContainer) {
        this.flashContainer.style.display = 'none';
        this.flashContainer = null;
      }
    }
  }, {
    key: 'cleanForm',
    value: function cleanForm($form) {
      // Remove JS classes that are not needed here
      $form.find('.js-comment-type-dropdown').removeClass('btn-group');

      // Remove dropdown
      $form.find('.dropdown-menu').remove();

      return $form;
    }

    /**
     * Check if note does not exists on page
     */

  }, {
    key: 'getFormData',


    /**
     * Get data from Form attributes to use for saving/submitting comment.
     */
    value: function getFormData($form) {
      var content = $form.find('.js-note-text').val();
      return {
        formData: $form.serialize(),
        formContent: underscore_default.a.escape(content),
        formAction: $form.attr('action'),
        formContentOriginal: content
      };
    }

    /**
     * Identify if comment has any quick actions
     */

  }, {
    key: 'hasQuickActions',
    value: function hasQuickActions(formContent) {
      return REGEX_QUICK_ACTIONS.test(formContent);
    }

    /**
     * Remove quick actions and leave comment with pure message
     */

  }, {
    key: 'stripQuickActions',
    value: function stripQuickActions(formContent) {
      return formContent.replace(REGEX_QUICK_ACTIONS, '').trim();
    }

    /**
     * Gets appropriate description from quick actions found in provided `formContent`
     */

  }, {
    key: 'getQuickActionDescription',
    value: function getQuickActionDescription(formContent) {
      var availableQuickActions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var tempFormContent = void 0;

      // Identify executed quick actions from `formContent`
      var executedCommands = availableQuickActions.filter(function (command, index) {
        var commandRegex = new RegExp('/' + command.name);
        return commandRegex.test(formContent);
      });

      if (executedCommands && executedCommands.length) {
        if (executedCommands.length > 1) {
          tempFormContent = 'Applying multiple commands';
        } else {
          var commandDescription = executedCommands[0].description.toLowerCase();
          tempFormContent = 'Applying command to ' + commandDescription;
        }
      } else {
        tempFormContent = 'Applying command';
      }

      return tempFormContent;
    }

    /**
     * Create placeholder note DOM element populated with comment body
     * that we will show while comment is being posted.
     * Once comment is _actually_ posted on server, we will have final element
     * in response that we will show in place of this temporary element.
     */

  }, {
    key: 'createPlaceholderNote',
    value: function createPlaceholderNote(_ref3) {
      var formContent = _ref3.formContent,
          uniqueId = _ref3.uniqueId,
          isDiscussionNote = _ref3.isDiscussionNote,
          currentUsername = _ref3.currentUsername,
          currentUserFullname = _ref3.currentUserFullname,
          currentUserAvatar = _ref3.currentUserAvatar;

      var discussionClass = isDiscussionNote ? 'discussion' : '';
      var $tempNote = jquery_default()('<li id="' + uniqueId + '" class="note being-posted fade-in-half timeline-entry">\n         <div class="timeline-entry-inner">\n            <div class="timeline-icon">\n               <a href="/' + underscore_default.a.escape(currentUsername) + '">\n                 <img class="avatar s40" src="' + currentUserAvatar + '" />\n               </a>\n            </div>\n            <div class="timeline-content ' + discussionClass + '">\n               <div class="note-header">\n                  <div class="note-header-info">\n                     <a href="/' + underscore_default.a.escape(currentUsername) + '">\n                       <span class="hidden-xs">' + underscore_default.a.escape(currentUsername) + '</span>\n                       <span class="note-headline-light">' + underscore_default.a.escape(currentUsername) + '</span>\n                     </a>\n                  </div>\n               </div>\n               <div class="note-body">\n                 <div class="note-text">\n                   <p>' + formContent + '</p>\n                 </div>\n               </div>\n            </div>\n         </div>\n      </li>');

      $tempNote.find('.hidden-xs').text(underscore_default.a.escape(currentUserFullname));
      $tempNote.find('.note-headline-light').text('@' + underscore_default.a.escape(currentUsername));

      return $tempNote;
    }

    /**
     * Create Placeholder System Note DOM element populated with quick action description
     */

  }, {
    key: 'createPlaceholderSystemNote',
    value: function createPlaceholderSystemNote(_ref4) {
      var formContent = _ref4.formContent,
          uniqueId = _ref4.uniqueId;

      var $tempNote = jquery_default()('<li id="' + uniqueId + '" class="note system-note timeline-entry being-posted fade-in-half">\n         <div class="timeline-entry-inner">\n           <div class="timeline-content">\n             <i>' + formContent + '</i>\n           </div>\n         </div>\n       </li>');

      return $tempNote;
    }

    /**
     * This method does following tasks step-by-step whenever a new comment
     * is submitted by user (both main thread comments as well as discussion comments).
     *
     * 1) Get Form metadata
     * 2) Identify comment type; a) Main thread b) Discussion thread c) Discussion resolve
     * 3) Build temporary placeholder element (using `createPlaceholderNote`)
     * 4) Show placeholder note on UI
     * 5) Perform network request to submit the note using `axios.post`
     *    a) If request is successfully completed
     *        1. Remove placeholder element
     *        2. Show submitted Note element
     *        3. Perform post-submit errands
     *           a. Mark discussion as resolved if comment submission was for resolve.
     *           b. Reset comment form to original state.
     *    b) If request failed
     *        1. Remove placeholder element
     *        2. Show error Flash message about failure
     */

  }, {
    key: 'postComment',
    value: function postComment(e) {
      var _this3 = this;

      e.preventDefault();

      // Get Form metadata
      var $submitBtn = jquery_default()(e.target);
      var $form = $submitBtn.parents('form');
      var $closeBtn = $form.find('.js-note-target-close');
      var isDiscussionNote = $submitBtn.parent().find('li.droplab-item-selected').attr('id') === 'discussion';
      var isMainForm = $form.hasClass('js-main-target-form');
      var isDiscussionForm = $form.hasClass('js-discussion-note-form');
      var isDiscussionResolve = $submitBtn.hasClass('js-comment-resolve-button');

      var _getFormData = this.getFormData($form),
          formData = _getFormData.formData,
          formContent = _getFormData.formContent,
          formAction = _getFormData.formAction,
          formContentOriginal = _getFormData.formContentOriginal;

      var noteUniqueId = void 0;
      var systemNoteUniqueId = void 0;
      var hasQuickActions = false;
      var $notesContainer = void 0;
      var tempFormContent = void 0;

      // Get reference to notes container based on type of comment
      if (isDiscussionForm) {
        $notesContainer = $form.parent('.discussion-notes').find('.notes');
      } else if (isMainForm) {
        $notesContainer = jquery_default()('ul.main-notes-list');
      }

      // If comment is to resolve discussion, disable submit buttons while
      // comment posting is finished.
      if (isDiscussionResolve) {
        $submitBtn.disable();
        $form.find('.js-comment-submit-button').disable();
      }

      tempFormContent = formContent;
      if (this.hasQuickActions(formContent)) {
        tempFormContent = this.stripQuickActions(formContent);
        hasQuickActions = true;
      }

      // Show placeholder note
      if (tempFormContent) {
        noteUniqueId = underscore_default.a.uniqueId('tempNote_');
        $notesContainer.append(this.createPlaceholderNote({
          formContent: tempFormContent,
          uniqueId: noteUniqueId,
          isDiscussionNote: isDiscussionNote,
          currentUsername: gon.current_username,
          currentUserFullname: gon.current_user_fullname,
          currentUserAvatar: gon.current_user_avatar_url
        }));
      }

      // Show placeholder system note
      if (hasQuickActions) {
        systemNoteUniqueId = underscore_default.a.uniqueId('tempSystemNote_');
        $notesContainer.append(this.createPlaceholderSystemNote({
          formContent: this.getQuickActionDescription(formContent, ajax_cache["a" /* default */].get(gl.GfmAutoComplete.dataSources.commands)),
          uniqueId: systemNoteUniqueId
        }));
      }

      // Clear the form textarea
      if ($notesContainer.length) {
        if (isMainForm) {
          this.resetMainTargetForm(e);
        } else if (isDiscussionForm) {
          this.removeDiscussionNoteForm($form);
        }
      }

      /* eslint-disable promise/catch-or-return */
      // Make request to submit comment on server
      axios_utils["a" /* default */].post(formAction + '?html=true', formData).then(function (res) {
        var note = res.data;

        // Submission successful! remove placeholder
        $notesContainer.find('#' + noteUniqueId).remove();

        var $diffFile = $form.closest('.diff-file');
        if ($diffFile.length > 0) {
          var blurEvent = new CustomEvent('blur.imageDiff', {
            detail: e
          });

          $diffFile[0].dispatchEvent(blurEvent);
        }

        // Reset cached commands list when command is applied
        if (hasQuickActions) {
          $form.find('textarea.js-note-text').trigger('clear-commands-cache.atwho');
        }

        // Clear previous form errors
        _this3.clearFlashWrapper();

        // Check if this was discussion comment
        if (isDiscussionForm) {
          // Remove flash-container
          $notesContainer.find('.flash-container').remove();

          // If comment intends to resolve discussion, do the same.
          if (isDiscussionResolve) {
            $form.attr('data-discussion-id', $submitBtn.data('discussionId')).attr('data-resolve-all', 'true').attr('data-project-path', $submitBtn.data('projectPath'));
          }

          // Show final note element on UI
          var isNewDiffComment = $notesContainer.length === 0;
          _this3.addDiscussionNote($form, note, isNewDiffComment);

          if (isNewDiffComment) {
            // Add image badge, avatar badge and toggle discussion badge for new image diffs
            var notePosition = $form.find('#note_position').val();
            if ($diffFile.length > 0 && notePosition.length > 0) {
              var _JSON$parse = JSON.parse(notePosition),
                  x = _JSON$parse.x,
                  y = _JSON$parse.y,
                  width = _JSON$parse.width,
                  height = _JSON$parse.height;

              var addBadgeEvent = new CustomEvent('addBadge.imageDiff', {
                detail: {
                  x: x,
                  y: y,
                  width: width,
                  height: height,
                  noteId: 'note_' + note.id,
                  discussionId: note.discussion_id
                }
              });

              $diffFile[0].dispatchEvent(addBadgeEvent);
            }
          }

          // append flash-container to the Notes list
          if ($notesContainer.length) {
            $notesContainer.append('<div class="flash-container" style="display: none;"></div>');
          }

          Notes.refreshVueNotes();
        } else if (isMainForm) {
          // Check if this was main thread comment
          // Show final note element on UI and perform form and action buttons cleanup
          _this3.addNote($form, note);
          _this3.reenableTargetFormSubmitButton(e);
        }

        if (note.commands_changes) {
          _this3.handleQuickActions(note);
        }

        $form.trigger('ajax:success', [note]);
      }).catch(function () {
        // Submission failed, remove placeholder note and show Flash error message
        $notesContainer.find('#' + noteUniqueId).remove();

        var blurEvent = new CustomEvent('blur.imageDiff', {
          detail: e
        });

        var closestDiffFile = $form.closest('.diff-file');

        if (closestDiffFile.length) {
          closestDiffFile[0].dispatchEvent(blurEvent);
        }

        if (hasQuickActions) {
          $notesContainer.find('#' + systemNoteUniqueId).remove();
        }

        // Show form again on UI on failure
        if (isDiscussionForm && $notesContainer.length) {
          var replyButton = $notesContainer.parent().find('.js-discussion-reply-button');
          _this3.replyToDiscussionNote(replyButton[0]);
          $form = $notesContainer.parent().find('form');
        }

        $form.find('.js-note-text').val(formContentOriginal);
        _this3.reenableTargetFormSubmitButton(e);
        _this3.addNoteError($form);
      });

      return $closeBtn.text($closeBtn.data('originalText'));
    }

    /**
     * This method does following tasks step-by-step whenever an existing comment
     * is updated by user (both main thread comments as well as discussion comments).
     *
     * 1) Get Form metadata
     * 2) Update note element with new content
     * 3) Perform network request to submit the updated note using `axios.post`
     *    a) If request is successfully completed
     *        1. Show submitted Note element
     *    b) If request failed
     *        1. Revert Note element to original content
     *        2. Show error Flash message about failure
     */

  }, {
    key: 'updateComment',
    value: function updateComment(e) {
      var _this4 = this;

      e.preventDefault();

      // Get Form metadata
      var $submitBtn = jquery_default()(e.target);
      var $form = $submitBtn.parents('form');
      var $closeBtn = $form.find('.js-note-target-close');
      var $editingNote = $form.parents('.note.is-editing');
      var $noteBody = $editingNote.find('.js-task-list-container');
      var $noteBodyText = $noteBody.find('.note-text');

      var _getFormData2 = this.getFormData($form),
          formData = _getFormData2.formData,
          formContent = _getFormData2.formContent,
          formAction = _getFormData2.formAction;

      var $diffFile = $form.closest('.diff-file');
      var $notesContainer = $form.closest('.notes');

      // Cache original comment content
      var cachedNoteBodyText = $noteBodyText.html();

      // Show updated comment content temporarily
      $noteBodyText.html(formContent);
      $editingNote.removeClass('is-editing fade-in-full').addClass('being-posted fade-in-half');
      $editingNote.find('.note-headline-meta a').html('<i class="fa fa-spinner fa-spin" aria-label="评论已经更新" aria-hidden="true"></i>');

      /* eslint-disable promise/catch-or-return */
      // Make request to update comment on server
      axios_utils["a" /* default */].post(formAction + '?html=true', formData).then(function (_ref5) {
        var data = _ref5.data;

        // Submission successful! render final note element
        _this4.updateNote(data, $editingNote);
      }).catch(function () {
        // Submission failed, revert back to original note
        $noteBodyText.html(underscore_default.a.escape(cachedNoteBodyText));
        $editingNote.removeClass('being-posted fade-in');
        $editingNote.find('.fa.fa-spinner').remove();

        // Show Flash message about failure
        _this4.updateNoteError();
      });

      return $closeBtn.text($closeBtn.data('originalText'));
    }
  }], [{
    key: 'initCommentTypeToggle',
    value: function initCommentTypeToggle(form) {
      var dropdownTrigger = form.querySelector('.js-comment-type-dropdown .dropdown-toggle');
      var dropdownList = form.querySelector('.js-comment-type-dropdown .dropdown-menu');
      var noteTypeInput = form.querySelector('#note_type');
      var submitButton = form.querySelector('.js-comment-type-dropdown .js-comment-submit-button');
      var closeButton = form.querySelector('.js-note-target-close');
      var reopenButton = form.querySelector('.js-note-target-reopen');

      var commentTypeToggle = new comment_type_toggle({
        dropdownTrigger: dropdownTrigger,
        dropdownList: dropdownList,
        noteTypeInput: noteTypeInput,
        submitButton: submitButton,
        closeButton: closeButton,
        reopenButton: reopenButton
      });

      commentTypeToggle.initDroplab();
    }
  }, {
    key: 'updateNoteTargetSelector',
    value: function updateNoteTargetSelector($note) {
      var hash = Object(url_utility["a" /* getLocationHash */])();
      // Needs to be an explicit true/false for the jQuery `toggleClass(force)`
      var addTargetClass = Boolean(hash && $note.filter('#' + hash).length > 0);
      $note.toggleClass('target', addTargetClass);
    }
  }, {
    key: 'isNewNote',
    value: function isNewNote(noteEntity, noteIds) {
      return jquery_default.a.inArray(noteEntity.id, noteIds) === -1;
    }

    /**
     * Check if $note already contains the `noteEntity` content
     */

  }, {
    key: 'isUpdatedNote',
    value: function isUpdatedNote(noteEntity, $note) {
      // There can be CRLF vs LF mismatches if we don't sanitize and compare the same way
      var sanitizedNoteEntityText = normalizeNewlines(noteEntity.note.trim());
      var currentNoteText = normalizeNewlines($note.find('.original-note-content').first().text().trim());
      return sanitizedNoteEntityText !== currentNoteText;
    }
  }, {
    key: 'checkMergeRequestStatus',
    value: function checkMergeRequestStatus() {
      if (Object(common_utils["h" /* getPagePath */])(1) === 'merge_requests' && gl.mrWidget) {
        gl.mrWidget.checkStatus();
      }
    }
  }, {
    key: 'animateAppendNote',
    value: function animateAppendNote(noteHtml, $notesList) {
      var $note = jquery_default()(noteHtml);

      $note.addClass('fade-in-full').renderGFM();
      $notesList.append($note);
      return $note;
    }
  }, {
    key: 'animateUpdateNote',
    value: function animateUpdateNote(noteHtml, $note) {
      var $updatedNote = jquery_default()(noteHtml);

      $updatedNote.addClass('fade-in').renderGFM();
      $note.replaceWith($updatedNote);
      return $updatedNote;
    }
  }, {
    key: 'refreshVueNotes',
    value: function refreshVueNotes() {
      document.dispatchEvent(new CustomEvent('refreshVueNotes'));
    }
  }]);

  return Notes;
}();

/* harmony default export */ var notes_0 = __webpack_exports__["a"] = (notes_Notes);


window.Notes = notes_Notes;

/***/ }),

/***/ "./pages/projects/commit/show/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__diff__ = __webpack_require__("./diff.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__zen_mode__ = __webpack_require__("./zen_mode.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shortcuts_navigation__ = __webpack_require__("./shortcuts_navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mini_pipeline_graph_dropdown__ = __webpack_require__("./mini_pipeline_graph_dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__init_notes__ = __webpack_require__("./init_notes.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__init_changes_dropdown__ = __webpack_require__("./init_changes_dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__diff_notes_diff_notes_bundle__ = __webpack_require__("./diff_notes/diff_notes_bundle.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commit_merge_requests__ = __webpack_require__("./commit_merge_requests.js");
/* eslint-disable no-new */









document.addEventListener('DOMContentLoaded', function () {
  new __WEBPACK_IMPORTED_MODULE_0__diff__["a" /* default */]();
  new __WEBPACK_IMPORTED_MODULE_1__zen_mode__["a" /* default */]();
  new __WEBPACK_IMPORTED_MODULE_2__shortcuts_navigation__["a" /* default */]();
  new __WEBPACK_IMPORTED_MODULE_3__mini_pipeline_graph_dropdown__["a" /* default */]({
    container: '.js-commit-pipeline-graph'
  }).bindEvents();
  Object(__WEBPACK_IMPORTED_MODULE_4__init_notes__["a" /* default */])();
  var stickyBarPaddingTop = 16;
  Object(__WEBPACK_IMPORTED_MODULE_5__init_changes_dropdown__["a" /* default */])(document.querySelector('.navbar-gitlab').offsetHeight - stickyBarPaddingTop);
  $('.commit-info.branches').load(document.querySelector('.js-commit-box').dataset.commitPath);
  Object(__WEBPACK_IMPORTED_MODULE_7__commit_merge_requests__["a" /* fetchCommitMergeRequests */])();
  Object(__WEBPACK_IMPORTED_MODULE_6__diff_notes_diff_notes_bundle__["a" /* default */])();
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./shortcuts_navigation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap__ = __webpack_require__("../../../node_modules/mousetrap/mousetrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__ = __webpack_require__("./shortcuts_dashboard_navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shortcuts__ = __webpack_require__("./shortcuts.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ShortcutsNavigation = function (_Shortcuts) {
  _inherits(ShortcutsNavigation, _Shortcuts);

  function ShortcutsNavigation() {
    _classCallCheck(this, ShortcutsNavigation);

    var _this = _possibleConstructorReturn(this, (ShortcutsNavigation.__proto__ || Object.getPrototypeOf(ShortcutsNavigation)).call(this));

    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g p', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-project');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g e', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-project-activity');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g f', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-tree');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g c', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-commits');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g j', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-builds');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g n', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-network');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g d', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-repository-charts');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g i', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-issues');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g b', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-issue-boards');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g m', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-merge_requests');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g t', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-todos');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g w', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-wiki');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g s', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-snippets');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('i', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-new-issue');
    });

    _this.enabledHelp.push('.hidden-shortcut.project');
    return _this;
  }

  return ShortcutsNavigation;
}(__WEBPACK_IMPORTED_MODULE_2__shortcuts__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ShortcutsNavigation);

/***/ }),

/***/ "./single_file_diff.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__files_comment_button__ = __webpack_require__("./files_comment_button.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__image_diff_helpers_index__ = __webpack_require__("./image_diff/helpers/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__syntax_highlight__ = __webpack_require__("./syntax_highlight.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, prefer-arrow-callback, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, one-var, one-var-declaration-per-line, consistent-return, no-param-reassign, max-len */








var WRAPPER = '<div class="diff-content"></div>';
var LOADING_HTML = '<i class="fa fa-spinner fa-spin"></i>';
var ERROR_HTML = '<div class="nothing-here-block"><i class="fa fa-warning"></i> Could not load diff</div>';
var COLLAPSED_HTML = '<div class="nothing-here-block diff-collapsed">This diff is collapsed. <a class="click-to-expand">Click to expand it.</a></div>';

var SingleFileDiff = function () {
  function SingleFileDiff(file) {
    _classCallCheck(this, SingleFileDiff);

    this.file = file;
    this.toggleDiff = this.toggleDiff.bind(this);
    this.content = $('.diff-content', this.file);
    this.$toggleIcon = $('.diff-toggle-caret', this.file);
    this.diffForPath = this.content.find('[data-diff-for-path]').data('diffForPath');
    this.isOpen = !this.diffForPath;
    if (this.diffForPath) {
      this.collapsedContent = this.content;
      this.loadingContent = $(WRAPPER).addClass('loading').html(LOADING_HTML).hide();
      this.content = null;
      this.collapsedContent.after(this.loadingContent);
      this.$toggleIcon.addClass('fa-caret-right');
    } else {
      this.collapsedContent = $(WRAPPER).html(COLLAPSED_HTML).hide();
      this.content.after(this.collapsedContent);
      this.$toggleIcon.addClass('fa-caret-down');
    }

    $('.js-file-title, .click-to-expand', this.file).on('click', function (e) {
      this.toggleDiff($(e.target));
    }.bind(this));
  }

  _createClass(SingleFileDiff, [{
    key: 'toggleDiff',
    value: function toggleDiff($target, cb) {
      if (!$target.hasClass('js-file-title') && !$target.hasClass('click-to-expand') && !$target.hasClass('diff-toggle-caret')) return;
      this.isOpen = !this.isOpen;
      if (!this.isOpen && !this.hasError) {
        this.content.hide();
        this.$toggleIcon.addClass('fa-caret-right').removeClass('fa-caret-down');
        this.collapsedContent.show();
        if (typeof gl.diffNotesCompileComponents !== 'undefined') {
          gl.diffNotesCompileComponents();
        }
      } else if (this.content) {
        this.collapsedContent.hide();
        this.content.show();
        this.$toggleIcon.addClass('fa-caret-down').removeClass('fa-caret-right');
        if (typeof gl.diffNotesCompileComponents !== 'undefined') {
          gl.diffNotesCompileComponents();
        }
      } else {
        this.$toggleIcon.addClass('fa-caret-down').removeClass('fa-caret-right');
        return this.getContentHTML(cb);
      }
    }
  }, {
    key: 'getContentHTML',
    value: function getContentHTML(cb) {
      var _this = this;

      this.collapsedContent.hide();
      this.loadingContent.show();

      __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(this.diffForPath).then(function (_ref) {
        var data = _ref.data;

        _this.loadingContent.hide();
        if (data.html) {
          _this.content = $(data.html);
          Object(__WEBPACK_IMPORTED_MODULE_5__syntax_highlight__["a" /* default */])(_this.content);
        } else {
          _this.hasError = true;
          _this.content = $(ERROR_HTML);
        }
        _this.collapsedContent.after(_this.content);

        if (typeof gl.diffNotesCompileComponents !== 'undefined') {
          gl.diffNotesCompileComponents();
        }

        var $file = $(_this.file);
        __WEBPACK_IMPORTED_MODULE_3__files_comment_button__["a" /* default */].init($file);

        var canCreateNote = $file.closest('.files').is('[data-can-create-note]');
        __WEBPACK_IMPORTED_MODULE_4__image_diff_helpers_index__["a" /* default */].initImageDiff($file[0], canCreateNote);

        if (cb) cb();
      }).catch(function () {
        Object(__WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* __ */])('An error occurred while retrieving diff'));
      });
    }
  }]);

  return SingleFileDiff;
}();

/* harmony default export */ __webpack_exports__["a"] = (SingleFileDiff);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./task_list.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_deckar01_task_list__ = __webpack_require__("../../../node_modules/deckar01-task_list/dist/task_list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_deckar01_task_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_deckar01_task_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var TaskList = function () {
  function TaskList() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, TaskList);

    this.selector = options.selector;
    this.dataType = options.dataType;
    this.fieldName = options.fieldName;
    this.onSuccess = options.onSuccess || function () {};
    this.onError = function showFlash(e) {
      var errorMessages = '';

      if (e.response.data && _typeof(e.response.data) === 'object') {
        errorMessages = e.response.data.errors.join(' ');
      }

      return new __WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */](errorMessages || 'Update failed', 'alert');
    };

    this.init();
  }

  _createClass(TaskList, [{
    key: 'init',
    value: function init() {
      // Prevent duplicate event bindings
      this.disable();
      $(this.selector + ' .js-task-list-container').taskList('enable');
      $(document).on('tasklist:changed', this.selector + ' .js-task-list-container', this.update.bind(this));
    }
  }, {
    key: 'disable',
    value: function disable() {
      $(this.selector + ' .js-task-list-container').taskList('disable');
      $(document).off('tasklist:changed', this.selector + ' .js-task-list-container');
    }
  }, {
    key: 'update',
    value: function update(e) {
      var _this = this;

      var $target = $(e.target);
      var patchData = {};
      patchData[this.dataType] = _defineProperty({}, this.fieldName, $target.val());

      return __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].patch($target.data('updateUrl') || $('form.js-issuable-update').attr('action'), patchData).then(function (_ref) {
        var data = _ref.data;
        return _this.onSuccess(data);
      }).catch(function (err) {
        return _this.onError(err);
      });
    }
  }]);

  return TaskList;
}();

/* harmony default export */ __webpack_exports__["a"] = (TaskList);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./vue_shared/components/user_avatar/user_avatar_image.vue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../images/no_avatar.png
var no_avatar = __webpack_require__("../images/no_avatar.png");
var no_avatar_default = /*#__PURE__*/__webpack_require__.n(no_avatar);

// EXTERNAL MODULE: ./lazy_loader.js
var lazy_loader = __webpack_require__("./lazy_loader.js");

// EXTERNAL MODULE: ./vue_shared/directives/tooltip.js
var tooltip = __webpack_require__("./vue_shared/directives/tooltip.js");

// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/babel-loader/lib!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=script&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue


/* This is a re-usable vue component for rendering a user avatar that
  does not need to link to the user's profile. The image and an optional
  tooltip can be configured by props passed to this component.

  Sample configuration:

  <user-avatar-image
    :lazy="true"
    :img-src="userAvatarSrc"
    :img-alt="tooltipText"
    :tooltip-text="tooltipText"
    tooltip-placement="top"
  />

*/





/* harmony default export */ var user_avatar_image = ({
  name: 'UserAvatarImage',
  directives: {
    tooltip: tooltip["a" /* default */]
  },
  props: {
    lazy: {
      type: Boolean,
      required: false,
      default: false
    },
    imgSrc: {
      type: String,
      required: false,
      default: no_avatar_default.a
    },
    cssClasses: {
      type: String,
      required: false,
      default: ''
    },
    imgAlt: {
      type: String,
      required: false,
      default: 'user avatar'
    },
    size: {
      type: Number,
      required: false,
      default: 20
    },
    tooltipText: {
      type: String,
      required: false,
      default: ''
    },
    tooltipPlacement: {
      type: String,
      required: false,
      default: 'top'
    }
  },
  computed: {
    // API response sends null when gravatar is disabled and
    // we provide an empty string when we use it inside user avatar link.
    // In both cases we should render the defaultAvatarUrl
    sanitizedSource: function sanitizedSource() {
      return this.imgSrc === '' || this.imgSrc === null ? no_avatar_default.a : this.imgSrc;
    },
    resultantSrcAttribute: function resultantSrcAttribute() {
      return this.lazy ? lazy_loader["b" /* placeholderImage */] : this.sanitizedSource;
    },
    tooltipContainer: function tooltipContainer() {
      return this.tooltipText ? 'body' : null;
    },
    avatarSizeClass: function avatarSizeClass() {
      return 's' + this.size;
    }
  }
});
// CONCATENATED MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75ce3616","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/user_avatar/user_avatar_image.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"avatar",class:( _obj = {
    lazy: _vm.lazy
  }, _obj[_vm.avatarSizeClass] = true, _obj[_vm.cssClasses] = true, _obj ),attrs:{"src":_vm.resultantSrcAttribute,"width":_vm.size,"height":_vm.size,"alt":_vm.imgAlt,"data-src":_vm.sanitizedSource,"data-container":_vm.tooltipContainer,"data-placement":_vm.tooltipPlacement,"title":_vm.tooltipText}})
var _obj;}
var staticRenderFns = []

// EXTERNAL MODULE: /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__("../../../node_modules/vue-loader/lib/runtime/component-normalizer.js");

// CONCATENATED MODULE: ./vue_shared/components/user_avatar/user_avatar_image.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  user_avatar_image,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var user_avatar_user_avatar_image = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "./vue_shared/directives/tooltip.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el) {
    $(el).tooltip();
  },
  componentUpdated: function componentUpdated(el) {
    $(el).tooltip('fixTitle');
  },
  unbind: function unbind(el) {
    $(el).tooltip('destroy');
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./zen_mode.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_jquery_scrollTo__ = __webpack_require__("../../../vendor/assets/javascripts/jquery.scrollTo.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_jquery_scrollTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vendor_jquery_scrollTo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dropzone__ = __webpack_require__("../../../node_modules/dropzone/dist/dropzone.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mousetrap__ = __webpack_require__("../../../node_modules/mousetrap/mousetrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mousetrap_plugins_pause_mousetrap_pause__ = __webpack_require__("../../../node_modules/mousetrap/plugins/pause/mousetrap-pause.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mousetrap_plugins_pause_mousetrap_pause___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mousetrap_plugins_pause_mousetrap_pause__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, no-unused-vars, consistent-return, camelcase, comma-dangle, max-len, class-methods-use-this */

// Zen Mode (full screen) textarea
//
/*= provides zen_mode:enter */
/*= provides zen_mode:leave */






__WEBPACK_IMPORTED_MODULE_1_dropzone___default.a.autoDiscover = false;

//
// ### Events
//
// `zen_mode:enter`
//
// Fired when the "Edit in fullscreen" link is clicked.
//
// **Synchronicity** Sync
// **Bubbles** Yes
// **Cancelable** No
// **Target** a.js-zen-enter
//
// `zen_mode:leave`
//
// Fired when the "Leave Fullscreen" link is clicked.
//
// **Synchronicity** Sync
// **Bubbles** Yes
// **Cancelable** No
// **Target** a.js-zen-leave
//

var ZenMode = function () {
  function ZenMode() {
    _classCallCheck(this, ZenMode);

    this.active_backdrop = null;
    this.active_textarea = null;
    $(document).on('click', '.js-zen-enter', function (e) {
      e.preventDefault();
      return $(e.currentTarget).trigger('zen_mode:enter');
    });
    $(document).on('click', '.js-zen-leave', function (e) {
      e.preventDefault();
      return $(e.currentTarget).trigger('zen_mode:leave');
    });
    $(document).on('zen_mode:enter', function (_this) {
      return function (e) {
        return _this.enter($(e.target).closest('.md-area').find('.zen-backdrop'));
      };
    }(this));
    $(document).on('zen_mode:leave', function (_this) {
      return function (e) {
        return _this.exit();
      };
    }(this));
    $(document).on('keydown', function (e) {
      // Esc
      if (e.keyCode === 27) {
        e.preventDefault();
        return $(document).trigger('zen_mode:leave');
      }
    });
  }

  _createClass(ZenMode, [{
    key: 'enter',
    value: function enter(backdrop) {
      __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.pause();
      this.active_backdrop = $(backdrop);
      this.active_backdrop.addClass('fullscreen');
      this.active_textarea = this.active_backdrop.find('textarea');
      // Prevent a user-resized textarea from persisting to fullscreen
      this.active_textarea.removeAttr('style');
      this.active_textarea.focus();
    }
  }, {
    key: 'exit',
    value: function exit() {
      if (this.active_textarea) {
        __WEBPACK_IMPORTED_MODULE_2_mousetrap___default.a.unpause();
        this.active_textarea.closest('.zen-backdrop').removeClass('fullscreen');
        this.scrollTo(this.active_textarea);
        this.active_textarea = null;
        this.active_backdrop = null;

        var $dropzone = $('.div-dropzone');
        if ($dropzone && !$dropzone.hasClass('js-invalid-dropzone')) {
          __WEBPACK_IMPORTED_MODULE_1_dropzone___default.a.forElement('.div-dropzone').enable();
        }
      }
    }
  }, {
    key: 'scrollTo',
    value: function scrollTo(zen_area) {
      return $.scrollTo(zen_area, 0, {
        offset: -150
      });
    }
  }]);

  return ZenMode;
}();

/* harmony default export */ __webpack_exports__["a"] = (ZenMode);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ })

},["./pages/projects/commit/show/index.js"]);


// WEBPACK FOOTER //
// pages.projects.commit.show.ac2368557a00ffacb13a.bundle.js